export const hmsDrone = 
{
    "0x11000002": "Aircraft power distribution board 1 overheated. Return to home or land promptly",
    "0x11000003": "Aircraft power distribution board 2 overheated. Return to home or land promptly",
    "0x11000020": "Gimbal %index payload voltage too high",
    "0x11000021": "Gimbal %index payload voltage too low",
    "0x11000022": "Gimbal %index battery module overheated",
    "0x11000023": "Gimbal %index battery module temperature too low",
    "0x11000024": "Total payload power too high",
    "0x11000025": "Gimbal %index payload transmission error",
    "0x11000029": "PSDK voltage too high",
    "0x1100002A": "PSDK voltage too low",
    "0x1100002B": "PSDK battery module overheated",
    "0x1100002C": "PSDK battery module temperature too low",
    "0x1100002D": "PSDK device rated power exceeded. Restarting...",
    "0x1100002E": "PSDK device rated power exceeded. Failed to restart",
    "0x11000034": "Landing gear motor power supply error. Restart aircraft",
    "0x11000035": "Radar power supply error. Restarting radar recommended",
    "0x11000036": "4G module power supply error. Remove and insert module again",
    "0x11000037": "Gimbal power supply error. Detach and remount gimbal",
    "0x11000038": "Left battery connector overheated. Return to home or land promptly",
    "0x11000039": "Right battery connector overheated. Return to home or land promptly",
    "0x1100003A": "Left battery not properly installed. Remove and reinstall battery",
    "0x1100003B": "Right battery not properly installed. Remove and reinstall battery",
    "0x1100003C": "Gimbal not properly installed. Detach and remount gimbal",
    "0x1100003D": "Aircraft center board overheated. Return to home or land promptly",
    "0x1100003E": "Radar disconnected. Fly with caution and return to home or land promptly",
    "0x1100003F": "Downward infrared sensing system connection error. Restart aircraft",
    "0x11000040": "Landing gear motor communication error. Restart aircraft",
    "0x11000041": "Landing gear motor stalled. Make sure motor is clear of obstacles and restart aircraft",
    "0x11000042": "Large current difference between batteries. Maintain smooth flight and land promptly",
    "0x11000043": "Motor overheated. Do not transform aircraft frequently",
    "0x11000044": "Motor overheated. Transforming aircraft stopped. Wait until motor cools down",
    "0x11000045": "Temperature too low. Landing gear stuck",
    "0x11000046": "Aircraft screw rod reaching maximum life span. To ensure flight safety, contact DJI Support and send aircraft back to DJI for maintenance",
    "0x11000047": "Aircraft screw rod exceeded maximum life span. To ensure flight safety, contact DJI Support immediately and send aircraft back to DJI for maintenance. You are responsible for the maintenance cost for the flight accident caused by continued use of the aircraft",
    "0x11000048": "Landing gear error. Obstacle avoidance performance degraded. Fly with caution. Pay attention to lens when aircraft is landing. Contact DJI Support",
    "0x11020030": "%battery_index battery cover temperature error. Switched to single-battery flight. Return to home or land promptly",
    "0x11020031": "%battery_index battery connector temperature error. Switched to single-battery flight. Return to home or land promptly",
    "0x11020032": "%battery_index battery temperature error. Switched to single-battery flight. Return to home or land promptly",
    "0x11020033": "%battery_index battery error. Switched to single-battery flight. Return to home or land promptly",
    "0x110B0001": "%battery_index Battery overcurrent when discharging. Maintain smooth flight and check if aircraft is overloaded",
    "0x110B0002": "%battery_index Battery overheated. Return to home promptly and wait until battery cools down",
    "0x110B0003": "%battery_index Battery temperature too low. Warm up battery to 5\u00b0C or higher",
    "0x110B0004": "%battery_index Battery short-circuited during discharge. Replace battery",
    "0x110B0005": "Battery %index cell voltage low. Replace battery",
    "0x110B0006": "%battery_index Battery cell damaged. Stop using battery and contact DJI Support",
    "0x110B0007": "%battery_index Battery auto-check failed. Stop using battery and contact DJI Support",
    "0x110B0008": "%battery_index Battery auto-check failed. Stop using battery and contact DJI Support",
    "0x110B0009": "%battery_index Battery auto-check failed. Stop using battery and contact DJI Support",
    "0x110B000A": "%battery_index Battery auto-check failed. Stop using battery and contact DJI Support",
    "0x110B000B": "%battery_index Battery damaged. Stop using battery and contact DJI Support",
    "0x110B000C": "%battery_index Battery maintenance required",
    "0x110B000D": "%battery_index Battery damaged. Stop using battery and contact DJI Support",
    "0x110B000E": "Battery %index self-discharged\u00a0during storage",
    "0x110B000F": "%battery_index Battery capacity significantly reduced. Continue using battery may cause safety risks",
    "0x110B0010": "Safety requirements not met. Dispose of %battery_index Battery properly",
    "0x110B0011": "%battery_index Battery data communication error. Reinstall battery. Replace battery if issue persists",
    "0x110B0012": "%battery_index Battery maintenance required",
    "0x110B0013": "Battery not detected in %battery_index Battery slot. Insert or replace battery",
    "0x110B0013_in_the_sky": "Battery not detected in %battery_index Battery slot. Return to home or land promptly",
    "0x110B0014": "%battery_index Battery self-heating",
    "0x110B0015": "%battery_index Battery maintenance required to ensure flight safety",
    "0x110B0016": "%battery_index Battery maintenance required to ensure flight safety",
    "0x110B0017": "%battery_index Battery maintenance required to ensure flight safety",
    "0x110B0018": "%battery_index Battery maintenance required to ensure flight safety",
    "0x110B0019": "%battery_index Battery maintenance required to ensure flight safety",
    "0x110B001A": "%battery_index Battery maintenance required to ensure flight safety",
    "0x110B001B": "%battery_index Battery maintenance required to ensure flight safety",
    "0x110B001C": "Batteries do not match. Replace with matching batteries",
    "0x110B001D": "%battery_index Battery discharge error. Return to home or land promptly",
    "0x110B001E": "%battery_index Battery connection error. Return to home or land promptly",
    "0x110B007": "Battery %d% auto check failed. Replace battery and contact DJI Support",
    "0x110B0403": "Incompatible battery firmware versions. Update firmware",
    "0x110b001e": "%battery_index Battery connection error. Return to home or land promptly",
    "0x12000000": "Battery Station not activated",
    "0x12000001": "Battery Station auto check error",
    "0x12000002": "Battery Station expansion card communication error",
    "0x12010000": "Power Supply Module Not Recognized",
    "0x12010001": "Battery module input voltage too high",
    "0x12010002": "Battery module input voltage too low",
    "0x12010003": "Battery module output voltage error",
    "0x12010004": "Battery module output current error",
    "0x12010005": "Battery module short-circuited",
    "0x12010006": "Battery module communication error",
    "0x12010007": "Battery module fan malfunctioned",
    "0x12010008": "Battery module temperature too high",
    "0x12020000": "Battery port %index battery communication error",
    "0x12020001": "Battery port %index battery temperature too low",
    "0x12020002": "Battery port %index battery overheated",
    "0x12020003": "Battery port %index battery cell voltage too high",
    "0x12020004": "Battery port %index battery system error",
    "0x12020005": "Battery port %index battery overcurrent during charging",
    "0x12020006": "Battery port %index battery voltage too high",
    "0x12020007": "Battery port %index battery voltage too high during charging",
    "0x12020008": "Battery port %index battery voltage too low during charging",
    "0x12020009": "Battery port %index battery permanently damaged",
    "0x1202000A": "Battery port %index battery short-circuited",
    "0x1202000B": "Battery port %index battery charging taking too long",
    "0x1202000C": "No current detected for battery port %index battery during charging",
    "0x1202000D": "Battery port %index battery type not recognized",
    "0x12030000": "Battery Station motherboard overheated",
    "0x12030001": "Battery Station motherboard voltage too high",
    "0x12030002": "Battery Station motherboard voltage too low",
    "0x12030003": "Battery Station port %index error",
    "0x12030004": "AC Input Voltage Drop Too Large",
    "0x12030005": "Oil Maintenance Tips",
    "0x12030006": "Charging Device Controller Board Output Voltage Error",
    "0x12030007": "Controller Board of Charging Device Input Voltage Error",
    "0x12120000": "Battery port %index remote controller battery communication error",
    "0x12120001": "Battery port %index remote controller battery temperature error",
    "0x12120002": "Battery port %index remote controller battery charging error",
    "0x14010031": "Payload infusion data error. Restart payload",
    "0x14010032": "Unable to converge payload infusion data",
    "0x14010033": "Payload system time error. Restart aircraft",
    "0x14010034": "Payload tachometer data invalid. Restart payload",
    "0x14010035": "Payload tachometer data not updated. Restart payload",
    "0x14010036": "No payload tachometer data. Restart payload",
    "0x14010037": "Payload tachometer data exceeds limit. Restart payload",
    "0x14010038": "Payload tachometer data error. Restart payload",
    "0x14010039": "Payload accelerometer data invalid. Restart payload",
    "0x1401003A": "Payload accelerometer data not updated. Restart payload",
    "0x1401003B": "No payload accelerometer data. Restart payload",
    "0x1401003C": "Payload accelerometer data exceeds limit. Restart payload",
    "0x1401003D": "Payload accelerometer data error. Restart payload",
    "0x1401003E": "Payload RTK data calculation error. Restart aircraft",
    "0x1401003F": "Payload direction data error. Check satellite signal",
    "0x14010040": "Payload RTK data error. Restart aircraft",
    "0x14010041": "Payload RTK time error. Restart aircraft",
    "0x14010042": "Payload RTK data invalid. Restart aircraft",
    "0x14010042_in_the_sky": "Payload RTK data invalid. Make sure satellite signal searching is normal and wait until RTK is fixed",
    "0x14010043": "Payload IMU warming up. Wait until IMU finished warming up to continue",
    "0x14010044": "Payload IMU temperature control processor error. Restart payload",
    "0x14010045": "Payload IMU overheated. Restart payload",
    "0x14010046": "Payload IMU temperature too low. Restart payload",
    "0x14010047": "Payload processor overheated. Return to home or land promptly. Remove payload and wait for it to cool down before use",
    "0x14010047_in_the_sky": "Payload processor overheated. Return to home or land promptly. Remove payload and wait for it to cool down before use",
    "0x14010048": "Payload fan error. Check whether the fan is stalled",
    "0x14010048_in_the_sky": "Payload fan error. Return to home or land and check whether the fan is stalled",
    "0x14010049": "Payload PPS Data Error",
    "0x1401004A": "Payload UTC Time Error",
    "0x14020000": "ASIC\u82af\u7247\u6e29\u5ea6\u5f02\u5e38",
    "0x14020001": "\u4e3b\u63a7\u82af\u7247\u6e29\u5ea6\u5f02\u5e38",
    "0x14020002": "\u770b\u95e8\u72d7\u8d85\u65f6",
    "0x14020003": "ASIC\u82af\u7247\u9519\u8bef",
    "0x14020004": "\u6808\u6ea2\u51fa",
    "0x14020005": "MIPI\u6545\u969c",
    "0x14020007": "%lidar_index blurry. Clean device",
    "0x14020008": "",
    "0x14020031": "Payload infusion data error. Restart payload",
    "0x14020032": "Unable to converge payload infusion data",
    "0x14020033": "Payload system time error. Restart aircraft",
    "0x14020034": "Payload tachometer data invalid. Restart payload",
    "0x14020035": "Payload tachometer data not updated. Restart payload",
    "0x14020036": "No payload tachometer data. Restart payload",
    "0x14020037": "Payload tachometer data exceeds limit. Restart payload",
    "0x14020038": "Payload tachometer data error. Restart payload",
    "0x14020039": "Payload accelerometer data invalid. Restart payload",
    "0x1402003A": "Payload accelerometer data not updated. Restart payload",
    "0x1402003B": "No payload accelerometer data. Restart payload",
    "0x1402003C": "Payload accelerometer data exceeds limit. Restart payload",
    "0x1402003D": "Payload accelerometer data error. Restart payload",
    "0x1402003E": "Payload RTK data calculation error. Restart aircraft",
    "0x14020040": "Payload RTK data error. Restart aircraft",
    "0x14020041": "Payload RTK time error. Restart aircraft",
    "0x14020042": "Payload RTK data invalid. Restart aircraft",
    "0x14020042_in_the_sky": "Payload RTK data invalid. Make sure satellite signal searching is normal and wait until RTK is fixed",
    "0x140200FF": "%lidar_index module error. Contact DJI Support",
    "0x14030000": "\u626b\u63cf\u6a21\u5757\u6e29\u5ea6\u5f02\u5e38",
    "0x14030001": "\u626b\u63cf\u6a21\u5757\u7535\u6d41\u5f02\u5e38",
    "0x14030002": "Rotation speed error of LiDAR scanning module. Restart aircraft",
    "0x14030003": "Auto Check error of LiDAR scanning module. Restart aircraft",
    "0x1403000B": "Calibrating LiDAR scanning module. Do not move aircraft",
    "0x1403000C": "Recovering %lidar_index scanning module. Restart if device not recovered for a long time",
    "0x1403001D": "LiDAR requires extrinsic parameter calibration",
    "0x14040000": "\u63a5\u6536\u5668\u9ad8\u538b\u5f02\u5e38",
    "0x14040001": "\u63a5\u6536\u5668\u6e29\u5ea6\u5f02\u5e38",
    "0x14040002": "\u6fc0\u5149\u5668\u6e29\u5ea6\u5f02\u5e38",
    "0x14040003": "",
    "0x14040004": "%lidar_index temperature high. Pay attention to operating environment or move to cool place",
    "0x14050000": "PPS\u540c\u6b65\u5f02\u5e38",
    "0x14050001": "",
    "0x14050002": "PPS\u540c\u6b65\u5f02\u5e38",
    "0x14050003": "\u65f6\u95f4\u540c\u6b65\u7cbe\u5ea6\u4f4e",
    "0x14050005": "",
    "0x14050006": "",
    "0x14060000": "NIR Illumination power error and disabled. Re-enable this function or contact DJI Support",
    "0x14810040": "LiDAR temperature too high/low",
    "0x14810080": "LiDAR voltage too high/low",
    "0x148100c0": "LiDAR motor error",
    "0x14810100": "LiDAR lifecycle warning",
    "0x14810140": "LiDAR system error",
    "0x15000020": "Millimeter-wave radar temperature too low. Check if ambient temperature is too low",
    "0x15000021": "Millimeter-wave radar overheated. Check if ambient temperature is too high",
    "0x15010020": "Millimeter-wave radar internal power supply error. Restart radar",
    "0x15010021": "Millimeter-wave radar internal power supply error. Restart radar",
    "0x15010022": "Millimeter-wave radar internal power supply error. Restart radar",
    "0x15010023": "Millimeter-wave radar internal power supply error. Restart radar",
    "0x15020020": "Millimeter-wave radar motor error. Check whether radar is stalled",
    "0x15020021": "Millimeter-wave radar motor error. Check whether radar is stalled",
    "0x15020022": "Millimeter-wave radar motor error. Check whether radar is stalled",
    "0x15020023": "Millimeter-wave radar sensing error. Check firmware version",
    "0x15030020": "Millimeter-wave radar link unstable. Check if there is strong interference in the surrounding area",
    "0x15030021": "Millimeter-wave radar link unstable. Check if there is strong interference in the surrounding area",
    "0x15030022": "Millimeter-wave radar link unstable. Check if there is strong interference in the surrounding area",
    "0x15030023": "Starting millimeter-wave radar timed out. Check if there is strong interference in the surrounding area",
    "0x15030024": "Millimeter-wave radar communication link unstable. Check if there is strong interference in the surrounding area",
    "0x15030025": "Millimeter-wave radar communication link unstable. Check if there is strong interference in the surrounding area",
    "0x15030026": "Millimeter-wave radar communication link unstable. Check if there is strong interference in the surrounding area",
    "0x15030028": "%index radar cable error. Obstacle avoidance and altitude stabilization unavailable",
    "0x15040020": "Millimeter-wave radar motor error. Check whether radar is stalled",
    "0x15040021": "Millimeter-wave radar motor error. Check whether radar is stalled",
    "0x15060020": "Millimeter-wave radar motor error. Check whether radar is stalled",
    "0x15070020": "Millimeter-wave radar link unstable. Check if there is strong interference in the surrounding area",
    "0x15080020": "Millimeter-wave radar overheated. Check if ambient temperature is too high",
    "0x15080021": "Millimeter-wave radar processor overheated. Obstacle avoidance and altitude stabilization affected",
    "0x15080022": "Millimeter-wave radar processor overheated. Obstacle avoidance and altitude stabilization affected",
    "0x15090020": "Millimeter-wave radar overheated. Check if ambient temperature is too high",
    "0x15090021": "Millimeter-wave radar error. Obstacle sensing unavailable",
    "0x15100020": "Millimeter-wave radar communication link unstable. Check if there is strong interference in the surrounding area",
    "0x15100021": "Millimeter-wave radar link unstable. Check if there is strong interference in the surrounding area",
    "0x15100022": "Millimeter-wave radar link unstable. Check if there is strong interference in the surrounding area",
    "0x15110020": "Millimeter-wave radar motor error. Check whether radar is stalled",
    "0x15130021": "Millimeter-wave radar sensing error. Check firmware version",
    "0x15140020": "Millimeter-wave radar RF clock error. Return to home promptly and check radar",
    "0x15200020": "Millimeter-wave radar temperature error. Altitude stabilization and obstacle sensing unstable",
    "0x15200021": "Millimeter-wave radar temperature error. Altitude stabilization and obstacle sensing unstable",
    "0x15200022": "Millimeter-wave radar temperature error. Altitude stabilization and obstacle sensing unstable",
    "0x15200023": "Millimeter-wave radar temperature error. Altitude stabilization and obstacle sensing unstable",
    "0x15210020": "Millimeter-wave radar power supply error. Altitude stabilization and obstacle sensing unstable. Power off and check if the radar is installed correctly",
    "0x15210021": "Millimeter-wave radar power supply error. Altitude stabilization and obstacle sensing unstable. Power off and check if the radar is installed correctly",
    "0x15210022": "Millimeter-wave radar communication error. Altitude stabilization and obstacle sensing unstable. Power off and check if the radar is installed correctly",
    "0x15210023": "Millimeter-wave radar error. Altitude stabilization and obstacle sensing unstable. Restart aircraft",
    "0x15210024": "Millimeter-wave radar error. Altitude stabilization and obstacle sensing unstable. Restart aircraft",
    "0x15220020": "Backward and downward radar disconnected. Restart aircraft or check and replace radar",
    "0x15300020": "Millimeter-wave radar sensing error. Check firmware version",
    "0x15300021": "Millimeter-wave radar sensing error. Check firmware version",
    "0x15300022": "Millimeter-wave radar sensing error. Check firmware version",
    "0x16000001": "Flight controller overloaded. Unable to take off. Restart aircraft",
    "0x16000001_in_the_sky": "Flight controller overloaded. If the issue persists, land aircraft promptly",
    "0x16000002": "Flight data recording error. Contact your local dealer or DJI Support",
    "0x16000002_in_the_sky": "Flight data record abnorma.If the warning persists, contact your local dealer or DJI Support.",
    "0x1600000B": "Collision may occur. Check aircraft body and propellers after landing",
    "0x16010001": "Sensor system error. Restart aircraft",
    "0x16010001_in_the_sky": "Sensor system error. Return to home or land",
    "0x16010005": "Sensor system initializing. Wait for initialization to complete",
    "0x16010005_in_the_sky": "Sensor system error. Return to home or land",
    "0x16010007": "Sensor system error. Restart aircraft",
    "0x16010007_in_the_sky": "Sensor system error. Return to home or land",
    "0x1601000A": "Sensor system initializing. Wait for initialization to complete",
    "0x1601000A_in_the_sky": "Sensor system error. Return to home or land",
    "0x1601000D": "Sensor system error. Restart aircraft",
    "0x1601000D_in_the_sky": "Sensor system error. Return to home or land",
    "0x16010010": "Sensor system error. Restart aircraft",
    "0x16010010_in_the_sky": "Sensor system error. Return to home or land",
    "0x16010013": "Sensor system error. Restart aircraft",
    "0x16010013_in_the_sky": "Sensor system error. Return to home or land",
    "0x16010016": "Sensor system error. Restart aircraft",
    "0x16010016_in_the_sky": "Sensor system error. Return to home or land",
    "0x16010019": "Sensor system error. Restart aircraft",
    "0x16010019_in_the_sky": "Sensor system error. Return to home or land",
    "0x1601001C": "Sensor system error. Restart aircraft",
    "0x1601001C_in_the_sky": "Sensor system error. Return to home or land",
    "0x1601001F": "Sensor system error. Restart aircraft",
    "0x1601001F_in_the_sky": "Not Applicable. This string has been deleted",
    "0x16010022": "Sensor system error. Restart aircraft",
    "0x16010022_in_the_sky": "Sensor system error. Return to home or land",
    "0x16010025": "Sensor system error. Restart aircraft",
    "0x16010025_in_the_sky": "Sensor system error. Return to home or land",
    "0x16010026": "Unable to take off. Non-DJI RTK module detected",
    "0x16010026_in_the_sky": "Non-DJI RTK module detected",
    "0x16010028": "Sensor system error. Restart aircraft",
    "0x16010028_in_the_sky": "Sensor system error. Return to home or land",
    "0x1601002B": "Sensor system error. Restart aircraft",
    "0x1601002B_in_the_sky": "Sensor system error. Return to home or land",
    "0x1601002F": "Sensor system error. Restart aircraft",
    "0x1601002F_in_the_sky": "Sensor system error. Return to home or land",
    "0x16010032": "Sensor system error. Restart aircraft",
    "0x16010032_in_the_sky": "Sensor system error. Return to home or land",
    "0x16010033": "Vision positioning detection poor. Fly with caution",
    "0x16010034": "GNSS detection poor. Fly with caution",
    "0x16010035": "Positioning quality poor. Fly with caution",
    "0x16010036": "Vision positioning detection poor. Fly with caution",
    "0x16010037": "GNSS detection poor. Fly with caution",
    "0x16010038": "Positioning quality poor. Fly with caution",
    "0x16010039": "No GNSS available. Wait for searching satellite signal. Fly with caution",
    "0x16010041": "Sensor system error. Restart aircraft",
    "0x16010041_in_the_sky": "Sensor system error. Return to home or land",
    "0x16010042": "Severe error in aircraft positioning system. Aircraft will automatically land soon. Fly aircraft to open area promptly",
    "0x16010050": "",
    "0x16020001": "IMU error. Restart aircraft",
    "0x16020001_in_the_sky": "IMU error. Return to home or land",
    "0x16020004": "IMU error. Restart aircraft",
    "0x16020004_in_the_sky": "IMU error. Return to home or land",
    "0x16020007": "IMU error. Restart aircraft",
    "0x16020007_in_the_sky": "IMU error. Return to home or land",
    "0x1602000A": "IMU error. Restart aircraft",
    "0x1602000A_in_the_sky": "IMU error. Return to home or land",
    "0x1602000D": "IMU error. Restart aircraft",
    "0x1602000D_in_the_sky": "IMU error. Return to home or land",
    "0x16020016": "IMU bias too large. Calibrate IMU",
    "0x16020016_in_the_sky": "IMU error. Return to home or land",
    "0x16020027": "IMU error. Restart aircraft",
    "0x16020027_in_the_sky": "IMU error. Return to home or land",
    "0x1602002A": "IMU error. Restart aircraft",
    "0x1602002A_in_the_sky": "IMU error. Return to home or land",
    "0x1602002B": "IMU constant temperature system error. Restart aircraft",
    "0x16020620": "RTH canceled. Control stick pushed down",
    "0x16020621": "RTH canceled. Obstacle detected",
    "0x16020622": "RTH canceled. Strong wind or aircraft approaching GEO Zone",
    "0x16020623": "GNSS error. RTH canceled",
    "0x16030001": "IMU error. Restart aircraft",
    "0x16030001_in_the_sky": "IMU error. Return to home or land",
    "0x16030004": "IMU error. Restart aircraft",
    "0x16030004_in_the_sky": "IMU error. Return to home or land",
    "0x16030007": "IMU error. Restart aircraft",
    "0x16030007_in_the_sky": "IMU error. Return to home or land",
    "0x1603000A": "IMU error. Restart aircraft",
    "0x1603000A_in_the_sky": "IMU error. Return to home or land",
    "0x1603000D": "IMU error. Restart aircraft",
    "0x1603000D_in_the_sky": "IMU error. Return to home or land",
    "0x16030010": "IMU error. Restart aircraft",
    "0x16030010_in_the_sky": "IMU error. Return to home or land",
    "0x16030013": "IMU error. Restart aircraft",
    "0x16030013_in_the_sky": "IMU error. Return to home or land",
    "0x16030016": "IMU bias too large. Calibrate IMU",
    "0x16030016_in_the_sky": "IMU error. Return to home or land",
    "0x1603001C": "IMU error. Calibrate IMU",
    "0x1603001C_in_the_sky": "IMU error. Return to home or land",
    "0x1603001D": "Abnormal aircraft vibration. Return to home or land promptly",
    "0x16040001": "Barometer error. Restart aircraft",
    "0x16040001_in_the_sky": "Barometer error. Return to home or land",
    "0x16040004": "Barometer error. Restart aircraft",
    "0x16040004_in_the_sky": "Barometer error. Return to home or land",
    "0x16040007": "Barometer error. Restart aircraft",
    "0x16040007_in_the_sky": "Barometer error. Return to home or land",
    "0x1604000A": "Barometer error. Restart aircraft",
    "0x1604000A_in_the_sky": "Barometer error. Return to home or land",
    "0x16040010": "Barometer error. Restart aircraft",
    "0x16040010_in_the_sky": "Barometer error. Return to home or land",
    "0x16040013": "Barometer error. Restart aircraft",
    "0x16040013_in_the_sky": "Barometer error. Return to home or land",
    "0x16040016": "Barometer error. Restart aircraft",
    "0x16040016_in_the_sky": "Barometer error. Return to home or land",
    "0x16040019": "Barometer error. Restart aircraft",
    "0x16040019_in_the_sky": "Barometer error. Return to home or land",
    "0x16050001": "GNSS error. Restart aircraft",
    "0x16050001_in_the_sky": "GNSS error. Return to home or land",
    "0x16050004": "GNSS error. Restart aircraft",
    "0x16050004_in_the_sky": "GNSS error. Return to home or land",
    "0x16050019": "GNSS error. Restart aircraft",
    "0x16050019_in_the_sky": "GNSS error. Return to home or land",
    "0x1605001C": "GNSS error. Restart aircraft",
    "0x1605001C_in_the_sky": "GNSS error. Return to home or land",
    "0x1605001F": "GNSS signal interfered. Fly with caution",
    "0x16050020": "Strong GNSS interference. Aircraft returning to home",
    "0x16050021": "RTK not converged. Place aircraft in an open area and start task after RTK converged",
    "0x16050022": "Large errors in GNSS positioning. There may be potential safety risks. Switch to A mode manually",
    "0x1605002B": "Only BDS data used. Number of searched satellites may be affected",
    "0x16060001": "Compass error. Restart aircraft",
    "0x16060001_in_the_sky": "Compass error. Return to home or land",
    "0x16060007": "Compass error. Restart aircraft",
    "0x16060007_in_the_sky": "Compass error. Return to home or land",
    "0x1606000A": "Compass error. Restart aircraft",
    "0x1606000A_in_the_sky": "Compass error. Return to home or land",
    "0x1606000D": "Compass interference. Calibrate compass",
    "0x1606000D_in_the_sky": "Compass interference. Move aircraft away from interference source",
    "0x16060010": "Compass interference. Calibrate compass",
    "0x16060010_in_the_sky": "Compass interference. Move aircraft away from interference source",
    "0x16070001": "Flight controller overheats. Returning to home...",
    "0x16070002": "Flight controller overheats. Returning to home...",
    "0x16070003": "Flight controller overheats. Auto landing...",
    "0x16070020": "RTK data not received by aircraft",
    "0x16070021": "RTK data error. Restart aircraft",
    "0x16070022": "",
    "0x16070023": "RTK data refresh frequency error",
    "0x16070024": "RTK data error",
    "0x16070025": "Unable to refresh RTK position data",
    "0x16070026": "Sudden RTK position data change",
    "0x16070027": "RTK and sensor altitude data inconsistent",
    "0x16070028": "RTK and GNSS positioning do not match",
    "0x16070029": "RTK position data changed slightly when aircraft is stationary",
    "0x16070030": "RTK firmware version does not match",
    "0x16070031": "RTK signal source switching error",
    "0x16070032": "D-RTK base station detached",
    "0x16070033": "D-RTK base station moved",
    "0x16070034": "RTK flight heading inconsistent with other sources",
    "0x16070035": "Aircraft D-RTK antenna error",
    "0x16070036": "Unable to take off. RTK antennas disconnected. Contact DJI Support",
    "0x16070036_in_the_sky": "RTK antennas disconnected. Return to home or land promptly",
    "0x16070037": "RTK Dongle Certification Error",
    "0x16070038": "",
    "0x16070039": "",
    "0x16070040": "RTK not converged. Place aircraft in an open environment and start task after RTK converged",
    "0x16070042": "RTK base station data error. Check if network RTK or D-RTK is connected",
    "0x16070043": "GNSS is interfered with error signal. Fly with caution or return to home",
    "0x16070043_in_the_sky": "GNSS is interfered with error signal. Take off with caution",
    "0x16070044": "GNSS is receiving false signal. Return to home or land promptly",
    "0x16070044_in_the_sky": "GNSS is receiving false signal. Take off with caution",
    "0x16070046": "Ionospheric scintillation detected. RTK positioning performance affected. Fly with caution",
    "0x16070047": "Relay connected. Current RTK service type unavailable. Change RTK service type to D-RTK 3 Relay before use",
    "0x16080020": "Motor %index stalled . Land aircraft immediately",
    "0x16080021": "ESC %index short-circuited . Land immediately and restart aircraft",
    "0x16080022": "ESC %index overloaded . Land aircraft immediately",
    "0x16080023": "Motor %index communication error . Land immediately and restart aircraft",
    "0x16080024": "Motor %index over-accelerating. Stop pressing control stick",
    "0x16080025": "Motor %index communication error",
    "0x16080026": "Motor %index communication error",
    "0x16080027": "Motor %index communication error",
    "0x16080028": "Motor %index communication error",
    "0x16080029": "Motor %index propeller detached, propeller not installed, or motor underloaded",
    "0x1608002A": "ESC %index overheated",
    "0x1608002B": "ESC %index overheated",
    "0x1608002C": "ESC %index voltage too high",
    "0x1608002D": "ESC %index voltage too low",
    "0x1608002E": "ESC %index flash memory error",
    "0x1608002F": "ESC %index auto-check error",
    "0x16080030": "ESC %index auto-check error",
    "0x16080031": "ESC %index auto-check error",
    "0x16080032": "ESC %index auto-check error",
    "0x16080033": "ESC %index auto-check error",
    "0x16080034": "ESC %index auto-check error",
    "0x16080035": "ESC %index auto-check error",
    "0x16080036": "ESC %index auto-check error",
    "0x16080037": "ESC %index auto-check error",
    "0x16080038": "ESC %index auto-check error",
    "0x16080039": "ESC %index auto-check error",
    "0x1608003a": "ESC %index auto-check error",
    "0x1608003b": "ESC %index auto-check error",
    "0x1608003c": "ESC %index auto-check error",
    "0x1608003d": "ESC %index auto-check error",
    "0x1608003e": "ESC %index auto-check error",
    "0x1608003f": "ESC %index auto-check error",
    "0x16080040": "ESC %index auto-check error",
    "0x16080041": "ESC %index auto-check error",
    "0x16080042": "ESC %index auto-check error",
    "0x16080043": "ESC %index auto-check error",
    "0x16080044": "ESC %index voltage too low",
    "0x16080045": "ESC %index voltage too high",
    "0x16080046": "ESC %index auto-check error",
    "0x16080047": "ESC %index auto-check error",
    "0x16080048": "ESC %index auto-check error",
    "0x16080049": "ESC %index auto-check error",
    "0x1608004a": "ESC %index overheated",
    "0x1608004b": "ESC %index temperature too low",
    "0x1608004c": "ESC %index auto-check error",
    "0x1608004d": "ESC %index auto-check error",
    "0x1608004e": "ESC %index auto-check error",
    "0x1608004f": "ESC %index auto-check error",
    "0x16080050": "ESC error. Unable to take off. Restart aircraft and try again",
    "0x16080050_in_the_sky": "ESC error. Return to home or land promptly",
    "0x16080051": "ESC error. Fly with caution",
    "0x16080052": "Propulsion system error. Propellers folded. Unable to take off",
    "0x16080052_in_the_sky": "Propulsion system error. Propellers folded",
    "0x16080053": "ESC error. Fly with caution",
    "0x16080054": "ESC error. Unable to take off. Restart aircraft and try again",
    "0x16080054_in_the_sky": "ESC error. Return to home or land promptly",
    "0x16080055": "Motor %index overheated. Land aircraft immediately",
    "0x16080056": "Motor operating temperature high. Flight speed limited",
    "0x16080056_in_the_sky": "Motor operating temperature high. Flight speed limited",
    "0x16080057": "ESC error. Return to home or land promptly",
    "0x16080057_in_the_sky": "ESC error. Return to home or land promptly",
    "0x16080058": "ESC error. Unable to take off. Contact DJI Support",
    "0x16080058_in_the_sky": "ESC error. Return to home or land promptly",
    "0x16080059": "ESC error. Unable to take off. Contact DJI Support",
    "0x16080059_in_the_sky": "ESC error. Return to home or land promptly",
    "0x1608005A": "ESC error. Unable to take off. Contact DJI Support",
    "0x1608005A_in_the_sky": "ESC error. Return to home or land promptly",
    "0x1608005B": "ESC error. Unable to take off. Contact DJI Support",
    "0x1608005B_in_the_sky": "ESC error. Return to home or land promptly",
    "0x1608005C": "ESC error. Unable to take off. Contact DJI Support",
    "0x1608005C_in_the_sky": "ESC error. Return to home or land promptly",
    "0x1608005D": "ESC error. Unable to take off. Contact DJI Support",
    "0x1608005D_in_the_sky": "ESC error. Return to home or land promptly",
    "0x1608005E": "ESC error. Unable to take off. Contact DJI Support",
    "0x1608005F": "Motor overheated. Aircraft auto landing",
    "0x1608005a": "ESC error. Unable to take off. Contact DJI Support",
    "0x1608005b": "ESC error. Unable to take off. Contact DJI Support",
    "0x1608005c": "ESC error. Unable to take off. Contact DJI Support",
    "0x1608005d": "ESC error. Unable to take off. Contact DJI Support",
    "0x1608005e": "ESC error. Unable to take off. Contact DJI Support",
    "0x1608005e_in_the_sky": "ESC error. Return to home or land promptly",
    "0x16080077": "%index ESC overheated (%alarmid)",
    "0x16080078": "%index ESC overheated (%alarmid)",
    "0x16080079": "%index ESC firmware incompatible with aircraft model (%alarmid)",
    "0x1608007A": "%index ESC firmware incompatible with aircraft model (%alarmid)",
    "0x1608007B": "%index ESC auto-check error (%alarmid)",
    "0x1608007C": "%index ESC auto-check error (%alarmid)",
    "0x1608007D": "%index ESC or motor auto-check error (%alarmid)",
    "0x1608007E": "%index ESC or motor auto-check error (%alarmid)",
    "0x1608007F": "%index ESC or motor auto-check error (%alarmid)",
    "0x16080080": "%index ESC or motor auto-check error (%alarmid)",
    "0x16080083": "Failed to start Motor %d. Make sure propellers are unfolded and free from obstacles and try again",
    "0x16090050": "%battery_index Battery power supply error. Return to home or land promptly",
    "0x16090051": "%battery_index Battery power supply error. Return to home or land promptly",
    "0x16090052": "%battery_index Battery temperature sensor error. Return to home or land promptly",
    "0x16090061": "%battery_index Battery overheated. Return to home or land promptly. Stop using battery",
    "0x16090062": "%battery_index Battery MOS temperature too high. Return to home or land promptly. Wait until %battery_index Battery cools down",
    "0x16090063": "%battery_index Battery voltage too high. Return to home or land promptly",
    "0x16090064": "%battery_index Battery voltage too low. Return to home or land promptly",
    "0x16090065": "%battery_index Battery single cell voltage too high. Return to home or land promptly",
    "0x16090066": "%battery_index Battery single cell voltage too low. Return to home or land promptly",
    "0x16090067": "Large static voltage difference between %battery_index Battery cells. Stop using battery",
    "0x16090068": "Large charge voltage difference between %battery_index Battery cells. Return to home or land promptly. Stop using battery",
    "0x16090069": "Large discharge voltage difference between %battery_index Battery cells. Return to home or land promptly. Stop using battery",
    "0x1609006A": "%battery_index Battery MOS connection error. Return to home or land promptly",
    "0x1609006B": "%battery_index Battery MOS impedance error. Return to home or land promptly",
    "0x1609006C": "%battery_index Battery aging. Flight safety may be affected. Return to home or land promptly",
    "0x1609006D": "%battery_index Battery experienced micro short circuit. Flight safety may be affected. Return to home or land promptly",
    "0x1609006F": "%battery_index Battery connector temperature too high. Return to home or land promptly",
    "0x16090070": "%battery_index Battery voltage too low. Return to home or land promptly",
    "0x16090071": "Battery overvoltage protection",
    "0x16090072": "%battery_index Battery overcurrent when charging. Check charging device",
    "0x16090073": "%battery_index Battery overcurrent when discharging. Check if aircraft is overloaded",
    "0x16090074": "%battery_index Battery over discharged. Check if aircraft is overloaded",
    "0x16090075": "%battery_index Battery system error. Restart %battery_index Battery and try again",
    "0x16090076": "%battery_index Battery internal module error. Return to home or land promptly",
    "0x16090077": "%battery_index Battery charging temperature too high. Stop charging and wait until %battery_index Battery cools down",
    "0x16090078": "%battery_index Battery discharging temperature too high. Return to home or land promptly. Wait until %battery_index Battery cools down",
    "0x16090079": "%battery_index Battery charging temperature too low. Warm up %battery_index Battery before charging",
    "0x1609007A": "%battery_index Battery discharging temperature too low. Return to home or land promptly. Warm up %battery_index Battery before takeoff",
    "0x1609007B": "%battery_index Battery voltage too high. Reinstall %battery_index Battery before takeoff",
    "0x1609007C": "%battery_index Battery voltage too low. Reinstall %battery_index Battery before takeoff",
    "0x1609007D": "Charging device voltage too high. Check device",
    "0x1609007E": "Charging device voltage too low. Check device",
    "0x1609007F": "%battery_index Battery overheated. Unable to take off. Wait until %battery_index Battery cools down",
    "0x16090080": "%battery_index Battery overheated. Return to home or land promptly. Wait until %battery_index Battery cools down",
    "0x16090081": "%battery_index Battery overheated. Return to home or land promptly. Wait until %battery_index Battery cools down",
    "0x16090082": "%battery_index Battery internal communication error. Return to home or land promptly",
    "0x16090083": "%battery_index Battery internal communication error. Return to home or land promptly",
    "0x16090084": "%battery_index Battery internal communication error. Return to home or land promptly",
    "0x16090085": "%battery_index Battery external communication error. Return to home or land promptly",
    "0x16090086": "%battery_index battery connector temperature too high. Flight safety affected",
    "0x16090086_in_the_sky": "%battery_index battery connector temperature too high. Flight safety affected. Return to home or land promptly",
    "0x16090092": "Pack voltage sensor error",
    "0x16090093": "%battery_index Battery voltage unstable. Return to home or land promptly. Restart aircraft after landing",
    "0x16090094": "%battery_index Battery voltage sensor error. Return to home or land promptly",
    "0x16090095": "%battery_index Battery voltage too high. Return to home or land promptly. Restart aircraft after landing",
    "0x16090096": "%battery_index Battery maintenance required. Fly with caution",
    "0x16090097": "%battery_index battery maintenance required. Fly with caution",
    "0x16090098": "Large voltage difference during discharge",
    "0x16090099": "%battery_index Battery overcurrent. Fly with caution",
    "0x1609009B": "%battery_index Battery temperature high. Return to home or land promptly. Wait until %battery_index Battery cools down",
    "0x1609009C": "%battery_index Battery temperature high. Return to home or land promptly. Wait until %battery_index Battery cools down",
    "0x1609009D": "%battery_index battery connector temperature too high",
    "0x1609009D_in_the_sky": "%battery_index battery connector temperature too high. Flight safety affected. Return to home or land promptly",
    "0x1609009E": "%battery_index Battery voltage high. Return to home or land promptly",
    "0x1609009F": "%battery_index Battery voltage low. Return to home or land promptly",
    "0x160900A2": "%index battery connector overheated. Flight safety affected. Fly with caution",
    "0x160900A3": "%index battery exceeds power limit. Flight safety affected. Return to home or land promptly",
    "0x160900A6": "%battery_index Battery connection error. Return to home or land promptly",
    "0x160900B0": "%battery_index Battery level incorrect. Return to home or land promptly",
    "0x160900B1": "%battery_index Battery level unstable. Return to home or land promptly",
    "0x160900B2": "Abnormal SoC changes",
    "0x160900B3": "%battery_index Battery capacity error. Fly with caution",
    "0x160900B4": "%battery_index Battery capacity error. Fly with caution",
    "0x160900B5": "%battery_index Battery capacity error. Fly with caution",
    "0x160900B6": "%battery_index Battery capacity error. Fly with caution",
    "0x160900B7": "%battery_index Battery capacity error. Fly with caution",
    "0x160900B8": "%battery_index Battery capacity error. Fly with caution",
    "0x160900B9": "%battery_index Battery capacity not updated for extended period. Maintenance required. Fly with caution",
    "0x160900BA": "%battery_index Battery capacity not updated for extended period. Maintenance required. Fly with caution",
    "0x160900BB": "%battery_index Battery degraded. Fly with caution",
    "0x160900BC": "Battery internal resistance unusually low",
    "0x160900BD": "%battery_index Battery aging. Flight safety may be affected. Return to home or land promptly",
    "0x160900BE": "%battery_index Battery aging. Flight safety may be affected. Return to home or land promptly",
    "0x160900BF": "%battery_index Battery approaching cycle count limit. It is recommended to replace with new battery and maintain %battery_index Battery",
    "0x160900C0": "%battery_index Battery rated power exceeded. Performance limited. Fly with caution",
    "0x160900C1": "Imbalanced battery",
    "0x160900C2": "Sudden SoC changes",
    "0x160900C3": "Battery approaching cycle count limit. Continuing use will pose safety risks. Replace battery recommended",
    "0x160900C4": "%battery_index battery level calibration required. Let battery sit for 2 hours to restore",
    "0x160900C8": "D-RTK 3 battery level below 20%. Charge promptly",
    "0x160900C9": "D-RTK 3 battery level below 10%. Charge promptly",
    "0x160900CA": "D-RTK 3 battery overcurrent during charging. Disconnect charging device and reconnect",
    "0x160900CB": "D-RTK 3 battery overcurrent during discharging. Restart D-RTK 3",
    "0x160900CD": "D-RTK 3 battery temperature exceeds 70\u00b0 C. Wait for temperature to return to normal before use",
    "0x160900CE": "D-RTK 3 battery temperature exceeds 75\u00b0 C. Wait for temperature to return to normal before use",
    "0x160900D0": "Battery temperature too low. D-RTK 3 will power off",
    "0x160900D2": "%battery_index battery level not calibrated for a long time. Let battery sit for 1 hour before calibration",
    "0x160900D5": "Unable to take off: Battery reached end of lifespan. Replace battery",
    "0x160900D5_in_the_sky": "Unable to take off: Battery reached end of lifespan. Replace battery",
    "0x160900D6": "Battery SOHc low. Battery will reach end of lifespan after 20 cycles or days. Replace battery promptly",
    "0x160900D7": "Non-standard PoE detected. Use PoE with power above 15 W",
    "0x160900D8": "Power of current adapter is too low. Unable to support D-RTK 3 operation in temperature below -20\u00b0 C",
    "0x160A0001": "Parachute communication error. Make sure parachute is installed properly",
    "0x160A0011": "Real-name registration is canceled, which may result in flight safety risks. View Help Documentation and complete real-name registration based on instructions before flight",
    "0x160B0000": "D-RTK 3 multifunctional station disconnected",
    "0x160B0001": "D-RTK 3 multifunctional station moved",
    "0x160B0002": "D-RTK 3 multifunctional station RTK satellite signal searching error. Check if signal is obstructed and use device in area with strong satellite signal",
    "0x160B0003": "Initialization position of D-RTK 3 multifunctional station is too far from last calibrated position",
    "0x160B0004": "Failed to initiate D-RTK 3 multifunctional station positioning. Redeploy in area with strong satellite signal",
    "0x16100001": "Compass error. Unable to take off. Restart aircraft",
    "0x16100001_in_the_sky": "Compass error. Return to home or land",
    "0x16100002": "DJI Assistant connected. Unable to take off. Disconnect before taking off",
    "0x16100002_in_the_sky": "DJI Assistant connected. Disconnect before taking off",
    "0x16100003": "Aircraft not activated or firmware out-of-date. Unable to take off. Activate aircraft or update to latest firmware version",
    "0x16100003_in_the_sky": "Device activation or firmware update required",
    "0x16100005": "IMU error. Unable to take off. Restart aircraft",
    "0x16100005_in_the_sky": "IMU error. Restart aircraft",
    "0x16100006": "Invalid IMU serial number. Unable to take off. Maintenance required",
    "0x16100006_in_the_sky": "Invalid IMU serial number. Return to home or land",
    "0x16100008": "Compass calibrating. Unable to take off. Wait for calibration to complete before taking off(%alarmid)",
    "0x16100008_in_the_sky": "Compass calibrating. Wait for calibration to complete before taking off",
    "0x16100009": "Sensor system initializing. Unable to take off. Wait for initialization to complete before taking off",
    "0x16100009_in_the_sky": "Sensor system initializing. Return to home or land",
    "0x1610000A": "Aircraft in Beginner mode. Unable to take off. Take off in an open outdoor area when in Beginner mode",
    "0x1610000A_in_the_sky": "Beginner mode enabled. When using Beginner mode, take off in an open, outdoor area",
    "0x1610000B": "Battery cell error. Unable to take off. Contact DJI Support",
    "0x1610000B_in_the_sky": "Battery cell error. Return to home or land",
    "0x1610000C": "Battery communication error. Unable to take off. Reinstall battery",
    "0x1610000C_in_the_sky": "Battery communication error. Return to home",
    "0x1610000D": "Critical low battery voltage. Unable to take off. Charge promptly",
    "0x1610000D_in_the_sky": "Critical low battery voltage. Return to home or land promptly",
    "0x1610000E": "Critical low battery. Unable to take off. Charge promptly",
    "0x1610000E_in_the_sky": "Critical low battery. Return to home or land promptly",
    "0x1610000F": "Critical low battery voltage. Unable to take off. Charge promptly",
    "0x1610000F_in_the_sky": "Critical low battery voltage. Return to home or land promptly",
    "0x16100010": "Battery output power insufficient. Unable to take off. Charge promptly",
    "0x16100010_in_the_sky": "Battery power output insufficient. Return to home or land",
    "0x16100011": "Critical low battery. Unable to take off. Charge promptly",
    "0x16100011_in_the_sky": "Critical low battery. Return to home or land promptly",
    "0x16100012": "Battery initializing. Unable to take off. Wait for initialization to complete before taking off",
    "0x16100012_in_the_sky": "Battery initialization error. Return to home or land",
    "0x16100013": "Running Flight Simulator. Unable to take off. Restart aircraft before taking off",
    "0x16100013_in_the_sky": "Running Flight Simulator. Restart aircraft before taking off",
    "0x16100014": "Unable to take off. Landing gear in Travel mode",
    "0x16100015": "Aircraft pitch angle too large. Unable to take off. Ensure aircraft is level before taking off",
    "0x16100015_in_the_sky": "Aircraft pitch angle too large. Ensure aircraft is level before taking off",
    "0x16100016": "Aircraft not activated. Unable to take off. Restart DJI Pilot and activate aircraft",
    "0x16100016_in_the_sky": "Aircraft not activated. Restart DJI Pilot and activate aircraft",
    "0x16100017": "Aircraft in GEO Zone. Unable to take off. Check map to find Recommended Zones",
    "0x16100017_in_the_sky": "Aircraft in GEO Zone. Check map to find Recommended Zones",
    "0x16100018": "IMU error. Unable to take off. Calibrate IMU",
    "0x16100018_in_the_sky": "IMU initialization error. Return to home or land",
    "0x16100019": "ESC error. Unable to take off. Contact DJI Support",
    "0x16100019_in_the_sky": "ESC error. Land immediately",
    "0x1610001A": "Sensor system initializing. Unable to take off. Wait for initialization to complete before taking off",
    "0x1610001A_in_the_sky": "Sensor system initializing. Return to home or land",
    "0x1610001B": "System updating. Unable to take off. Wait for update to complete",
    "0x1610001B_in_the_sky": "System updating. Wait for update to complete before taking off",
    "0x1610001C": "Running Flight Simulator. Unable to take off. Restart aircraft before taking off",
    "0x1610001C_in_the_sky": "Running Flight Simulator. Restart aircraft before taking off",
    "0x1610001D": "IMU calibrating. Unable to take off. Wait for calibration to complete before takeoff",
    "0x1610001D_in_the_sky": "Calibrating IMU. Wait for calibration to complete before taking off",
    "0x1610001E": "Aircraft pitch angle too large. Unable to take off. Ensure aircraft is level before taking off",
    "0x1610001E_in_the_sky": "Aircraft pitch angle too large. Ensure aircraft is level before taking off",
    "0x1610001F": "Unable to take off. Flight controller overheats.",
    "0x1610001F_in_the_sky": "Flight controller overheats. Returning to home...",
    "0x16100020": "Unable to take off. Flight controller overheats.",
    "0x16100020_in_the_sky": "Flight controller overheats. Returning to home...",
    "0x16100021": "Unable to take off. Flight controller overheats.",
    "0x16100021_in_the_sky": "Flight controller overheats. Auto landing...",
    "0x16100022": "Unable to take off. Aircraft unable to remain stable for several times. To ensure flight safety, contact DJI Support",
    "0x16100023": "AirSense error. Unable to obtain crewed aircraft information",
    "0x16100024": "Compass interference. Unable to take off. Move away from source of interference or calibrate compass",
    "0x16100025": "Hot swapping not supported for RTK module. Unable to take off",
    "0x16100025_in_the_sky": "RTK error. Land promptly",
    "0x16100026": "Unable to take off. Non-DJI RTK module detected",
    "0x16100026_in_the_sky": "Non-DJI RTK module detected",
    "0x16100027": "Flight control system error. Unable to take off",
    "0x16100027_in_the_sky": "Flight control system error. Land promptly",
    "0x16100028": "Unable to take off. Models of aircraft and RTK module do not match",
    "0x16100029": "Invalid aircraft serial number. Unable to take off. Contact your local dealer or DJI Support",
    "0x16100029_in_the_sky": "Invalid aircraft serial number. Return to home or land",
    "0x1610002D": "Unable to take off. GNSS signal lost. Restart aircraft",
    "0x1610002D_in_the_sky": "GNSS signal lost. Return to home or land",
    "0x1610002F": "Data recorder error. Unable to take off. Restart aircraft",
    "0x1610002F_in_the_sky": "Data recorder error. Return to home or land",
    "0x16100030": "Aircraft model and firmware version do not match. Unable to take off. Contact your local dealer or DJI Support.",
    "0x16100030_in_the_sky": "Aircraft model and firmware version do not match. Return to home or land",
    "0x16100031": "Unable to take off. Hook is not fully retracted. Make sure hook is retracted and secure",
    "0x16100032": "Winch cable wound in reverse direction. Unable to take off. Manually unwind cable before takeoff",
    "0x16100032_in_the_sky": "Winch cable wound in reverse direction. Do not operate winch system and land promptly to unwind cable",
    "0x16100033": "Real-name registration is not performed. View Help Documentation and complete real-name registration based on instructions before flight",
    "0x16100034": "Real-name registration is canceled. View Help Documentation and complete real-name registration based on instructions before flight",
    "0x16100038": "Unable to take off. ESC voltage error. Contact DJI Support",
    "0x16100038_in_the_sky": "ESC voltage error. Return to home and contact DJI Support",
    "0x16100039": "Geo-cage function is preparing",
    "0x16100039_in_the_sky": "Unable to take off. Geo-cage function is preparing",
    "0x1610003A": "Unable to take off. RTK module overheated. Aircraft will power off immediately",
    "0x1610003B": "Unable to take off. Speaker installed. Recalibrating compass required",
    "0x1610003D": "Sensor system disconnected. Unable to take off. Restart aircraft",
    "0x1610003D_in_the_sky": "Sensor system disconnected. Return to home or land",
    "0x1610003E": "Unable to take off. Calibrating remote controller. Wait for calibration to complete",
    "0x16100041": "Unable to take off. Control sticks off-centered. Calibrate remote controller",
    "0x16100042": "Unable to take off. Control stick hardware error. Contact DJI Support",
    "0x16100042_in_the_sky": "Control stick hardware error. Land promptly. Contact DJI Support",
    "0x1610004A": "Sensor system error. Unable to take off. Restart aircraft",
    "0x1610004A_in_the_sky": "Sensor system error. Return to home or land",
    "0x1610004B": "Sensor system error. Unable to take off. Restart aircraft",
    "0x1610004B_in_the_sky": "Sensor system error. Return to home or land",
    "0x1610004C": "Unable to take off. Remote Controller Calibration Required",
    "0x1610004D": "Flight controller data error. Unable to take off. Restart aircraft",
    "0x1610004D_in_the_sky": "Flight controller data error. Return to home or land",
    "0x1610004E": "Not enough batteries installed. Unable to take off. Insert two batteries before taking off",
    "0x1610004E_in_the_sky": "Insufficient batteries. Return to home or land promptly",
    "0x1610004F": "Battery authentication failed. Unable to take off. Replace with DJI battery",
    "0x1610004F_in_the_sky": "Battery authentication failed. Replace with standard DJI battery",
    "0x16100051": "Large voltage difference between batteries. Unable to take off. Replace batteries with new ones of a similar capacity",
    "0x16100051_in_the_sky": "Large voltage difference between batteries. Return to home or land. Replace batteries with new ones of a similar capacity and try again",
    "0x16100053": "Aircraft module firmware versions do not match. Unable to take off. Update to latest firmware versions.",
    "0x16100053_in_the_sky": "Aircraft module firmware versions do not match. Update to latest firmware versions",
    "0x16100054": "Gimbal error. Unable to take off. Contact DJI Support",
    "0x16100054_in_the_sky": "Gimbal error. Return to home or land",
    "0x16100055": "Gimbal error. Unable to take off. Contact DJI Support",
    "0x16100055_in_the_sky": "Gimbal error. Return to home or land",
    "0x16100056": "Gimbal error. Unable to take off. Contact DJI Support",
    "0x16100056_in_the_sky": "Gimbal error. Return to home or land",
    "0x16100057": "Gimbal error. Unable to take off. Contact DJI Support",
    "0x16100057_in_the_sky": "Gimbal error. Return to home or land",
    "0x16100058": "Gimbal firmware updating. Unable to take off...",
    "0x16100058_in_the_sky": "Gimbal firmware update in progress",
    "0x1610005D": "IMU calibration successful. Unable to take off. Restarting aircraft required",
    "0x1610005D_in_the_sky": "IMU calibration error. Return to home or land",
    "0x1610005E": "Aircraft rolled during takeoff. Unable to take off. Check whether propellers were installed correctly",
    "0x1610005E_in_the_sky": "Aircraft rolled during takeoff. Check whether propellers are installed correctly",
    "0x1610005F": "Motor stalled. Unable to take off. Power off aircraft and check whether motor can rotate freely",
    "0x1610005F_in_the_sky": "Motor stalled. Land promptly. Power off airfcraft and check whether motor can rotate freely",
    "0x16100060": "Motor rotation speed error. Unable to take off. Restart aircraft",
    "0x16100060_in_the_sky": "Motor rotation speed error. Land and restart aircraft",
    "0x16100061": "Motor idle. Unable to take off. Check whether propellers are detached or installed incorrectly",
    "0x16100061_in_the_sky": "Motor idle. Unable to take off. Check whether propellers are detached or installed incorrectly",
    "0x16100062": "Unable to turn on motor. Unable to take off. Check aircraft status and restart",
    "0x16100062_in_the_sky": "Unable to turn on aircraft motor(s). Check aircraft status and restart",
    "0x16100063": "Auto Takeoff failed. Unable to take off",
    "0x16100063_in_the_sky": "Auto Takeoff failed",
    "0x16100064": "Aircraft rolled over. Unable to take off. Restart aircraft and ensure it is level before taking off",
    "0x16100064_in_the_sky": "Aircraft rolled over. Return to home or land",
    "0x16100065": "Battery firmware version error. Unable to take off. Replace battery or update battery firmware to latest version",
    "0x16100065_in_the_sky": "Battery firmware version error. Replace battery or update to the latest firmware version",
    "0x16100066": "RTK signal weak. Unable to take off. Move to an open area for takeoff or turn off RTK",
    "0x16100066_in_the_sky": "RTK signal weak. Move to an open area for takeoff or turn off RTK",
    "0x16100067": "Compass interference. Unable to take off. Calibrate compass",
    "0x16100067_in_the_sky": "Compass interference. Move away from interference source",
    "0x16100068": "ESC short-circuited. Unable to take off. Restart aircraft",
    "0x16100068_in_the_sky": "ESC short-circuited. Restart aircraft",
    "0x16100069": "ESC auto-check error. Unable to take off. Restart aircraft",
    "0x16100069_in_the_sky": "ESC auto-check error. Return to home or land",
    "0x1610006A": "Incompatible battery. Replace battery",
    "0x1610006B": "Unable to take off. Battery firmware update required",
    "0x1610006B_in_the_sky": "Battery firmware error. Return to home or land promptly",
    "0x1610006C": "Unable to take off. Severe battery error",
    "0x1610006C_in_the_sky": "Severe battery error. Auto landing...",
    "0x1610006D": "Unable to take off. Power restricted. Check battery warning for issue reason",
    "0x1610006D_in_the_sky": "Power and flight attitude restricted. Return to home promptly. Check battery warning for issue reason",
    "0x16100070": "Not Applicable. This string has been deleted",
    "0x16100070_in_the_sky": "Not Applicable. This string has been deleted",
    "0x16100071": "Unable to take off. GNSS error. Restart aircraft",
    "0x16100071_in_the_sky": "GNSS error. Return to home or land",
    "0x16100072": "Gimbal calibrating. Unable to take off",
    "0x16100072_in_the_sky": "Gimbal calibration error. Return to home or land",
    "0x16100073": "Takeoff conditions not met. Unable to take off. Firmware out-of-date or flight route uploading to aircraft",
    "0x16100073_in_the_sky": "Firmware out of date or flight route uploading to aircraft. Return to home or land",
    "0x16100074": "Takeoff altitude error. Unable to take off. Restart aircraft",
    "0x16100074_in_the_sky": "Takeoff altitude error. Restart aircraft",
    "0x16100075": "ESC firmware versions do not match. Unable to take off. Update to latest firmware version",
    "0x16100075_in_the_sky": "ESC firmware versions do not match. Update to latest firmware versions",
    "0x16100076": "IMU error. Unable to take off. Contact DJI Support",
    "0x16100076_in_the_sky": "IMU error. Return to home or land",
    "0x16100078": "Compass error. Unable to take off. Contact DJI Support",
    "0x16100078_in_the_sky": "Compass error. Return to home or land",
    "0x1610007A": "ESC beeping. Unable to take off. Turn off ESC beeping before takeoff",
    "0x1610007A_in_the_sky": "ESC beeping. Return to home or land",
    "0x1610007B": "ESC overheated. Unable to take off. Power off aircraft and wait for temperature to return to normal",
    "0x1610007B_in_the_sky": "ESC overheated. Land promptly. Power off aircraft and wait for temperature to return to normal",
    "0x1610007C": "Battery installed incorrectly. Detach battery and reinstall it",
    "0x1610007D": "Impact detected. Takeoff failed and aircraft landed. Unable to take off. Restart aircraft",
    "0x1610007D_in_the_sky": "Impact detected. Aircraft landed. Restart aircraft",
    "0x1610007F": "Impact detected. Unable to take off. Restart aircraft",
    "0x1610007F_in_the_sky": "Impact detected. Return to home or land",
    "0x16100080": "Aircraft altitude control error. Unable to take off. Restart aircraft",
    "0x16100080_in_the_sky": "Aircraft altitude control error. RTH or land",
    "0x16100081": "Battery firmware out-of-date. Unable to take off. Update to latest firmware version",
    "0x16100081_in_the_sky": "Battery firmware version out of date. Return to home or land. Update to latest firmware version",
    "0x16100082": "Large voltage different between battery cells. Unable to take off. Battery maintenance required",
    "0x16100082_in_the_sky": "Large difference in battery cell voltage detected. Return to home or land. Battery maintenance required",
    "0x16100083": "Battery installed incorrectly. Unable to take off. Turn battery locker to its limit and ensure both batteries are installed correctly",
    "0x16100083_in_the_sky": "Battery installed incorrectly. Return to home or land. Turn battery locker to its limit and ensure both batteries are installed correctly",
    "0x16100083_in_the_sky_pm440": "Battery not properly installed. Return to home or land. Check if battery handle is secured",
    "0x16100083_pm440": "Unable to take off. Install battery handle properly",
    "0x16100084": "Upper fan error. Unable to take off. Check whether upper fan is stalled",
    "0x16100084_in_the_sky": "Upper fan error. Return to home or land. Check whether upper fan is stalled",
    "0x16100085": "Aircraft overheated. Unable to take off. Power off aircraft and wait for temperature to return to normal",
    "0x16100085_in_the_sky": "Aircraft overheated. Return to home or land. Power off aircraft and wait for temperature to return to normal",
    "0x16100087": "Emergency Propeller Stop triggered. Unable to take off",
    "0x16100087_in_the_sky": "Emergency Propeller Stop triggered",
    "0x16100088": "Unable to take off. Calibrating remote controller. Exit calibration first",
    "0x16100088_in_the_sky": "Unable to take off. Calibrating remote controller. Exit calibration first",
    "0x16100089": "Unable to take off. Remote controller not bound/still confirming binding status. Use bound remote controller or bind aircraft to current remote controller",
    "0x16100089_in_the_sky": "Takeoff error. Failed to verify remote controller. Use bound remote controller or bind aircraft to current remote controller",
    "0x1610008A": "Flight controller unit error. Unable to take off. Restart aircraft",
    "0x1610008A_in_the_sky": "Flight controller unit error. Return to home or land",
    "0x1610008F": "Aircraft antenna satellite signal searching error. Unable to take off. Move to an open area for takeoff",
    "0x1610008F_in_the_sky": "Aircraft antenna satellite signal searching error. Fly with caution",
    "0x16100090": "Sensor system error. Restart aircraft",
    "0x16100090_in_the_sky": "Sensor system error. Return to home or land",
    "0x16100091": "Flight prohibited in current area. Unable to take off",
    "0x16100091_in_the_sky": "Flying prohibited in current area. Return to home or land",
    "0x16100091_in_the_sky_special": "Unable to fly in this area. Max flight altitude limited to %1$s m",
    "0x16100092": "Battery capacity error. Unable to take off. Battery maintenance required",
    "0x16100092_in_the_sky": "Battery capacity error. Return to home or land. Battery maintenance required",
    "0x16100095": "Unable to take off. Set Hover mode before flying",
    "0x16100096": "%battery_index Battery power supply error. Aircraft auto landing",
    "0x16100099": "Gimbal starting error. Unable to take off. Check whether gimbal can rotate freely and restart aircraft",
    "0x16100099_in_the_sky": "Gimbal startup error. Return to home or land. Check whether gimbal can rotate freely and restart aircraft",
    "0x1610009A": "Excessive gimbal vibration. Unable to take off. Check whether gimbal can rotate freely or is damaged. Restart aircraft",
    "0x1610009A_in_the_sky": "Excessive gimbal vibration. Return to home or land. Check whether gimbal can rotate freely or is damaged. Restart aircraft",
    "0x1610009F": "Flight controller unit error. Unable to take off. Restart aircraft",
    "0x1610009F_in_the_sky": "Flight controller unit error. Return to home or land",
    "0x161000A0": "GEO module error. Unable to take off",
    "0x161000A0_in_the_sky": "GEO module error . Return to home or land promptly",
    "0x161000A1": "Unable to take off. Check whether frame arm sleeves are tightened securely",
    "0x161000A1_in_the_sky": "Land promptly and check whether frame arm sleeves are tightened securely",
    "0x161000A2": "Lower fan error. Unable to take off. Check whether lower fan is stalled",
    "0x161000A2_in_the_sky": "Lower fan error. Return to home or land. Check whether lower fan is stalled",
    "0x161000A3": "Unable to take off. Disconnect aircraft from USB and try again",
    "0x161000A4": "Unable to take off. Aircraft on moving platform",
    "0x161000A4_in_the_sky": "Flight controller error. Return to home or land promptly",
    "0x161000A5": "Unable to take off. Propellers folded",
    "0x161000A5_in_the_sky": "Flight controller error. Return to home or land promptly",
    "0x161000A6": "Remote controller battery low. Unable to take off. Recharge battery",
    "0x161000A6_in_the_sky": "Remote controller battery low. Return to home or land promptly",
    "0x161000A7": "Unable to take off. Failed to verify remote controller. Max number of temporary flights reached. Use bound remote controller or bind to another remote controller",
    "0x161000A7_in_the_sky": "Flight controller error. Return to home or land promptly",
    "0x161000A9": "Propellers in slow motion mode. Unable to take off",
    "0x161000A9_in_the_sky": "Propeller motion error. Return to home or land promptly",
    "0x161000AA": "GEO module error. Unable to take off",
    "0x161000AA_in_the_sky": "GEO module error. Return to home or land promptly",
    "0x161000AB": "Fly Safe database error. Unable to take off",
    "0x161000AB_in_the_sky": "Fly Safe database error. Return to home or land promptly",
    "0x161000AC": "Flight control system error. Unable to take off",
    "0x161000AC_in_the_sky": "Flight control system error. Land promptly",
    "0x161000AF": "Initializing flight control system. Unable to take off",
    "0x161000AF_in_the_sky": "Flight control system initialization error. Return to home or land promptly",
    "0x161000B1": "Landing gear status error. Try to release Landing Gear Auto Lock and press the transform button to reset the landing gear",
    "0x161000B1_in_the_sky": "Landing gear status error. Try to press the transform button to reset the landing gear",
    "0x161000B2": "Unable to take off. Landing gear transforming...",
    "0x161000B3": "Unable to take off. Landing gear in Travel mode. Remove gimbal camera to transform",
    "0x161000B4": "Remote ID broadcast error. Failed to obtain remote controller location. Unable to take off",
    "0x161000B5": "Remote ID module error. Unable to take off. Contact DJI Support",
    "0x161000B6": "Average battery power output too low. Unable to take off. Reduce payload or replace with fully charged batteries",
    "0x161000B7": "Payload exceeded max allowable weight. Reduce payload or fully charge battery",
    "0x161000B7_in_the_sky": "Payload exceeded max allowable weight. Return to home or land promptly",
    "0x161000B8": "Obstacle detected near aircraft. Unable to take off",
    "0x161000BD": "Parachute built-in battery voltage too low. Unable to take off",
    "0x161000BE": "Incompatible battery models. Unable to take off",
    "0x161000BF": "Single battery flight not enabled. Unable to take off",
    "0x161000C0": "Unable to take off. Gimbal camera with current mount not supported. Update aircraft firmware",
    "0x161000C4": "Unable to take off. Auto checking ESC...",
    "0x161000C7": "Battery temperature lower than 10\u00b0C. Unable to take off",
    "0x161000C7_in_the_sky": "Battery temperature lower than 10\u00b0C. Return to home or land promptly",
    "0x161000C8": "Unable to take off. Check whether aircraft is connected to DJI Assistant or system is updating",
    "0x161000C8_in_the_sky": "Check whether aircraft is connected to DJI Assistant or system is updating",
    "0x161000C9": "Unable to take off. Check whether aircraft is connected to DJI Assistant or system is updating",
    "0x161000C9_in_the_sky": "Check whether aircraft is connected to DJI Assistant or system is updating",
    "0x161000D3": "Unable to take off. Motor 1 severely overheated. Flight safety may be affected. Contact DJI Support to check motor coil",
    "0x161000D3_in_the_sky": "Motor 1 severely overheated. Flight safety may be affected. Contact DJI Support to check motor coil",
    "0x161000D4": "Unable to take off. Motor 2 severely overheated. Flight safety may be affected. Contact DJI Support to check motor coil",
    "0x161000D4_in_the_sky": "Motor 2 severely overheated. Flight safety may be affected. Contact DJI Support to check motor coil",
    "0x161000D5": "Unable to take off. Motor 3 severely overheated. Flight safety may be affected. Contact DJI Support to check motor coil",
    "0x161000D5_in_the_sky": "Motor 3 severely overheated. Flight safety may be affected. Contact DJI Support to check motor coil",
    "0x161000D6": "Unable to take off. Motor 4 severely overheated. Flight safety may be affected. Contact DJI Support to check motor coil",
    "0x161000D6_in_the_sky": "Motor 4 severely overheated. Flight safety may be affected. Contact DJI Support to check motor coil",
    "0x161000D7": "Unable to take off. Motor 5 severely overheated. Flight safety may be affected. Contact DJI Support to check motor coil",
    "0x161000D7_in_the_sky": "Motor 5 severely overheated. Flight safety may be affected. Contact DJI Support to check motor coil",
    "0x161000D8": "Unable to take off. Motor 6 severely overheated. Flight safety may be affected. Contact DJI Support to check motor coil",
    "0x161000D8_in_the_sky": "Motor 6 severely overheated. Flight safety may be affected. Contact DJI Support to check motor coil",
    "0x161000D9": "Unable to take off. Motor 7 severely overheated. Flight safety may be affected. Contact DJI Support to check motor coil",
    "0x161000D9_in_the_sky": "Motor 7 severely overheated. Flight safety may be affected. Contact DJI Support to check motor coil",
    "0x161000DA": "Unable to take off. Motor 8 severely overheated. Flight safety may be affected. Contact DJI Support to check motor coil",
    "0x161000DA_in_the_sky": "Motor 8 severely overheated. Flight safety may be affected. Contact DJI Support to check motor coil",
    "0x161000F1": "Unable to take off. Check whether front right frame arm is fully unfolded",
    "0x161000F1_in_the_sky": "Front right frame arm error. Land promptly",
    "0x161000F2": "Unable to take off. Check whether front left frame arm is fully unfolded",
    "0x161000F2_in_the_sky": "Front left frame arm error. Land promptly",
    "0x161000F3": "Unable to take off. Check whether back left frame arm is fully unfolded",
    "0x161000F3_in_the_sky": "Back left frame arm error. Land promptly",
    "0x161000F4": "Unable to take off. Check whether back right frame arm is fully unfolded",
    "0x161000F4_in_the_sky": "Back right frame arm error. Land promptly",
    "0x161000F5": "Initializing system. Unable to take off",
    "0x161000F5_in_the_sky": "Initializing system. Land promptly",
    "0x161000F6": "Flight control system error. Unable to take off",
    "0x161000F6_in_the_sky": "Flight control system error. Land promptly",
    "0x161000F7": "Sensor system initialization in progress",
    "0x161000F7_in_the_sky": "Sensor system error. Land promptly or fly with caution",
    "0x161000F8": "Sensor system initialization in progress",
    "0x161000F8_in_the_sky": "Sensor system error. Land promptly",
    "0x161000F9": "Unable to take off. Remote controller signal weak. Take off near remote controller",
    "0x161000F9_in_the_sky": "Flight controller error. Return to home or land promptly",
    "0x161000FA": "Unable to take off. Remote controller signal weak. Take off near remote controller",
    "0x161000FA_in_the_sky": "Flight controller error. Return to home or land promptly",
    "0x161000FB": "Unable to take off. Propeller damaged. Contact DJI Support",
    "0x161000FC": "Unable to take off. DJI Dock in site selection process",
    "0x161000FD": "Unable to take off. Aircraft is outside of custom task area or within 10 meters of the area boundary",
    "0x161000FD_in_the_sky": "Execute task in custom task area",
    "0x161000a1": "Unable to take off. Check whether frame arm sleeves are tightened securely",
    "0x161000a2": "Lower fan error. Unable to take off. Check whether lower fan is stalled",
    "0x161000a2_in_the_sky": "Lower fan error. Return to home or land. Check whether lower fan is stalled",
    "0x161000a6": "Remote controller battery low. Unable to take off. Recharge battery",
    "0x161000a6_in_the_sky": "Remote controller battery low. Return to home or land promptly",
    "0x161000b4": "Remote ID broadcast error. Failed to obtain remote controller location. Unable to take off",
    "0x161000b5": "Remote ID module error. Unable to take off. Contact DJI Support",
    "0x161000c0": "Unable to take off: left battery and right battery models do not match. Replace battery for model consistency",
    "0x161000c0_in_the_sky": "Left battery and right battery models do not match. Land aircraft immediately and replace battery",
    "0x1611000A": "Signal lost. RTH in progress",
    "0x16110010": "The bottom  auxiliary light  does not function before takeoff and will automatically activate after takeoff.",
    "0x16110023": "Aircraft output power insufficient. Land immediately with caution",
    "0x16110029": "Flight and wind-resistance performances reduced. Accessory installed",
    "0x1611002A": "Spotlight disconnected. Tighten screws",
    "0x1611002B": "Speaker disconnected. Tighten screws",
    "0x1611002D": "Payload power supply error. Power exceeded limit. Return to home and restart aircraft",
    "0x1611004F": "Battery authentication failed",
    "0x16110065": "Aircraft overheated. AI recognition disabled. Wait for temperature to return to normal before use",
    "0x16110066": "RTK module overheated. Wait for temperature to return to normal before use",
    "0x16110067": "RTK module overheated and disabled. Wait for temperature to return to normal before use",
    "0x1612000B": "Altitude too high. Using high-altitude propellers recommended",
    "0x1612000C": "Altitude too high. Use high-altitude propellers only",
    "0x1612000D": "Reaching maximum flight altitude. Pay attention to flight safety and altitude",
    "0x16120010": "Approaching ground. Fly with caution",
    "0x16130001": "Aircraft will take off from boat. Aircraft attitude angle too large. Fly with caution",
    "0x16130002": "Aircraft will take off from boat. Boat speed too fast. Fly with caution",
    "0x16130003": "Aircraft will take off from boat. Aircraft attitude angle too large. Fly with caution",
    "0x16140001": "Failed to connect to PSDK device. Check connection and restart aircraft",
    "0x16140002": "PSDK device power error. Restart aircraft",
    "0x16200101": "Aircraft connected to USB device. Unable to take off",
    "0x16200101_in_the_sky": "USB port error. Fly with caution",
    "0x16200102": "Clearing logs. Unable to take off",
    "0x16200102_in_the_sky": "Clearing logs. Fly with caution",
    "0x16200103": "Updating firmware. Unable to take off",
    "0x16200103_in_the_sky": "Updating firmware. Fly with caution",
    "0x16200104": "Unable to take off. Firmware update required or update in progress",
    "0x16200104_in_the_sky": "Firmware update required. Fly with caution",
    "0x16200201": "Updating Fly Safe database. Unable to take off",
    "0x16200201_in_the_sky": "Updating Fly Safe database. Fly with caution",
    "0x16200202": "Vision sensor calibration error. Unable to take off",
    "0x16200202_in_the_sky": "Vision sensor calibration error. Fly with caution",
    "0x16200203": "ToF sensor calibration error. Unable to take off",
    "0x16200203_in_the_sky": "ToF sensor calibration error. Fly with caution",
    "0x16200204": "Vision sensor status error. Unable to take off",
    "0x16200204_in_the_sky": "Vision sensor status error. Fly with caution",
    "0x16200207": "Unable to take off. Downward infrared sensor connection error",
    "0x16200208": "Propeller error. Make sure propellers are not damaged. Contact DJI Support",
    "0x16200301": "Extension port device error. Unable to take off. Check PSDK device",
    "0x16200301_in_the_sky": "Extension port device error. Return to home or land promptly",
    "0x16200302": "Third-party payload error. Unable to take off",
    "0x16200302_in_the_sky": "Stopping propellers. Predict landing area based on current aircraft location",
    "0x16200401": "Mandatory Fly Safe database update in progress. Unable to take off",
    "0x16200401_in_the_sky": "Mandatory Fly Safe database update in progress. Fly with caution",
    "0x16200402": "Mandatory firmware update in progress. Unable to take off",
    "0x16200402_in_the_sky": "Mandatory firmware update in progress. Fly with caution",
    "0x16200501": "Incompatible battery versions. Unable to take off",
    "0x16200501_in_the_sky": "Incompatible battery versions. Return to home or land promptly",
    "0x16200601": "Initializing flight system...",
    "0x16200601_in_the_sky": "Initializing flight system...",
    "0x16200A01": "Unable to take off. Battery cover off",
    "0x16200A01_in_the_sky": "Battery communication error. Fly with caution",
    "0x16200C01": "Unable to take off. Battery not in use",
    "0x16200C01_in_the_sky": "Battery not in use",
    "0x16200D01": "Calibrating LiDAR extrinsic parameters. Flight restricted",
    "0x16200D02": "LiDAR low temperature. Flight restricted",
    "0x16400002": "",
    "0x16400003": "",
    "0x16400004": "",
    "0x16400005": "",
    "0x16400006": "",
    "0x16400007": "",
    "0x16400008": "",
    "0x16400009": "",
    "0x1640000A": "",
    "0x1640000B": "",
    "0x1640000C": "",
    "0x16400100": "",
    "0x16400101": "",
    "0x16400102": "",
    "0x16400103": "",
    "0x16400104": "",
    "0x16400105": "",
    "0x16400106": "",
    "0x16400107": "",
    "0x16400108": "",
    "0x16400109": "",
    "0x1640010A": "",
    "0x1640010B": "",
    "0x1640010C": "",
    "0x1640010D": "",
    "0x1640010E": "",
    "0x1640010F": "",
    "0x16400110": "",
    "0x16400111": "",
    "0x16400112": "",
    "0x16400113": "",
    "0x16400114": "",
    "0x16400115": "",
    "0x16400116": "",
    "0x16400117": "",
    "0x16400118": "",
    "0x16400119": "",
    "0x16416001": "",
    "0x16416002": "",
    "0x16418000": "",
    "0x16418001": "",
    "0x16418500": "",
    "0x16418501": "",
    "0x16418502": "",
    "0x16420000": "",
    "0x16420001": "",
    "0x16420002": "",
    "0x16420003": "",
    "0x16420004": "",
    "0x16420010": "",
    "0x16420011": "",
    "0x16420012": "",
    "0x16420013": "",
    "0x16420014": "",
    "0x16420015": "",
    "0x16420016": "",
    "0x16420020": "",
    "0x16420021": "",
    "0x16420022": "",
    "0x16420100": "",
    "0x16420101": "",
    "0x16420102": "",
    "0x16420103": "",
    "0x16420104": "",
    "0x16420105": "",
    "0x16420106": "",
    "0x16420107": "",
    "0x16420108": "",
    "0x16420109": "",
    "0x1642010A": "",
    "0x1642010B": "",
    "0x1642010C": "",
    "0x1642010D": "",
    "0x1642010E": "",
    "0x1642010F": "",
    "0x16420110": "",
    "0x16420111": "",
    "0x16420112": "",
    "0x16420113": "",
    "0x16420114": "",
    "0x16420115": "",
    "0x16420116": "",
    "0x16420117": "",
    "0x16430001": "",
    "0x16430002": "",
    "0x16430003": "",
    "0x16430004": "",
    "0x16430005": "",
    "0x16430006": "",
    "0x16430007": "",
    "0x16430008": "",
    "0x16430009": "",
    "0x1643000A": "",
    "0x1643000B": "",
    "0x1643000C": "",
    "0x1643000D": "",
    "0x1643000E": "",
    "0x1643000F": "",
    "0x16430010": "",
    "0x16430011": "",
    "0x16430012": "",
    "0x16430013": "",
    "0x16430014": "",
    "0x16430015": "",
    "0x16430016": "",
    "0x16430017": "",
    "0x16430018": "",
    "0x16430019": "",
    "0x1643001A": "",
    "0x1643001B": "",
    "0x1643001C": "",
    "0x1643001D": "",
    "0x1643001E": "",
    "0x1643001F": "",
    "0x16430020": "",
    "0x16430021": "",
    "0x16430022": "",
    "0x16430023": "",
    "0x16430024": "",
    "0x16430025": "",
    "0x16430026": "",
    "0x16430101": "",
    "0x16430102": "",
    "0x16430103": "",
    "0x16430104": "",
    "0x16430105": "",
    "0x16430106": "",
    "0x16430107": "",
    "0x16430108": "",
    "0x16430109": "",
    "0x1643010A": "",
    "0x1643010B": "",
    "0x1643010C": "",
    "0x1643010D": "",
    "0x1643010E": "",
    "0x1643010F": "",
    "0x16430110": "",
    "0x16430111": "",
    "0x16430112": "",
    "0x16430113": "",
    "0x16430114": "",
    "0x16430115": "",
    "0x16430116": "",
    "0x16430117": "",
    "0x16430118": "",
    "0x16430119": "",
    "0x1643011A": "",
    "0x1643011B": "",
    "0x1643011C": "",
    "0x1643011D": "",
    "0x1643011E": "",
    "0x16430201": "",
    "0x16430202": "",
    "0x16430203": "",
    "0x16430204": "",
    "0x16430205": "",
    "0x16430206": "",
    "0x16430207": "",
    "0x16430208": "",
    "0x16430209": "",
    "0x1643020A": "",
    "0x1643020B": "",
    "0x1643020C": "",
    "0x1643020D": "",
    "0x1643020E": "",
    "0x1643020F": "",
    "0x16430210": "",
    "0x16430211": "",
    "0x16430212": "",
    "0x16430213": "",
    "0x16430214": "",
    "0x16430215": "",
    "0x16430216": "",
    "0x16430217": "",
    "0x16430218": "",
    "0x16430219": "",
    "0x1643021A": "",
    "0x1643021B": "",
    "0x1643021C": "",
    "0x1643021D": "",
    "0x16430301": "",
    "0x16430302": "",
    "0x16430303": "",
    "0x16430304": "",
    "0x16430305": "",
    "0x16430306": "",
    "0x16430307": "",
    "0x16430308": "",
    "0x16430309": "",
    "0x1643030a": "",
    "0x1643030b": "",
    "0x1643030c": "",
    "0x1643030d": "",
    "0x1643030e": "",
    "0x1643030f": "",
    "0x16430310": "GNSS signal weak",
    "0x16430311": "",
    "0x16430312": "",
    "0x16430313": "",
    "0x16430314": "",
    "0x16430315": "",
    "0x16430316": "",
    "0x16430317": "",
    "0x16430318": "",
    "0x16430319": "",
    "0x1643031a": "",
    "0x1643031b": "",
    "0x1643031c": "",
    "0x1643031d": "",
    "0x1643031e": "",
    "0x1643031f": "",
    "0x16430320": "",
    "0x16430321": "",
    "0x16430322": "",
    "0x16430323": "",
    "0x16430324": "",
    "0x16432400": "",
    "0x16432401": "",
    "0x16432402": "",
    "0x16432403": "",
    "0x16432404": "",
    "0x16432405": "",
    "0x16432410": "",
    "0x16432411": "",
    "0x16432412": "",
    "0x16432413": "",
    "0x16432414": "",
    "0x16432415": "",
    "0x16432416": "",
    "0x16432417": "",
    "0x16432418": "",
    "0x16432419": "",
    "0x16432420": "",
    "0x16432421": "",
    "0x16432422": "",
    "0x16432423": "",
    "0x16432424": "",
    "0x16432425": "",
    "0x16432430": "",
    "0x16432431": "",
    "0x16432432": "",
    "0x16432433": "",
    "0x16432434": "",
    "0x16432435": "",
    "0x16432436": "",
    "0x16432500": "",
    "0x16432501": "",
    "0x16432502": "",
    "0x16432503": "",
    "0x16432504": "",
    "0x16432505": "",
    "0x16432506": "",
    "0x16432550": "",
    "0x16432551": "",
    "0x16450001": "",
    "0x16450002": "",
    "0x16450011": "",
    "0x16450012": "",
    "0x16450013": "",
    "0x16450014": "",
    "0x16450015": "",
    "0x16450016": "",
    "0x16450017": "",
    "0x16450018": "",
    "0x16450019": "",
    "0x16450021": "",
    "0x16450022": "",
    "0x16450023": "",
    "0x16450024": "",
    "0x16450025": "",
    "0x16450031": "",
    "0x16450032": "",
    "0x16450033": "",
    "0x16450034": "",
    "0x16450035": "",
    "0x16450101": "",
    "0x16450102": "",
    "0x16450103": "",
    "0x16450104": "",
    "0x16450105": "",
    "0x16450106": "",
    "0x16450107": "",
    "0x16450108": "",
    "0x16450109": "GNSS signal weak during task",
    "0x1645010A": "",
    "0x1645010B": "",
    "0x1645010C": "",
    "0x1645010D": "",
    "0x1645010E": "",
    "0x1645010F": "",
    "0x16450110": "",
    "0x16450111": "",
    "0x16450112": "",
    "0x16450113": "",
    "0x16450114": "",
    "0x16450115": "",
    "0x16450116": "",
    "0x16450117": "",
    "0x16450118": "",
    "0x16450119": "",
    "0x1645011A": "",
    "0x1645011B": "",
    "0x1645011C": "",
    "0x1645011D": "",
    "0x1645011E": "",
    "0x1645011F": "",
    "0x16450120": "",
    "0x16450121": "",
    "0x16450122": "",
    "0x16450123": "",
    "0x16450124": "",
    "0x16450125": "",
    "0x16450126": "",
    "0x16450127": "",
    "0x16450128": "",
    "0x16450129": "",
    "0x16461000": "",
    "0x16461001": "",
    "0x16461002": "",
    "0x16461003": "",
    "0x16462001": "",
    "0x16462004": "",
    "0x16462007": "",
    "0x1646200A": "",
    "0x16463001": "",
    "0x16463004": "",
    "0x16463005": "",
    "0x16463006": "",
    "0x16463007": "",
    "0x16463008": "",
    "0x16463009": "",
    "0x1646300A": "",
    "0x1646300B": "",
    "0x16463011": "",
    "0x16463012": "",
    "0x16463013": "",
    "0x16463014": "",
    "0x16463021": "",
    "0x16463022": "",
    "0x16463023": "",
    "0x16463024": "",
    "0x16463031": "",
    "0x16463032": "",
    "0x16463033": "",
    "0x16463034": "",
    "0x16471000": "",
    "0x16471001": "",
    "0x16471002": "",
    "0x16471003": "",
    "0x16471004": "",
    "0x16471005": "",
    "0x16471006": "",
    "0x16471007": "",
    "0x16471010": "",
    "0x16471012": "",
    "0x16471100": "",
    "0x16471101": "",
    "0x16471102": "",
    "0x16471103": "",
    "0x16471201": "",
    "0x16471204": "",
    "0x16471205": "",
    "0x16471207": "",
    "0x16471209": "GNSS positioning information update error",
    "0x16476000": "",
    "0x16476001": "",
    "0x16476002": "",
    "0x16476003": "Vision sensor error. Restart aircraft and try again",
    "0x16476004": "",
    "0x16476005": "",
    "0x16476006": "",
    "0x16476007": "",
    "0x16476008": "",
    "0x16476009": "",
    "0x16476100": "",
    "0x16476101": "",
    "0x16476102": "",
    "0x16476103": "",
    "0x16476104": "",
    "0x16476105": "",
    "0x16476106": "",
    "0x16476107": "",
    "0x16479000": "",
    "0x16479001": "",
    "0x16479002": "",
    "0x16479003": "",
    "0x16479004": "",
    "0x16479005": "",
    "0x16479006": "",
    "0x16479011": "",
    "0x16479012": "",
    "0x16479013": "",
    "0x16479014": "",
    "0x16479015": "",
    "0x16479021": "",
    "0x16479022": "",
    "0x16479031": "",
    "0x16479032": "",
    "0x16479041": "",
    "0x16479051": "",
    "0x16479052": "",
    "0x1647C010": "",
    "0x1647C011": "",
    "0x1647C012": "",
    "0x1647C013": "",
    "0x1647C014": "",
    "0x1647C015": "",
    "0x1647C016": "",
    "0x1647C017": "",
    "0x1647C018": "",
    "0x1647C019": "",
    "0x1647C020": "",
    "0x1647C021": "",
    "0x1647C022": "",
    "0x1647C023": "",
    "0x1647C024": "",
    "0x1647C025": "",
    "0x1647C030": "",
    "0x1647C031": "",
    "0x1647C032": "",
    "0x1647C033": "",
    "0x1647C034": "",
    "0x1647C035": "",
    "0x1647C040": "",
    "0x1647C041": "",
    "0x1647C042": "",
    "0x1647C043": "",
    "0x1647C044": "",
    "0x1647C045": "",
    "0x1647C046": "",
    "0x1647C047": "",
    "0x1647C048": "",
    "0x16490001": "",
    "0x16490002": "",
    "0x16490003": "Vertical altitude error",
    "0x16490004": "",
    "0x16490005": "",
    "0x16490006": "",
    "0x16490007": "",
    "0x16490008": "",
    "0x16490009": "",
    "0x1649000A": "",
    "0x1649000B": "",
    "0x1649000C": "",
    "0x1649000D": "",
    "0x1649000E": "",
    "0x1649000F": "",
    "0x16490010": "",
    "0x16490011": "",
    "0x16493000": "",
    "0x16493100": "",
    "0x16493200": "",
    "0x16493300": "",
    "0x16493400": "",
    "0x16493500": "",
    "0x16493600": "",
    "0x16494000": "",
    "0x16494001": "",
    "0x16494002": "",
    "0x16494003": "",
    "0x16494004": "",
    "0x16494100": "",
    "0x16494101": "",
    "0x16494102": "",
    "0x16494103": "",
    "0x16494104": "",
    "0x16494105": "",
    "0x16494106": "",
    "0x16497100": "",
    "0x16497110": "",
    "0x16497111": "",
    "0x16497112": "",
    "0x16497113": "",
    "0x16497120": "",
    "0x16497121": "",
    "0x16497122": "",
    "0x16497130": "",
    "0x16497131": "",
    "0x16497132": "",
    "0x16497133": "",
    "0x164A1005": "In No Position Hold mode, aircraft is unable to hover stably. It is recommended to switch to Normal mode before flying",
    "0x164A1005_in_the_sky": "In No Position Hold mode, aircraft is unable to hover stably, and flight safety is affected. It is recommended to switch to Normal mode",
    "0x164C0000": "",
    "0x164C0040": "",
    "0x164C0080": "",
    "0x164C00C0": "",
    "0x164C0100": "",
    "0x164C0101": "",
    "0x164C0102": "",
    "0x164C0103": "",
    "0x164C0104": "",
    "0x164C0105": "",
    "0x164C013E": "",
    "0x164C0140": "",
    "0x164C0180": "",
    "0x164C01C0": "",
    "0x164C0200": "",
    "0x164C0240": "",
    "0x164C0241": "",
    "0x164C0242": "",
    "0x164C0243": "",
    "0x164C0244": "",
    "0x164C0245": "",
    "0x164C027E": "",
    "0x164C0280": "",
    "0x164C0281": "",
    "0x164C0282": "",
    "0x164C0283": "",
    "0x164C0284": "",
    "0x164C0285": "",
    "0x164C02BE": "",
    "0x164C02C0": "",
    "0x164C0300": "",
    "0x164C0440": "",
    "0x164C04BE": "",
    "0x164C04FE": "",
    "0x164C053E": "",
    "0x164C057E": "",
    "0x164C05BE": "",
    "0x164C05FE": "",
    "0x164C0600": "",
    "0x164C0640": "",
    "0x164C0680": "",
    "0x164C06C0": "",
    "0x164C0700": "",
    "0x164C0740": "",
    "0x164C0780": "",
    "0x164C07C0": "",
    "0x164C0800": "",
    "0x164C0840": "",
    "0x164C0940": "",
    "0x164C09C0": "",
    "0x164C0A40": "",
    "0x164C0B00": "",
    "0x164C0BC0": "",
    "0x164C0C00": "",
    "0x164C0C40": "",
    "0x164C0C80": "",
    "0x164C0CC0": "",
    "0x164C0D40": "",
    "0x164C0D80": "",
    "0x164C0E80": "",
    "0x164C0EC0": "",
    "0x164C0ED0": "",
    "0x164C0F40": "",
    "0x164C0F80": "",
    "0x164C0d00": "",
    "0x164D0000": "",
    "0x164D0001": "",
    "0x164D0002": "",
    "0x164D0003": "",
    "0x164D0004": "",
    "0x164D0005": "",
    "0x164D0006": "",
    "0x164D0040": "",
    "0x164D0041": "",
    "0x164D0042": "",
    "0x164D0043": "",
    "0x164D0044": "",
    "0x164D0045": "",
    "0x164D0046": "",
    "0x164D0080": "",
    "0x164D0081": "",
    "0x164D0082": "",
    "0x164D0083": "",
    "0x164D0084": "",
    "0x164D0085": "",
    "0x164D0086": "",
    "0x164D0087": "",
    "0x164D0088": "",
    "0x164D0089": "",
    "0x164D008A": "",
    "0x164D008B": "",
    "0x164D008C": "",
    "0x164D008D": "",
    "0x164D008E": "",
    "0x164DFFF1": "",
    "0x164DFFF2": "",
    "0x164DFFF3": "",
    "0x164DFFF4": "",
    "0x164a0001": "",
    "0x164a0002": "",
    "0x164a0003": "",
    "0x164a0004": "",
    "0x164a0005": "",
    "0x164a1001": "",
    "0x164a1002": "",
    "0x164a1003": "",
    "0x164a1004": "",
    "0x16670000": "No power lines identified ahead. Power Line Follow task ended",
    "0x16670001": "Home Point not set. Check and update Home Point",
    "0x16670002": "GNSS signal weak. Power Line Follow task stopped",
    "0x16670003": "Power Line Follow in progress. Stop task and try again",
    "0x16670004": "Power Line Follow not supported by current payload type",
    "0x16670005": "GNSS signal weak. Power Line Follow task stopped",
    "0x16670006": "Remote controller signal lost. Power Line Follow task stopped",
    "0x16670007": "Power Line Follow not supported in S mode. Switch to N mode",
    "0x16670101": "Too close to obstacle. Power Line Follow task stopped",
    "0x16670102": "Approaching ground. Power Line Follow task stopped",
    "0x16670103": "Approaching Altitude Zone. Power Line Follow task stopped",
    "0x16670104": "Reaching max flight distance. Power Line Follow task stopped",
    "0x16670105": "Approaching GEO Zone. Power Line Follow task stopped",
    "0x16670106": "Approaching Altitude Zone. Power Line Follow task stopped",
    "0x16670107": "Identifying power lines...",
    "0x16670108": "Identifying power lines...",
    "0x16670201": "Payload communication link error. Power Line Follow task stopped",
    "0x16670202": "LiDAR communication link error. Power Line Follow task stopped",
    "0x16670203": "Error in receiving point cloud data. Power Line Follow task stopped",
    "0x16670204": "Point cloud recording stopped. Power Line Follow task stopped",
    "0x16670205": "Storage full. Free up storage space before performing task",
    "0x16670301": "Flight speed of Power Line Follow exceeds limit. Confirm settings",
    "0x16670302": "Flight altitude of Power Line Follow exceeds limit. Confirm settings",
    "0x16670303": "Gimbal tilt angle exceeds limit. Confirm settings",
    "0x16670304": "Failed to identify power lines. Try again",
    "0x16670305": "Failed to identify power lines. Try again",
    "0x16670401": "Failed to recenter gimbal. Try again",
    "0x16670402": "Failed to set gimbal tilt angle. Try again",
    "0x16670403": "Failed to start recording point cloud. Try again",
    "0x16670501": "Power Line Follow task ended",
    "0x16670502": "Aircraft returning to home or landing. Power Line Follow task stopped",
    "0x16670503": "Too close to crewed aircraft. Power Line Follow task stopped",
    "0x16670504": "Power Line Follow task stopped",
    "0x16670505": "Failed to obtain camera view. Power Line Follow task stopped",
    "0x16670506": "Failed to calibrate IMU. Try again",
    "0x17000001": "Primary image transmission disconnected",
    "0x17000001_in_the_sky": "Primary image transmission disconnected. Adjust antennas",
    "0x17000002": "Remote controller signal weak. Adjust antennas",
    "0x17000002_in_the_sky": "Remote controller signal weak. Adjust antennas",
    "0x17000003": "Strong signal interference in aircraft location. Fly with caution",
    "0x17000003_in_the_sky": "Strong signal interference in aircraft location. Fly with caution",
    "0x17000004": "Image transmission signal weak. Adjust antennas",
    "0x17000004_in_the_sky": "Image transmission signal weak. Adjust antennas",
    "0x17000005": "Strong signal interference in remote controller location. Fly with caution",
    "0x17000005_in_the_sky": "Strong signal interference in remote controller location. Fly with caution",
    "0x17000006": "Country code not updated. Certain features unavailable. Make sure GNSS signal is good and connect to DJI Pilot to update automatically",
    "0x17000006_in_the_sky": "Country code not updated. Certain features unavailable",
    "0x17000011": "Avionics system memory insufficient. Restart aircraft to restore",
    "0x17000011_in_the_sky": "Avionics system memory insufficient. Fly with caution",
    "0x17000013": "Remote controller signal interference",
    "0x17000014": "Strong remote controller signal interference. Move away from other remote controllers or source of interference",
    "0x17000015": "Strong aircraft signal interference. Return to home promptly or move away from source of interference",
    "0x17000016": "Remote controller signal weak. Adjust antenna",
    "0x17000017": "Controller A signal weak. Make sure antennas of Controller A are unfolded and no obstacle is blocking aircraft and remote controller",
    "0x17000018": "Controller B signal weak. Make sure antennas of controller B are unfolded and no obstacle is blocking aircraft and remote controller",
    "0x17000019": "Camera error. Detach and remount gimbal",
    "0x1700001A": "Weak signal between remote controller and relay. Move remote controller or relay",
    "0x1700001B": "Weak signal between relay and aircraft. Move relay or aircraft",
    "0x1700001C": "Strong signal interference at relay site. Fly with caution",
    "0x17000041": "Unable to get control stick input",
    "0x17000071": "Avionics system overloaded. Check whether logs are being transmitted. Restart aircraft to restore",
    "0x17000071_in_the_sky": "Avionics system overloaded. Fly with caution",
    "0x17000081": "Avionics system memory insufficient. Restart aircraft to restore",
    "0x17000081_in_the_sky": "Avionics system memory insufficient. Fly with caution",
    "0x17010021": "Flight controller error. Return to home promptly",
    "0x17110041": "Unable to obtain control stick input",
    "0x17110041_in_the_sky": "Control stick input error. Fly with caution and land promptly",
    "0x17200020": "Winch system motor stalled",
    "0x17200022": "Winch system motor overloaded",
    "0x1720002B": "Winch system ESC overheated",
    "0x1720002C": "Winch system ESC voltage too high",
    "0x1720002D": "Winch system ESC voltage too low",
    "0x1720002F": "Winch system ESC or motor auto-check error",
    "0x17200030": "Winch system ESC or motor auto-check error",
    "0x17200031": "Winch system ESC or motor auto-check error",
    "0x17200032": "Winch system ESC or motor auto-check error",
    "0x17200033": "Winch system ESC or motor auto-check error",
    "0x17200034": "Winch system ESC or motor auto-check error",
    "0x17200035": "Winch system ESC or motor auto-check error",
    "0x17200036": "Winch system ESC auto-check error",
    "0x17200037": "Winch system ESC auto-check error",
    "0x17200038": "Winch system ESC auto-check error",
    "0x17200039": "Winch system ESC auto-check error",
    "0x1720003A": "Winch system ESC auto-check error",
    "0x1720003B": "Winch system ESC auto-check error",
    "0x1720003C": "Winch system ESC or motor auto-check error",
    "0x1720003D": "Winch system ESC or motor auto-check error",
    "0x1720003E": "Winch system ESC or motor auto-check error",
    "0x1720003F": "Winch system ESC or motor auto-check error",
    "0x17200040": "Winch system ESC auto-check error",
    "0x17200041": "Winch system ESC auto-check error",
    "0x17200042": "Winch system ESC auto-check error",
    "0x17200043": "Winch system ESC auto-check error",
    "0x17200044": "Winch system ESC voltage too low",
    "0x17200045": "Winch system ESC voltage too high",
    "0x17200046": "Winch system ESC or motor auto-check error",
    "0x17200047": "Winch system ESC or motor auto-check error",
    "0x17200048": "Winch system ESC or motor auto-check error",
    "0x17200049": "Winch system ESC auto-check error",
    "0x1720004A": "Winch system ESC overheated",
    "0x1720004B": "Winch system ESC temperature too low",
    "0x1720004C": "Winch system ESC auto-check error",
    "0x1720004D": "Winch system ESC auto-check error",
    "0x1720004E": "Winch system ESC auto-check error",
    "0x17200055": "Winch system motor may be overheated. Do not quickly reel up and down when aircraft is loaded",
    "0x17200056": "Winch system motor severely overheated. Aircraft will land automatically",
    "0x17200058": "Winch system ESC speed and current error",
    "0x1720005D": "Winch system ESC auto-check error",
    "0x1720005E": "Winch system ESC auto-check error",
    "0x17200077": "Winch system ESC severely overheated",
    "0x17200078": "Winch system ESC severely overheated",
    "0x17200079": "Winch system ESC firmware incompatible with aircraft model",
    "0x1720007B": "Winch system ESC auto-check error",
    "0x1720007C": "Winch system ESC auto-check error",
    "0x1720007D": "Winch system ESC or motor auto-check error",
    "0x1720007E": "Winch system ESC or motor auto-check error",
    "0x1720007F": "Winch system ESC or motor auto-check error",
    "0x17200080": "Winch system ESC or motor auto-check error",
    "0x17200083": "Winch system ESC calibration failed",
    "0x17200200": "Cable stuck or reversely reeled in. Enable repair mode to manually unwind cable",
    "0x17200201": "Cable cutter of winch system damaged. Replace cable cutter promptly. Otherwise, flight safety will be affected",
    "0x17200201_in_the_sky": "Cable cutter of winch system damaged. Replace cable cutter promptly. Otherwise, flight safety will be affected",
    "0x17200202": "Winch reeling down without payload. Attach payload",
    "0x17200203": "Winch system motor not calibrated. Calibrate motor",
    "0x17200204": "Winch system triaxial force sensor not calibrated. Calibrate sensor",
    "0x17200205": "Winch system cable length not calibrated. Calibrate cable length",
    "0x17200206": "Winch brake hardware damaged. Restart aircraft and try again",
    "0x17200207": "Winch brake auto-check error. Unable to take off",
    "0x17200208": "Winch cable auto-check error. Check if cable is wound in reverse direction or not secure",
    "0x17200209": "Winch limit switch auto-check error. Stop propellers and rotate dial manually. Make sure winch system motor works properly",
    "0x1720020A": "Winch limit switch error. Check if the switch is stuck or damaged",
    "0x17210000": "Parachute sensor error",
    "0x17210001": "Parachute igniter error",
    "0x17210002": "Parachute connection error",
    "0x17210003": "Parachute igniter communication error",
    "0x17210004": "Parachute igniter connection error",
    "0x17210005": "Parachute igniter voltage error",
    "0x17210006": "Parachute igniter resistance error",
    "0x17210007": "Parachute ignition error",
    "0x17210008": "Parachute IMU communication error",
    "0x17210009": "Parachute IMU connection error",
    "0x1721000A": "Parachute barometer communication error",
    "0x1721000B": "Parachute internal storage error",
    "0x1721000C": "Parachute control error",
    "0x1721000D": "Parachute connection error",
    "0x1721000E": "Parachute speed deviation too large",
    "0x1721000F": "Parachute built-in battery voltage too low",
    "0x17210010": "Parachute Built-in Battery Overheated",
    "0x17210011": "Parachute File System Error",
    "0x17210013": "Parachute deployed",
    "0x17210020": "Parachute opened. Watch out for pedestrians nearby",
    "0x19000001": "Avionics system overloaded. Check whether logs are being transmitted. Restart aircraft to restore",
    "0x19000001_in_the_sky": "Avionics system overloaded. Fly with caution",
    "0x19000002": "Avionics system overloaded. Check whether logs are being transmitted. Restart aircraft to restore",
    "0x19000002_in_the_sky": "Avionics system overloaded. Fly with caution",
    "0x19000003": "\u5b58\u5728\u4e1a\u52a1cpu loading\u8d85\u9650",
    "0x19000004": "\u5b58\u5728\u4e1a\u52a1\u5185\u5b58\u8d44\u6e90\u4f7f\u7528\u8d85\u9650",
    "0x19000005": "\u4e2d\u65ad\u9891\u7387\u8fc7\u9ad8",
    "0x19000006": "\u5185\u5b58\u7533\u8bf7\u5931\u8d25",
    "0x19000007": "rt\u8fdb\u7a0bcpu loading\u8fc7\u9ad8",
    "0x19000008": "\u7cfb\u7edf\u5185\u5b58\u4e0d\u8db3",
    "0x19000009": "\u7cfb\u7edf\u5185\u5b58\u4e25\u91cd\u4e0d\u8db3",
    "0x1900000A": "rcu stall\u5f02\u5e38",
    "0x1900000B": "\u8fdb\u7a0b\u957f\u671f\u5904\u4e8eD\u72b6\u6001",
    "0x1900000C": "\u539f\u5b50\u64cd\u4f5c\u5f02\u5e38",
    "0x1900000D": "\u81ea\u65cb\u9501\u64cd\u4f5c\u5f02\u5e38",
    "0x19000011": "Avionics system memory insufficient. Restart aircraft to restore",
    "0x19000011_in_the_sky": "Avionics system memory insufficient. Fly with caution",
    "0x19000012": "Avionics system memory insufficient. Restart aircraft to restore",
    "0x19000012_in_the_sky": "Avionics system memory insufficient. Fly with caution",
    "0x19000020": "camera\u8fdb\u7a0b\u5f02\u5e38\u5d29\u6e83",
    "0x19000021": "Avionics system error. Restart aircraft to restore",
    "0x19000021_in_the_sky": "Avionics system error. Fly with caution",
    "0x19000022": "Avionics system error. Restart aircraft to restore",
    "0x19000022_in_the_sky": "Avionics system error. Fly with caution",
    "0x19000023": "\u76f8\u673a\u9ea6\u514b\u98ce\u8fdb\u7a0b\u5f02\u5e38\u5954\u6e83",
    "0x19000024": "\u76f8\u673a\u8fdb\u7a0b\u5f02\u5e38\u5d29\u6e83",
    "0x19000025": "\u76f8\u673a\u8fdb\u7a0b\u53d1\u751fcrash\uff0c\u8bf7\u62c9\u65e5\u5fd7\u5206\u6790",
    "0x19000026": "\u76f8\u673a\u8fdb\u7a0b\u53d1\u751fcrash\uff0c\u8bf7\u62c9\u65e5\u5fd7\u5206\u6790",
    "0x19000027": "\u76f8\u673a\u8fdb\u7a0b\u53d1\u751fcrash\uff0c\u8bf7\u62c9\u65e5\u5fd7\u5206\u6790",
    "0x19000028": "\u5d4c\u5165\u5f0fdji_sys\u8fdb\u7a0b\u5f02\u5e38\u5d29\u6e83",
    "0x19000029": "\u5d4c\u5165\u5f0f\u65e5\u5fd7\u8fdb\u7a0b\u5f02\u5e38\u5d29\u6e83",
    "0x1900002A": "\u5d4c\u5165\u5f0f\u56fe\u4f20\u8fdb\u7a0b\u5f02\u5e38\u5d29\u6e83",
    "0x1900002B": "\u5d4c\u5165\u5f0f\u8fdb\u7a0b\u5f02\u5e38\u5d29\u6e83",
    "0x1900002C": "\u5d4c\u5165\u5f0f\u8fdb\u7a0bdji_gateway\u5f02\u5e38\u5d29\u6e83",
    "0x1900002D": "\u8fdb\u7a0b\u53d1\u751fcrash\uff0c\u8bf7\u62c9\u65e5\u5fd7\u5206\u6790",
    "0x1900002E": "\u8fdb\u7a0b\u53d1\u751fcrash\uff0c\u8bf7\u62c9\u65e5\u5fd7\u5206\u6790",
    "0x1900002F": "\u76f8\u673a\u8fdb\u7a0b\u53d1\u751fcrash\uff0c\u8bf7\u62c9\u65e5\u5fd7\u5206\u6790",
    "0x19000030": "\u98de\u884c\u7cfb\u7edf\u611f\u77e5\u8fdb\u7a0b\u5f02\u5e38\u5d29\u6e83",
    "0x19000031": "Unable to take off. Clear data and restart aircraft",
    "0x19000031_in_the_sky": "Restart aircraft after clearing data",
    "0x19000032": "\u98de\u884c\u7cfb\u7edf\u8fdb\u7a0b\u5f02\u5e38\u5d29\u6e83",
    "0x19000033": "\u98de\u884c\u7cfb\u7edfrtk_fusion\u8fdb\u7a0b\u5f02\u5e38\u5d29\u6e83",
    "0x19000034": "CRobot\u8fdb\u7a0b\u5f02\u5e38\u5d29\u6e83",
    "0x19000035": "\u8fdb\u7a0b\u53d1\u751fcrash\uff0c\u8bf7\u62c9\u65e5\u5fd7\u5206\u6790",
    "0x19000036": "\u673a\u5668\u5b66\u4e60\u8fdb\u7a0b\u5f02\u5e38\u5d29\u6e83",
    "0x19000037": "\u8fdb\u7a0b\u53d1\u751fcrash\uff0c\u8bf7\u62c9\u65e5\u5fd7\u5206\u6790",
    "0x19000038": "\u8fdb\u7a0b\u53d1\u751fcrash\uff0c\u8bf7\u62c9\u65e5\u5fd7\u5206\u6790",
    "0x19000039": "\u7535\u6c60\u8fdb\u7a0b\u5f02\u5e38\u5d29\u6e83",
    "0x1900003A": "\u8fdb\u7a0b\u53d1\u751fcrash\uff0c\u8bf7\u62c9\u65e5\u5fd7\u5206\u6790",
    "0x1900003B": "\u8fdb\u7a0b\u53d1\u751fcrash\uff0c\u8bf7\u62c9\u65e5\u5fd7\u5206\u6790",
    "0x1900003C": "\u6fc0\u5149\u96f7\u8fbe\u8fdb\u7a0b\u8fdb\u7a0b\u5f02\u5e38\u5d29\u6e83",
    "0x1900003D": "\u8fdb\u7a0b\u53d1\u751fcrash\uff0c\u8bf7\u62c9\u65e5\u5fd7\u5206\u6790",
    "0x1900003E": "System panic",
    "0x1900003F": "\u8fdb\u7a0b\u5f02\u5e38\u5d29\u6e83",
    "0x19000041": "USB connection detected. Unable to take off. Disconnect USB cable and restart aircraft",
    "0x19000041_in_the_sky": "USB connection detected. Fly with caution and land promptly",
    "0x19000042": "Unable to take off. Clear data and restart aircraft",
    "0x19000042_in_the_sky": "Restart aircraft after clearing data",
    "0x19000051": "Firmware updating. Unable to take off. Wait for update to complete",
    "0x19000051_in_the_sky": "Firmware updating. Fly with caution and land promptly",
    "0x19000060": "Selinux permission check error",
    "0x19000061": "Selinux permission check errors",
    "0x19000070": "File system error. File may be damaged or storage card may be removed. Remove and insert storage card or format storage card",
    "0x190003ED": "dji_wlm_slave cpu loading\u8d85\u9650",
    "0x190003EE": "logd loading \u8d85\u9650",
    "0x190003EF": "dji_autoflight cpu loading \u8d85\u9650",
    "0x190003F1": "dji_sdrs_agent cpu loading \u8d85\u9650",
    "0x190003F2": "dji_lte cpu loading\u8d85\u9650",
    "0x190003F3": "dji_wlm cpu loading\u8d85\u9650",
    "0x190003F5": "dji_nn_server loading\u8d85\u9650",
    "0x190003F6": "dji_ml cpu loading\u8d85\u9650",
    "0x190003F9": "dji_media_server cpu loading \u8d85\u9650",
    "0x190003FB": "dji_rcam cpu loading  \u8d85\u9650",
    "0x190003FC": "dji_camera cpu loading\u8d85\u9650",
    "0x190003FD": "dji_perception cpu loading\u8d85\u9650",
    "0x190003FE": "dji_blackbox loading\u8d85\u9650",
    "0x190003FF": "dji_sys loading\u8d85\u9650",
    "0x19000400": "SD\u5f02\u5e38",
    "0x19000700": "File system error. File may be damaged or storage card may be removed. Remove and insert storage card or format storage card",
    "0x19000701": "\u78c1\u76d8\u626b\u63cf\u5f02\u5e38",
    "0x19000702": "File system error",
    "0x19000703": "SD card not recommended. User experience may be\r\n affected",
    "0x19000800": "Aircraft fan %index error. Check whether fan is stalled",
    "0x19000801": "Camera fan error. Check whether fan is stalled",
    "0x19000802": "Camera processor overheated. Wait for camera processor to cool down before use",
    "0x19000803": "Camera overheated. Recording will stop soon. Wait for camera to cool down before use",
    "0x19000810": "Aircraft in low-power state",
    "0x19000811": "Air unit in low-power state",
    "0x19000C00": "Connection error between avionics board and radio frequency board. Downward radar and video transmission performance may be affected",
    "0x1900A001": "Flight termination system unable to connect to server. Unable to send flight termination command. Check DJI Cellular Dongle of aircraft",
    "0x1900A002": "Flight termination triggered. Flight terminated or aircraft unable to take off",
    "0x1900E001": "Log storage space insufficient. Logs may not be able to be stored",
    "0x1900E002": "Log data missing",
    "0x1900E003": "Log data missing",
    "0x1900E004": "Storage device mounting error",
    "0x1900F001": "Goggles only support motion controller",
    "0x19010002": "Third-party payload authentication failed. Restart aircraft and use official payload",
    "0x19018001": "System in factory mode",
    "0x1901C080": "Current aircraft does not support working with both Zenmuse L2 and H30 series. Use one of the payloads separately",
    "0x1901C081": "Current aircraft does not support working with more than one Zenmuse H30 series payload. Use one of the payloads separately",
    "0x1901C082": "Current aircraft does not support working with more than one Zenmuse L2 payload. Use one of the payloads separately",
    "0x19100041": "Livestream network connection unavailable",
    "0x19100041_in_the_sky": "No livestream network connection",
    "0x19100042": "Livestream registration password error",
    "0x19100042_in_the_sky": "Incorrect livestream registration password",
    "0x19100043": "Livestream registration timed out",
    "0x19100043_in_the_sky": "Livestream registration timed out",
    "0x19100044": "Livestream channel %d connection failed",
    "0x19100044_in_the_sky": "Failed to connect to livestream channel %d",
    "0x19100045": "Livestream channel %d URL parameter format error",
    "0x19100045_in_the_sky": "Livestream channel %d URL parameter format error",
    "0x19100051": "Selecting livestream channel %d timed out",
    "0x19100051_in_the_sky": "Livestream channel %d timed out",
    "0x19100052": "Selecting livestream channel %d. Parameters error",
    "0x19100052_in_the_sky": "Livestream channel %d parameter error",
    "0x19100053": "Selecting livestream channel %d received no response",
    "0x19100053_in_the_sky": "Livestream channel %d timed out",
    "0x19100054": "\u5220\u9664",
    "0x19100054_in_the_sky": "Livestream channel %d timed out",
    "0x19100055": "Livestream channel %d successfully selected. No streaming data",
    "0x19100055_in_the_sky": "Livestream channel %d connected. No streaming data yet",
    "0x19100056": "Livestream channel %d bit rate error",
    "0x19100056_in_the_sky": "Livestream channel %d bit rate error",
    "0x19100057": "Livestream channel %d frame rate error",
    "0x19100057_in_the_sky": "Livestream channel %d frame rate error",
    "0x19100058": "Livestream channel %d data sending error",
    "0x19100058_in_the_sky": "Failed to send livestream channel %d data",
    "0x19100071": "Livestream channel %d losing data packet",
    "0x19100071_in_the_sky": "Livestream channel %d packet loss",
    "0x19100072": "Livestream channel %d experiencing high network latency",
    "0x19100072_in_the_sky": "Network latency on livestream channel %d",
    "0x19100073": "Livestream channel %d experiencing high network jitter",
    "0x19100073_in_the_sky": "Network jitter on livestream channel %d",
    "0x19100074": "Livestream channel %d experiencing network congestion",
    "0x19100074_in_the_sky": "Network congestion on livestream channel %d",
    "0x19100081": "Livestream metadata transfer frequency error",
    "0x19100081_in_the_sky": "Livestream metadata transfer frequency error",
    "0x19100082": "Livestream unable to get metadata",
    "0x19100082_in_the_sky": "Failed to send metadata",
    "0x19100083": "Livestream unable to get aircraft location",
    "0x19100083_in_the_sky": "Failed to send aircraft location info",
    "0x19117042": "",
    "0x19117100": "",
    "0x19117121": "",
    "0x19117200": "",
    "0x19117300": "",
    "0x19117420": "",
    "0x19117440": "",
    "0x19200001": "Payload system CPU usage too high. Restart aircraft to restore",
    "0x19200001_in_the_sky": "Payload system CPU usage too high. Camera tasks may be affected",
    "0x19200011": "Payload system memory low. Restart aircraft to restore",
    "0x19200011_in_the_sky": "Payload system low on memory. Camera tasks may be affected",
    "0x19200021": "Payload system error. Restart aircraft to restore",
    "0x19200021_in_the_sky": "Payload system error. Camera tasks may be affected",
    "0x1A010004": "",
    "0x1A010007": "System in factory mode. Contact DJI Support",
    "0x1A010040": "Bottom (left) vision sensor connection error. Restart aircraft",
    "0x1A010040_in_the_sky": "Bottom (left) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
    "0x1A010041": "Bottom (right) vision sensor connection error. Restart aircraft",
    "0x1A010041_in_the_sky": "Bottom (right) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
    "0x1A010042": "Front (left) vision sensor connection error. Restart aircraft",
    "0x1A010042_in_the_sky": "Front (left) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
    "0x1A010043": "Front (right) vision sensor connection error. Restart aircraft",
    "0x1A010043_in_the_sky": "Front (right) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
    "0x1A010044": "Back (left) vision sensor connection error. Restart aircraft",
    "0x1A010044_in_the_sky": "Back (left) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
    "0x1A010045": "Back (right) vision sensor connection error. Restart aircraft",
    "0x1A010045_in_the_sky": "Back (right) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
    "0x1A010046": "Top (left) vision sensor connection error. Restart aircraft",
    "0x1A010046_in_the_sky": "Top (left) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
    "0x1A010047": "Top (right) vision sensor connection error. Restart aircraft",
    "0x1A010047_in_the_sky": "Top (right) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
    "0x1A010048": "Side (back left) vision sensor connection error. Restart aircraft",
    "0x1A010048_in_the_sky": "Side (back left) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
    "0x1A010049": "Side (front left) vision sensor connection error. Restart aircraft",
    "0x1A010049_in_the_sky": "Side (front left) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
    "0x1A01004A": "Side (front right) vision sensor connection error. Restart aircraft",
    "0x1A01004A_in_the_sky": "Side (front right) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
    "0x1A01004B": "Side (back right) vision sensor connection error. Restart aircraft",
    "0x1A01004B_in_the_sky": "Side (back right) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
    "0x1A010080": "Bottom (left) vision sensor connection error. Restart aircraft",
    "0x1A010080_in_the_sky": "Bottom (left) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A010081": "Bottom (right) vision sensor connection error. Restart aircraft",
    "0x1A010081_in_the_sky": "Bottom (right) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A010082": "Front (left) vision sensor connection error. Restart aircraft",
    "0x1A010082_in_the_sky": "Front (left) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A010083": "Front (right) vision sensor connection error. Restart aircraft",
    "0x1A010083_in_the_sky": "Front (right) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A010084": "Back (left) vision sensor connection error. Restart aircraft",
    "0x1A010084_in_the_sky": "Back (left) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A010085": "Back (right) vision sensor connection error. Restart aircraft",
    "0x1A010085_in_the_sky": "Back (right) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A010086": "Top (left) vision sensor connection error. Restart aircraft",
    "0x1A010086_in_the_sky": "Top (left) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A010087": "Top (right) vision sensor connection error. Restart aircraft",
    "0x1A010087_in_the_sky": "Top (right) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A010088": "Side (back left) vision sensor connection error. Restart aircraft",
    "0x1A010088_in_the_sky": "Side (back right) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A010089": "Side (front left) vision sensor connection error. Restart aircraft",
    "0x1A010089_in_the_sky": "Side (front left) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A01008A": "Side (front right) vision sensor connection error. Restart aircraft",
    "0x1A01008A_in_the_sky": "Side (front right) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A01008B": "Side (back right) vision sensor connection error. Restart aircraft",
    "0x1A01008B_in_the_sky": "Side (back right) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A0100C0": "Bottom (left) vision sensor connection error. Restart sensor",
    "0x1A0100C0_in_the_sky": "Bottom (left) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A0100C1": "Bottom (right) vision sensor connection error. Restart sensor",
    "0x1A0100C1_in_the_sky": "Bottom (right) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A0100C2": "Front (left) vision sensor connection error. Restart sensor",
    "0x1A0100C2_in_the_sky": "Front (left) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A0100C3": "Front (right) vision sensor connection error. Restart sensor",
    "0x1A0100C3_in_the_sky": "Front (right) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A0100C4": "Back (left) vision sensor connection error. Restart sensor",
    "0x1A0100C4_in_the_sky": "Back (left) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A0100C5": "Back (right) vision sensor connection error. Restart sensor",
    "0x1A0100C5_in_the_sky": "Back (right) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A0100C6": "Top (left) vision sensor connection error. Restart sensor",
    "0x1A0100C6_in_the_sky": "Top (left) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A0100C7": "Top (right) vision sensor connection error. Restart sensor",
    "0x1A0100C7_in_the_sky": "Back (right) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A0100C8": "Side (back left) vision sensor connection error. Restart sensor",
    "0x1A0100C8_in_the_sky": "Side (back left) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A0100C9": "Side (front left) vision sensor connection error. Restart sensor",
    "0x1A0100C9_in_the_sky": "Side (front left) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A0100CA": "Side (front right) vision sensor connection error. Restart sensor",
    "0x1A0100CA_in_the_sky": "Side (front right) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A0100CB": "Side (back right) vision sensor connection error. Restart sensor",
    "0x1A0100CB_in_the_sky": "Side (back right) vision sensor connection error. Fly with caution. Return to home or land",
    "0x1A0100F0": "",
    "0x1A011340": "Vision system calibration error",
    "0x1A011341": "Vision system calibration error",
    "0x1A011342": "Vision system calibration error",
    "0x1A011343": "Vision system calibration error",
    "0x1A011344": "Vision system calibration error",
    "0x1A011345": "Vision system calibration error",
    "0x1A011346": "Vision system calibration error",
    "0x1A011347": "Vision system calibration error",
    "0x1A011348": "Vision system calibration error",
    "0x1A011349": "Vision system calibration error",
    "0x1A01134A": "Vision system calibration error",
    "0x1A01134B": "Vision system calibration error",
    "0x1A020040": "Bottom infrared sensor connection error. Restart aircraft",
    "0x1A020040_in_the_sky": "Bottom infrared sensor connection error. Return to home or land. Pay attention to the landing speed",
    "0x1A020041": "Front infrared sensor connection error. Restart aircraft",
    "0x1A020041_in_the_sky": "Front infrared sensor connection error. Fly with caution. Return to home or land",
    "0x1A020042": "Right infrared sensor connection error. Restart aircraft",
    "0x1A020042_in_the_sky": "Right infrared sensor connection error. Fly with caution. Return to home or land",
    "0x1A020043": "Back infrared sensor connection error. Restart aircraft",
    "0x1A020043_in_the_sky": "Back infrared sensor connection error. Fly with caution. Return to home or land",
    "0x1A020044": "Left infrared sensor connection error. Restart aircraft",
    "0x1A020044_in_the_sky": "Left infrared sensor connection error. Fly with caution. Return to home or land",
    "0x1A020045": "Top infrared sensor connection error. Restart aircraft",
    "0x1A020045_in_the_sky": "Top infrared sensor connection error. Fly with caution. Return to home or land",
    "0x1A020080": "Bottom infrared sensor connection error. Restart aircraft",
    "0x1A020080_in_the_sky": "Bottom infrared sensor connection error. Return to Home or land. Pay attention to the landing speed",
    "0x1A020081": "Front infrared sensor connection error. Restart aircraft",
    "0x1A020081_in_the_sky": "Front infrared sensor connection error. Fly with caution. Return to home or land",
    "0x1A020082": "Right infrared sensor connection error. Restart aircraft",
    "0x1A020082_in_the_sky": "Right infrared sensor connection error. Fly with caution. Return to home or land",
    "0x1A020083": "Back infrared sensor connection error. Restart aircraft",
    "0x1A020083_in_the_sky": "Back infrared sensor connection error. Fly with caution. Return to home or land",
    "0x1A020084": "Left infrared sensor connection error. Restart aircraft",
    "0x1A020084_in_the_sky": "Left infrared sensor connection error. Fly with caution. Return to home or land",
    "0x1A020085": "Top infrared sensor connection error. Restart aircraft",
    "0x1A020085_in_the_sky": "Top infrared sensor connection error. Fly with caution. Return to home or land",
    "0x1A0200C0": "Downward Infrared Sensor Connection Error",
    "0x1A0200C0_in_the_sky": "Bottom infrared sensor connection error. Return to home or land. Pay attention to the landing speed",
    "0x1A0200C1": "Forward infrared sensor connection error",
    "0x1A0200C1_in_the_sky": "Front infrared sensor connection error. Return to home or land",
    "0x1A0200C2": "Right infrared sensor connection error",
    "0x1A0200C2_in_the_sky": "Right infrared sensor connection error. Return to home or land",
    "0x1A0200C3": "Backward infrared sensor connection error",
    "0x1A0200C3_in_the_sky": "Back infrared sensor connection error. Return to home or land",
    "0x1A0200C4": "Left infrared sensor connection error",
    "0x1A0200C4_in_the_sky": "Left infrared sensor connection error. Return to home or land",
    "0x1A0200C5": "Upward infrared sensor connection error",
    "0x1A0200C5_in_the_sky": "Top infrared sensor connection error. Return to home or land",
    "0x1A020100": "Downward infrared\u00a0sensor calibration error",
    "0x1A020101": "Forward infrared\u00a0sensor calibration error",
    "0x1A020102": "Right infrared\u00a0sensor calibration error",
    "0x1A020103": "Backward infrared\u00a0sensor calibration error",
    "0x1A020104": "Left infrared\u00a0sensor calibration error",
    "0x1A020105": "Upward infrared\u00a0sensor calibration error",
    "0x1A020140": "Infrared sensors blocked",
    "0x1A020180": "Infrared sensors overheated. Return to home or land promptly. Move away from high-temperature environment",
    "0x1A020400": "Low visibility. Fly with caution",
    "0x1A030040": "Bottom infrared sensor connection error. Restart aircraft",
    "0x1A030040_in_the_sky": "Bottom infrared sensor connection error. Return to home or land. Pay attention to the landing speed",
    "0x1A030041": "Front infrared sensor connection error. Restart aircraft",
    "0x1A030041_in_the_sky": "Front infrared sensor connection error. Return to home or land",
    "0x1A030042": "Back infrared sensor connection error. Restart aircraft",
    "0x1A030042_in_the_sky": "Back infrared sensor connection error. Return to home or land",
    "0x1A030043": "Top infrared sensor connection error. Restart aircraft",
    "0x1A030043_in_the_sky": "Top infrared sensor connection error. Return to home or land",
    "0x1A030044": "Left infrared sensor connection error. Restart aircraft",
    "0x1A030044_in_the_sky": "Left infrared sensor connection error. Return to home or land",
    "0x1A030045": "Right infrared sensor connection error. Restart aircraft",
    "0x1A030045_in_the_sky": "Right infrared sensor connection error. Return to home or land",
    "0x1A030080": "Bottom infrared sensor connection error. Restart aircraft",
    "0x1A030080_in_the_sky": "Bottom infrared sensor connection error. Pay attention to the landing speed. Return to home or land",
    "0x1A030081": "Front infrared sensor connection error. Restart aircraft",
    "0x1A030081_in_the_sky": "Front infrared sensor connection error. Return to home or land",
    "0x1A030082": "Back infrared sensor connection error. Restart aircraft",
    "0x1A030082_in_the_sky": "Back infrared sensor connection error. Return to home or land",
    "0x1A030083": "Top infrared sensor connection error. Restart aircraft",
    "0x1A030083_in_the_sky": "Top infrared sensor connection error. Return to home or land",
    "0x1A030084": "Left infrared sensor connection error. Restart aircraft",
    "0x1A030084_in_the_sky": "Left infrared sensor connection error. Return to home or land",
    "0x1A030085": "Right infrared sensor connection error. Restart aircraft",
    "0x1A030085_in_the_sky": "Right infrared sensor connection error. Return to home or land",
    "0x1A030180": "Bottom infrared sensor connection error. Restart aircraft",
    "0x1A030180_in_the_sky": "Bottom infrared sensor connection error. Pay attention to the landing speed. Return to home or land",
    "0x1A030181": "Front infrared sensor connection error. Restart aircraft",
    "0x1A030181_in_the_sky": "Front infrared sensor connection error. Return to home or land",
    "0x1A030182": "Back infrared sensor connection error. Restart aircraft",
    "0x1A030182_in_the_sky": "Back infrared sensor connection error. Return to home or land",
    "0x1A030183": "",
    "0x1A030184": "",
    "0x1A030185": "",
    "0x1A0301C0": "",
    "0x1A0301C1": "",
    "0x1A0301C2": "",
    "0x1A0301C3": "",
    "0x1A0301C4": "",
    "0x1A0301C5": "",
    "0x1A040001": "Power mode error. Restart aircraft",
    "0x1A050040": "Obstacle sensing error. Fly with caution",
    "0x1A050041": "Obstacle sensing error. Fly with caution",
    "0x1A050042": "Obstacle sensing error. Fly with caution",
    "0x1A050043": "Obstacle sensing error. Fly with caution",
    "0x1A060041": "",
    "0x1A060042": "",
    "0x1A060043": "",
    "0x1A060080": "",
    "0x1A060081": "",
    "0x1A060082": "",
    "0x1A060083": "",
    "0x1A0600C0": "",
    "0x1A0600C1": "",
    "0x1A0600C2": "",
    "0x1A0600C3": "",
    "0x1A080080": "",
    "0x1A080081": "",
    "0x1A080082": "",
    "0x1A080083": "",
    "0x1A080084": "",
    "0x1A080085": "",
    "0x1A090043": "Upward LiDAR connection error. Fly with caution",
    "0x1A090043_in_the_sky": "Upward LiDAR connection error. Fly with caution and return to home promptly",
    "0x1A210180": "Sensor system error. Land promptly or fly with caution",
    "0x1A210181": "Sensor system error. Land promptly or fly with caution",
    "0x1A210182": "Sensor system error. Land promptly or fly with caution",
    "0x1A210183": "Sensor system error. Land promptly or fly with caution",
    "0x1A210184": "Sensor system error. Land promptly or fly with caution",
    "0x1A210185": "Sensor system error. Land promptly or fly with caution",
    "0x1A2101C0": "Sensor system error. Restart aircraft",
    "0x1A2101C1": "Sensor system error. Restart aircraft",
    "0x1A2101C2": "Sensor system error. Restart aircraft",
    "0x1A2101C3": "Sensor system error. Restart aircraft",
    "0x1A2101C4": "Sensor system error. Restart aircraft",
    "0x1A2101C5": "Sensor system error. Restart aircraft",
    "0x1A210240": "Bottom vision sensor is blocked. Obstacle avoidance capabilities decreased. Fly with caution",
    "0x1A210241": "Front vision sensor is blocked. Obstacle avoidance capabilities decreased. Fly with caution",
    "0x1A210242": "Back vision sensor is blocked. Obstacle avoidance capabilities decreased. Fly with caution",
    "0x1A210243": "Right-side vision sensor is blocked. Obstacle avoidance capabilities decreased. Fly with caution",
    "0x1A210244": "Left-side vision sensor is blocked. Obstacle avoidance capabilities decreased. Fly with caution",
    "0x1A210245": "Top vision sensor is blocked. Obstacle avoidance capabilities decreased. Fly with caution",
    "0x1A310980": "Vision positioning system error",
    "0x1A310981": "Vision positioning system error",
    "0x1A420040": "Downward obstacle sensing system error",
    "0x1A420041": "Forward obstacle sensing system error",
    "0x1A420042": "Right obstacle sensing system error",
    "0x1A420043": "Backward obstacle sensing system error",
    "0x1A420044": "Left obstacle sensing system error",
    "0x1A420045": "Upward obstacle sensing system error",
    "0x1A420440": "Obstacle sensing system error",
    "0x1A4205C0": "Obstacle sensing system error",
    "0x1A420680": "Obstacle sensing system error",
    "0x1A420BC0": "Downward ambient light too low. Downward obstacle sensing unavailable. Fly with caution",
    "0x1A420BC1": "Forward ambient light too low. Forward obstacle sensing unavailable. Fly with caution",
    "0x1A420BC2": "Backward ambient light too low. Backward obstacle sensing unavailable. Fly with caution",
    "0x1A420BC3": "Right ambient light too low. Right obstacle sensing unavailable. Fly with caution",
    "0x1A420BC4": "Left ambient light too low. Left obstacle sensing unavailable. Fly with caution",
    "0x1A420BC5": "Upward ambient light too low. Upward obstacle sensing unavailable. Fly with caution",
    "0x1A420BC6": "Horizontal ambient light too low. Horizontal obstacle sensing unavailable. Fly with caution",
    "0x1A420C00": "Downward ambient light too bright. Downward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1A420C01": "Forward ambient light too bright. Forward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1A420C02": "Backward ambient light too bright. Backward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1A420C03": "Rightward ambient light too bright. Rightward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1A420C04": "Leftward ambient light too bright. Leftward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1A420C05": "Upward ambient light too bright. Upward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1A420C06": "Horizontal ambient light too bright. Horizontal obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1A420C40": "Downward sensor(s) blocked. Downward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1A420C41": "Forward sensor(s) blocked. Forward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1A420C42": "Backward sensor(s) blocked. Backward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1A420C43": "Rightward sensor(s) blocked. Rightward obstacle avoidance unavailable. Only infrared sensors available.  Fly with caution",
    "0x1A420C44": "Leftward sensor(s) blocked. Leftward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1A420C45": "Upward sensor(s) blocked. Upward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1A420C46": "Obstacle sensing unavailable. Spotlight on. Fly with caution",
    "0x1A420C47": "Obstacle sensing unavailable. Spotlight on. Fly with caution",
    "0x1A420C80": "Downward sensor(s) blurry. Downward obstacle avoidance unavailable. Fly with caution",
    "0x1A420C81": "Forward sensor(s) blurry. Forward obstacle avoidance unavailable. Fly with caution",
    "0x1A420C82": "Backward sensor(s) blurry. Backward obstacle avoidance unavailable. Fly with caution",
    "0x1A420C83": "Right sensor(s) blurry. Rightward obstacle avoidance unavailable. Fly with caution",
    "0x1A420C84": "Left sensor(s) blurry. Leftward obstacle avoidance unavailable. Fly with caution",
    "0x1A420C85": "Upward sensor(s) blurry. Upward obstacle avoidance unavailable. Fly with caution",
    "0x1A420CC0": "Aircraft attitude angle too large. Obstacle avoidance unavailable. Fly with caution",
    "0x1A420D00": "Aircraft attitude angle too large. Landing protection unavailable. Land manually",
    "0x1A420D40": "Aircraft approaching obstacle sensing blind spot and may be unable to detect obstacles. Fly with caution",
    "0x1A421B00": "Vision system disabled. Switched to radar obstacle avoidance. The obstacle avoidance available range will change",
    "0x1A421B40": "",
    "0x1A421B80": "",
    "0x1A430680": "Unstable lighting conditions. Vision system and obstacle sensing may be unavailable. Fly with caution",
    "0x1A510380": "Downward vision sensor calibration error",
    "0x1A510381": "Forward vision sensor calibration error",
    "0x1A510382": "Backward vision sensor calibration error",
    "0x1A510383": "Upward vision sensor calibration error",
    "0x1A510384": "Left vision sensor calibration error",
    "0x1A510385": "Right vision sensor calibration\u00a0error",
    "0x1A5103C0": "Downward vision sensor calibration error",
    "0x1A5103C1": "Forward vision sensor calibration error",
    "0x1A5103C2": "Backward vision sensor calibration error",
    "0x1A5103C3": "Upward vision sensor calibration error",
    "0x1A5103C4": "Left vision sensor calibration error",
    "0x1A5103C5": "Right vision sensor calibration\u00a0error",
    "0x1A5104C0": "Downward obstacle sensing error. Fly with caution",
    "0x1A5104C1": "Forward obstacle sensing error. Fly with caution",
    "0x1A5104C2": "Backward obstacle sensing error. Fly with caution",
    "0x1A5104C3": "Upward obstacle sensing error. Fly with caution",
    "0x1A5104C4": "Left obstacle sensing error. Fly with caution",
    "0x1A5104C5": "Right obstacle sensing error. Fly with caution",
    "0x1A5104C6": "Omnidirectional obstacle sensing error. Fly with caution",
    "0x1A5104C7": "Upward and downward obstacle sensing error. Fly with caution",
    "0x1A680040": "Propeller guards mounted. Obstacle Avoidance unavailable. Flight performance and wind resistance performance reduced",
    "0x1A680080": "Propeller guards removed",
    "0x1A6800D8": "Ambient light too low. Obstacle sensing unavailable. Fly with caution",
    "0x1A6800E8": "Ambient light too bright. Obstacle sensing unavailable. Fly with caution",
    "0x1A6800F7": "Vision sensor may be blocked. Obstacle sensing performance degraded. Fly with caution",
    "0x1A6800F8": "Vision sensor may be blocked. Obstacle sensing unavailable. Fly with caution",
    "0x1A680106": "Vision sensor may be stained. Obstacle sensing performance degraded. Fly with caution",
    "0x1A680107": "Vision sensor may be stained. Obstacle sensing performance degraded. Fly with caution",
    "0x1AFC0040": "",
    "0x1AFD0040": "Sensor system error. Unable to take off. Flight prohibited",
    "0x1AFD0040_in_the_sky": "Sensor system error. Return to home or land promptly",
    "0x1AFE0040": "Vision system overloaded. Fly to open area",
    "0x1B010001": "Navigation system error . Restart aircraft",
    "0x1B010002": "Target Acquisition unavailable with current payload",
    "0x1B010003": "Camera mode error. Smart Track disabled",
    "0x1B010004": "Target too close",
    "0x1B010005": "Target lost. Target Acquisition paused",
    "0x1B010006": "Gimbal not facing flight direction. Fly with caution",
    "0x1B010007": "Target Acquisition paused . Switch to P mode",
    "0x1B010007_n_mode": "Target Acquisition stopped. Switch to N mode",
    "0x1B010008": "Enabling Target Acquisition failed",
    "0x1B010009": "Obstacle detected. Circling stopped. Manually control aircraft to avoid obstacle",
    "0x1B01000A": "GEO Zone nearby. Circling stopped. Manually control aircraft to avoid GEO Zone",
    "0x1B01000B": "Smart Track paused",
    "0x1B01000C": "Target moving too fast. Circling stopped",
    "0x1B01000D": "Unusual target movement. Drag-select target again",
    "0x1B01000E": "GNSS signal weak, and vision positioning unavailable. Aircraft switched to A mode. Control aircraft manually",
    "0x1B01000F": "Target lost. Searching...",
    "0x1B010010": "During Smart Track, you can control gimbals within a certain limit",
    "0x1B010011": "During Smart Track, you can control lens zoom within a certain limit",
    "0x1B010401": "Camera sending data error. Target acquisition stopped. Try again later",
    "0x1B010402": "Camera sending data error. Smart Track stopped. Try again later",
    "0x1B010403": "Camera data sending error. Smart Track paused.",
    "0x1B010404": "Camera sending data error. Smart Track stopped. Try again later",
    "0x1B010405": "Camera sending data error. Smart Track stopped. Try again later",
    "0x1B010406": "Camera sending data error. Smart Track stopped. Try again later",
    "0x1B010407": "Camera sending data error. Smart Track stopped. Try again later",
    "0x1B010408": "Camera sending data error. Smart Track stopped. Try again later",
    "0x1B010801": "DJI Pilot error. Target Acquisition paused. Restart DJI Pilot",
    "0x1B010802": "DJI Pilot error. Smart Track paused. Restart DJI Pilot",
    "0x1B010803": "DJI Pilot error. Smart Track paused. Restart DJI Pilot",
    "0x1B010C01": "Flight Controller data sending error. Target Acquisition paused. Restart aircraft",
    "0x1B010C02": "Flight Controller data sending error. Smart Track paused. Restart aircraft",
    "0x1B010C03": "Flight Controller data sending error. Smart Track paused. Restart aircraft",
    "0x1B011001": "Gimbal data sending error. Target Acquisition paused. Reinstall payload",
    "0x1B011002": "Gimbal data sending error. Smart Track paused. Reinstall payload",
    "0x1B011003": "Gimbal data sending error. Smart Track paused. Reinstall payload",
    "0x1B011801": "Remote controller data sending error. Target Acquisition stopped. Restart RC",
    "0x1B011802": "Remote controller data sending error. Target Acquisition paused. Check connection between RC and aircraft",
    "0x1B030001": "Obstacle detected. RTH stopped. Manually control aircraft to avoid obstacle",
    "0x1B030002": "GEO Zone nearby. RTH stopped. Manually control aircraft to avoid GEO Zone",
    "0x1B030003": "RTH error. Fly aircraft manually",
    "0x1B030004": "Aircraft signal lost. RTH started",
    "0x1B030005": "Enabling RTH Obstacle Check failed. Control aircraft to return to home manually",
    "0x1B030006": "Obstacle avoidance or backlight detected. Press the Pause button on the remote controller to exit RTH and manually control aircraft to return to home",
    "0x1B030007": "Control stick pushed down. Aircraft descending. Aircraft RTH canceled",
    "0x1B030008": "Control stick pushed down. Aircraft flying backward. Aircraft RTH canceled",
    "0x1B03000D": "Positioning poor during RTH. Unable to continue RTH. Manually control aircraft to return to home",
    "0x1B030010": "Approaching or already evening. Setting RTH altitude recommended",
    "0x1B030011": "Failed to fly optimal RTH route. Aircraft returning at preset altitude",
    "0x1B030012": "Aircraft accelerating. Battery draining faster",
    "0x1B030013": "RTH stopped. Control stick moved opposite to flight direction",
    "0x1B030014": "Battery level low. Return to home promptly",
    "0x1B030015": "Home Point in Altitude Zone. Aircraft will return at lower altitude",
    "0x1B030016": "Complex environment. RTH stopped. Manually control aircraft to return to home",
    "0x1B030017": "Unable to return to home due to low battery level. Aircraft may land earlier. Selecting alternate landing site recommended",
    "0x1B030018": "Max flight altitude limit too low. Flight safety during RTH affected",
    "0x1B030019": "Aircraft not flying along route. Safe RTH exited",
    "0x1B03001A": "Vision positioning unavailable. Unable to return to home. Confirm area below is safe and land aircraft manually",
    "0x1B03002B": "Obstacle sensed during RTH. Pay attention to remaining battery level and be prepared to manually control aircraft",
    "0x1B03002C": "",
    "0x1B03002D": "",
    "0x1B03002E": "",
    "0x1B03002F": "",
    "0x1B030030": "Aircraft approaching Dynamic Home Point. RTH exited. Control aircraft manually",
    "0x1B030031": "",
    "0x1B030032": "",
    "0x1B030033": "Aircraft power consumption higher than estimated. Pay attention to remaining battery level and fly safely",
    "0x1B030035": "Laser obstacle sensing unavailable. Pay attention to safety of RTH route",
    "0x1B030036": "Automatic return is not ready. Please manually refresh the return point or manually fly a horizontal distance of over 50 meters after satellite positioning is stable.",
    "0x1B030C02": "GNSS signal weak. RTH accuracy low. It is recommended to manually control aircraft to return to home",
    "0x1B040001": "Focused shooting unavailable with current payload",
    "0x1B040002": "Focused shooting failed . Switched to normal shooting mode",
    "0x1B040003": "AI Spot-Check failed. Switched to normal shooting mode",
    "0x1B040004": "Camera not mounted. Focused shooting failed",
    "0x1B040401": "Camera zoom timed out. AI Spot-Check failed. Try again later",
    "0x1B040402": "Switching shooting modes failed. AI Spot-Check failed. Try again later",
    "0x1B040403": "Camera zoom timed out. AI Spot-Check failed. Try again later",
    "0x1B040801": "Unable to locate focused shooting sample. Reupload flight route",
    "0x1B040802": "Target box parameter error. Readjust target box",
    "0x1B041001": "Gimbal error. Focused shooting failed. Reinstall payload",
    "0x1B050010": "Failed to update Dynamic Home Point. Unable to obtain remote controller positioning info",
    "0x1B050011": "Remote controller positioning info obtained. Updating Dynamic Home Point...",
    "0x1B050012": "Failed to update Dynamic Home Point. Remote controller positioning accuracy low",
    "0x1B050013": "Dynamic Home Point update stopped. Remote controller in Restricted Zone",
    "0x1B050014": "Remote controller not in Restricted Zone. Updating Dynamic Home Point...",
    "0x1B050015": "Home Point update stopped. Remote controller far away from aircraft",
    "0x1B050016": "Failed to update Dynamic Home Point. Unable to obtain remote controller positioning info",
    "0x1B050017": "Failed to update Dynamic Home Point. Remote controller positioning accuracy low",
    "0x1B060001": "Flight speed limited. Firmware update required",
    "0x1B060005": "Aircraft braking. Obstacle sensing failed in current flight direction. Recenter control sticks and move them again to regain control of aircraft",
    "0x1B070001": "Payload exceeds capacity. Reduce payload or adjust flight plan",
    "0x1B070001_in_the_sky": "Payload exceeds capacity. Land promptly and reduce payload",
    "0x1B070002": "Payload weight not evenly distributed. Adjust payload placement",
    "0x1B070002_in_the_sky": "Payload weight not evenly distributed. Land promptly and adjust payload placement",
    "0x1B070003": "Cargo case weight sensor error",
    "0x1B070004": "Weight sensor error. Calibrate cargo case weight sensor",
    "0x1B070005": "Weight sensor error. Calibrate cargo case weight sensor",
    "0x1B070006": "Payload exceeds capacity. Reduce payload or adjust flight plan",
    "0x1B070006_in_the_sky": "Payload exceeds capacity. Land promptly and reduce payload",
    "0x1B070008": "Winch system weight sensor error",
    "0x1B070009": "Weight sensor error. Calibrate winch system weight sensor",
    "0x1B07000A": "Weight sensor error. Calibrate winch system weight sensor",
    "0x1B07000B": "Swing angle too large. Fly with caution",
    "0x1B07000C": "Cable broke. Check payload on winch system",
    "0x1B07000D": "Winch system motor stalled. Check payload on winch system",
    "0x1B07000E": "Winch system motor overheated. Check if payload exceeds capacity",
    "0x1B080001": "Remote ID broadcast error. Failed to obtain remote controller location",
    "0x1B080002": "Remote ID module error. Contact DJI Support",
    "0x1B090001": "Target tracking stopped",
    "0x1B090002": "Target tracking stopped",
    "0x1B090003": "Target tracking stopped",
    "0x1B092C01": "Target identification error",
    "0x1B092C02": "Target identification error",
    "0x1B092C03": "Target identification error",
    "0x1B092C04": "Target identification error",
    "0x1B092C05": "Target identification error",
    "0x1B092C06": "Target identification error",
    "0x1B092C07": "Target identification error",
    "0x1B092C08": "Target identification error",
    "0x1B092C09": "Target identification error",
    "0x1B092C0A": "Target identification error",
    "0x1B092C0B": "Target identification error",
    "0x1B092C0C": "Target identification error",
    "0x1B092C0D": "Target identification error",
    "0x1B092C0E": "Target identification error",
    "0x1B092C0F": "Target identification error",
    "0x1B092C10": "Target identification error",
    "0x1B092C11": "Target identification error",
    "0x1B092C12": "Target identification error",
    "0x1B092C13": "Target identification error",
    "0x1B092C14": "Target identification error",
    "0x1B092C15": "Target identification error",
    "0x1B092C16": "Enabling Smart Track failed. Check and try again",
    "0x1B092C17": "Enabling Smart Track failed. Check and try again",
    "0x1B092C18": "Enabling Smart Track failed. Check and try again",
    "0x1B092C19": "Enabling Smart Track failed. Check and try again",
    "0x1B092C1A": "Enabling Smart Track failed. Check and try again",
    "0x1B092C1B": "Enabling Smart Track failed. Check and try again",
    "0x1B092C1C": "Enabling Smart Track failed. Check and try again",
    "0x1B092C1D": "Enabling Smart Track failed. Check and try again",
    "0x1B092C1E": "Enabling Smart Track failed. Check and try again",
    "0x1B092C1F": "Enabling Smart Track failed. Check and try again",
    "0x1B092C20": "Enabling Smart Track failed. Ensure selected target is valid",
    "0x1B092C21": "Enabling Smart Track failed. Check and try again",
    "0x1B092C22": "Enabling Smart Track failed. Reduce selected area",
    "0x1B092C23": "Enabling Smart Track failed. Increase selected area",
    "0x1B092C24": "Enabling Smart Track failed. Ensure selected target is valid",
    "0x1B092C25": "Enabling Smart Track failed. Check and try again",
    "0x1B092C26": "Enabling Smart Track failed. Check and try again",
    "0x1B093001": "Enabling Smart Track failed. Check and try again",
    "0x1B093002": "Enabling Smart Track failed. Check and try again",
    "0x1B093003": "Enabling Smart Track failed. Check and try again",
    "0x1B093004": "Enabling Smart Track failed. Check and try again",
    "0x1B093005": "Enabling Smart Track failed. Check and try again",
    "0x1B093006": "Enabling Smart Track failed. Check and try again",
    "0x1B093007": "Enabling Smart Track failed. Check and try again",
    "0x1B093008": "Enabling Smart Track failed. Check and try again",
    "0x1B093009": "Enabling Smart Track failed. Increase selected area",
    "0x1B09300A": "Enabling Smart Track failed. Ensure selected target is valid",
    "0x1B09300B": "Target lost. Exited Target Acquisition",
    "0x1B09300C": "Enabling Smart Track failed. Check and try again",
    "0x1B09300D": "Enabling Smart Track failed. Check and try again",
    "0x1B09300E": "Camera parameters changed. Exited Target Acquisition",
    "0x1B09300F": "Enabling Smart Track failed. Check and try again",
    "0x1B093010": "Enabling Smart Track failed. Check and try again",
    "0x1B093011": "Enabling Smart Track failed. Check and try again",
    "0x1B093012": "Enabling Smart Track failed. Check and try again",
    "0x1B093013": "Enabling Smart Track failed. Check and try again",
    "0x1B093014": "Enabling Smart Track failed. Check and try again",
    "0x1B093015": "Enabling Smart Track failed. Check and try again",
    "0x1B093016": "Target lost. Exited Smart Track",
    "0x1B093017": "Enabling Smart Track failed. Check and try again",
    "0x1B093018": "Target too far away. Exited Target Acquisition",
    "0x1B093019": "Camera parameters changed. Exited Smart Track",
    "0x1B09301A": "Enabling Smart Track failed. Check and try again",
    "0x1B0A0001": "GNSS signal weak. Geo-awareness function degraded. Fly with caution",
    "0x1B0A0002": "Failed to load dynamic safety data. Geo-awareness function degraded. It is recommended to update FlySafe database",
    "0x1B0A0003": "Failed to query dynamic safety data. Geo-awareness function degraded. It is recommended to update FlySafe database",
    "0x1B0A0004": "FlySafe data density high in current region. Aircraft may not be able to fully process data. It is recommended to update FlySafe database",
    "0x1B0B0001": "Unable to take off. Failed to obtain aircraft location. Take off in open area",
    "0x1B0B0001_in_the_sky": "Failed to obtain aircraft location. Take off in open area",
    "0x1B0B0002": "Unable to take off. Take off inside geo-cage",
    "0x1B0B0002_in_the_sky": "Fly aircraft inside geo-cage",
    "0x1B0B0003": "Unable to take off. No geo-cage data found",
    "0x1B0B0003_in_the_sky": "No geo-cage data found. Return to home promptly",
    "0x1B0B0004": "Unable to take off. Geo-cage data error",
    "0x1B0B0004_in_the_sky": "Geo-cage data error. Return to home promptly",
    "0x1B0B0005": "Unable to take off. Geo-cage function error",
    "0x1B0B0005_in_the_sky": "Geo-cage function error. Return to home promptly",
    "0x1B0B0006": "Unable to fly automatically. Manually fly aircraft back to flight geography area",
    "0x1B0B0006_in_the_sky": "Unable to fly automatically. Manually fly aircraft back to flight geography area",
    "0x1B0B0007": "Home Point should be set in flight geography area of geo-cage",
    "0x1B0B0007_in_the_sky": "Home Point should be set in flight geography area of geo-cage",
    "0x1B0B0008": "Unable to return to home automatically. Manually fly aircraft back to flight geography area",
    "0x1B0B0008_in_the_sky": "Unable to return to home automatically. Manually fly aircraft back to flight geography area",
    "0x1B0C0001": "",
    "0x1B0C0001_in_the_sky": "",
    "0x1B0C0002": "",
    "0x1B0C0002_in_the_sky": "",
    "0x1B0C0003": "",
    "0x1B0C0003_in_the_sky": "",
    "0x1B0C0004": "",
    "0x1B0C0004_in_the_sky": "",
    "0x1B0C0005": "",
    "0x1B0C0005_in_the_sky": "",
    "0x1B0C0006": "",
    "0x1B0C0006_in_the_sky": "",
    "0x1B0C0007": "",
    "0x1B0C0007_in_the_sky": "",
    "0x1B100000": "Target lost. Tracking stopped",
    "0x1B100001": "Target too small. Easy to lose",
    "0x1B300001": "Unable to obtain cargo case data. Make sure cargo case is installed properly",
    "0x1B300002": "Winch system communication error. Check winch system connection",
    "0x1B300003": "Payload exceeds capacity. Reduce payload and adjust flight plan",
    "0x1B300004": "Payload exceeds capacity. Cancel flight",
    "0x1B300005": "Payload weight not evenly distributed. Secure payload in center of cargo case",
    "0x1B300006": "Cargo case severely imbalanced. Secure payload in center of cargo case",
    "0x1B300007": "Cargo case wobbling. Secure cargo case and payload inside",
    "0x1B300008": "Cargo case wobbles significantly. Secure cargo case and payload inside",
    "0x1B300009": "Payload on winch system exceeds capacity. Reduce payload and adjust flight plan",
    "0x1B30000A": "Payload on winch system exceeds capacity. Cancel flight",
    "0x1B30000B": "Payload swings slightly. Fly with caution",
    "0x1B30000C": "Payload swings significantly. Fly with caution",
    "0x1B30000D": "Payload on winch system approaching obstacle. Fly with caution",
    "0x1B30000E": "Payload on winch system very close to obstacle. Fly with caution",
    "0x1B30000F": "Extending or retracting winch cable is prohibited during flight. Make sure aircraft is hovering before extending or retracting winch cable",
    "0x1B300010": "Payload swings greatly. Do not reel up winch cable. Wait until payload swing reduces before reeling up",
    "0x1B300011": "Winch system weight sensor auto calibrated",
    "0x1B300011_in_the_sky": "Winch system weight sensor auto calibrated",
    "0x1B310001": "Battery level too low to complete flight mission. Adjust flight plan",
    "0x1B310001_in_the_sky": "Battery level too low to complete flight mission. Adjust flight plan",
    "0x1B310002": "Battery level too low to fly to alternate landing site. Land promptly",
    "0x1B310002_in_the_sky": "Battery level too low to fly to alternate landing site. Land promptly",
    "0x1B310003": "Current payload exceeds propulsion system capability limit. Motors may be overheated. Reduce payload weight before taking off",
    "0x1B310003_in_the_sky": "Current payload exceeds propulsion system capability limit. Motors may be overheated. Return to home or land promptly",
    "0x1B310004": "Current payload exceeds battery capability limit. Battery may be damaged. Reduce payload weight before taking off",
    "0x1B310004_in_the_sky": "Current payload exceeds battery capability limit. Battery may be damaged. Return to home or land promptly",
    "0x1B310005": "Altitude detection function of radar module unavailable. Safe altitude changed. Fly with caution",
    "0x1B310006": "Altitude detection function of radar module available. Safe altitude changed. Fly with caution",
    "0x1B310007": "Aircraft in area with terrain data. Fly under safe altitude",
    "0x1B310007_in_the_sky": "Aircraft entered area with terrain data. Safe altitude changed",
    "0x1B310008": "Aircraft not in area with terrain data. Apply terrain data",
    "0x1B310008_in_the_sky": "Aircraft out of area with terrain data. Safe altitude changed. Fly with caution",
    "0x1B310009": "Aircraft flight altitude exceeded safe altitude. Fly aircraft under safe altitude",
    "0x1B31000A": "Winch system not fully reeled up. Propellers may be impacted during landing. Reel up cable before landing",
    "0x1B31000B": "Aircraft Stops. Fly with caution",
    "0x1B31000B_in_the_sky": "Aircraft Stops. Fly with caution",
    "0x1B310011": "Battery temperature low. Warm up battery before takeoff",
    "0x1B310011_in_the_sky": "Battery temperature low. Fly with caution",
    "0x1BA10000": "Cruise control enabled",
    "0x1BA10001": "Aircraft not in flight. Cruise control disabled",
    "0x1BA10002": "Switching flight modes. Cruise control disabled",
    "0x1BA10003": "Aircraft braking. Cruise control disabled",
    "0x1BA10004": "Flight speed limited. Cruise control disabled",
    "0x1BA10005": "Aircraft approaching the set max flight altitude or distance. Cruise control disabled",
    "0x1BA10006": "Cruise control unavailable in current flight mode. Cruise control disabled",
    "0x1BA10007": "Aircraft braking. Cruise control disabled",
    "0x1BA10008": "Remote controller signal lost. Cruise control disabled",
    "0x1BA10009": "Aircraft reached the destination point. Cruise Control exited",
    "0x1C000001": "",
    "0x1C000103": "Camera processor temperature high (%alarmid). Power off aircraft and wait for temperature to return to normal before use",
    "0x1C000103_in_the_sky": "Camera processor temperature high (%alarmid). Return to home or land promptly. Wait for temperature to return to normal before use",
    "0x1C000104": "Camera processor temperature too high. Power off aircraft.  Wait for temperature to return to normal before use",
    "0x1C000104_in_the_sky": "Camera processor temperature too high. Return to home or land promptly. Wait for temperature to return to normal before use",
    "0x1C000201": "Camera hardware error. Restart and try again",
    "0x1C000202": "Camera hardware error. Restart and try again",
    "0x1C000203": "Camera hardware error. Restart and try again",
    "0x1C000204": "Camera image sensor overheated",
    "0x1C000207": "Check if camera connection cable is loose or has been eroded",
    "0x1C00020A": "Image sensor calibration data error. Restart aircraft",
    "0x1C000303": "Camera connection error. Restart camera and check whether camera is installed properly",
    "0x1C000305": "Shutter trigger count reached 100K design limit",
    "0x1C000306": "Non-DJI Enterprise lens",
    "0x1C000310": "Camera lens not detected",
    "0x1C000311": "Camera lens error. Re-install lens",
    "0x1C000312": "Camera lens error. Re-install lens",
    "0x1C000313": "Camera lens error. Re-install lens",
    "0x1C000314": "Camera lens error. Re-install lens",
    "0x1C000317": "Lens calibration data error. Re-install lens or restart aircraft",
    "0x1C000401": "Invalid memory card. Replace card (%alarmid)",
    "0x1C000402": "Memory card speed low. Replace with faster card",
    "0x1C000403": "Memory card error. Replace card (%alarmid)",
    "0x1C000404": "No memory card",
    "0x1C000405": "Confirm memory card read and write permissions",
    "0x1C000407": "Formatting memory card...",
    "0x1C000408": "Memory card file system not supported. Format card before use",
    "0x1C00040A": "Memory card full. Clear space",
    "0x1C00040B": "Max file index exceeded. Format SD card",
    "0x1C00040C": "Initializing memory card...",
    "0x1C00040D": "Memory card error. Format card before use",
    "0x1C00040E": "Memory card write speed low",
    "0x1C00040F": "Memory card write speed low",
    "0x1C000411": "SD card write error. Replace SD card",
    "0x1C000412": "Verification required before using memory card. Enter password to verify",
    "0x1C000414": "SD card storage severely fragmented. Back up files and format SD card",
    "0x1C000602": "Ambient Light Too Low",
    "0x1C000603": "Photos may be underexposed",
    "0x1C000604": "Photos may be overexposed",
    "0x1C000901": "PPS signal sending error",
    "0x1C000902": "Camera time synchronization error",
    "0x1C000903": "Camera hardware error. Restart and try again",
    "0x1C000904": "Camera hardware error. Restart and try again",
    "0x1C000905": "Camera hardware error. Restart and try again",
    "0x1C000906": "Camera hardware error. Restart and try again",
    "0x1C000907": "Camera hardware error. Restart and try again",
    "0x1C000908": "Camera hardware error. Restart and try again",
    "0x1C000909": "Camera hardware error. Restart and try again",
    "0x1C00090A": "Camera hardware error. Restart and try again",
    "0x1C000A01": "Frames dropped in recording. Firmware update recommended",
    "0x1C000A02": "Frames dropped in recording. Firmware update recommended",
    "0x1C000B01": "Camera hardware error. Restart and try again",
    "0x1C000D01": "Focusing failed",
    "0x1C000D02": "Lens infinity focus not calibrated",
    "0x1C000D03": "Infinity focus calibration data expired. Recalibrate",
    "0x1C000D04": "Infinity focus calibration data expired. Recalibrate",
    "0x1C000E01": "Camera and lens intrinsic parameters calibration data do not match",
    "0x1C000E02": "Intrinsic parameters calibration data expired",
    "0x1C001001": "DJI PROSSD fragmentation risk detected. Formatting storage device recommended",
    "0x1C001002": "DJI PROSSD fragmented. Formatting storage device recommended",
    "0x1C001003": "",
    "0x1C001101": "DJI PROSSD approaching end of lifespan. Replacing storage device recommended",
    "0x1C001102": "DJI PROSSD reached end of lifespan. Replacing storage device recommended",
    "0x1C001103": "Failed to obtain data stored in DJI PROSSD. Back up files before formatting DJI PROSSD to avoid data loss",
    "0x1C001201": "Use DJI PROSSD to start recording",
    "0x1C001301": "Failed to write video to storage. Stopping recording...",
    "0x1C001302": "DJI PROSSD write speed low. Stopping recording...",
    "0x1C001303": "Insufficient storage on DJI PROSSD. Stopping recording...",
    "0x1C001303_special": "Insufficient storage on memory card. Stopping recording...",
    "0x1C001306": "System busy. Recording not allowed",
    "0x1C001307": "System not busy. Recording available",
    "0x1C001401": "Camera connection unstable. Detach and remount gimbal",
    "0x1C001402": "Camera connection unstable. Detach and remount gimbal",
    "0x1C001403": "Camera connection unstable. Detach and remount gimbal",
    "0x1C001404": "Camera connection unstable. Detach and remount gimbal",
    "0x1C001405": "Camera connection unstable. Detach and remount gimbal",
    "0x1C001406": "Camera connection unstable. Detach and remount gimbal",
    "0x1C001407": "Camera connection unstable. Detach and remount gimbal",
    "0x1C001408": "Camera connection unstable. Detach and remount gimbal",
    "0x1C001409": "Camera connection unstable. Detach and remount gimbal",
    "0x1C00140A": "Camera connection unstable. Detach and remount gimbal",
    "0x1C00140E": "Camera error. Restarting aircraft recommended",
    "0x1C00140F": "Camera connection unstable. Detach and remount gimbal",
    "0x1C001501": "Light sensor error. Contact DJI Support",
    "0x1C001502": "Light sensor error. Contact DJI Support",
    "0x1C001503": "Light sensor calibration data error. Contact DJI Support",
    "0x1C001603": "Unable to use DJI PROSSD. Remove and insert storage device again",
    "0x1C001604": "No memory card",
    "0x1C001605": "SSD file system error. Remove and insert SSD again. Back up SSD files and then format SSD card if issue persists",
    "0x1C001606": "DJI PROSSD not formatted",
    "0x1C001607": "Formatting DJI PROSSD...",
    "0x1C001608": "DJI PROSSD file system format not supported",
    "0x1C001609": "Refreshing DJI PROSSD...",
    "0x1C00160A": "DJI PROSSD full",
    "0x1C00160B": "DJI PROSSD file naming index full. Delete extra files",
    "0x1C00160C": "Initializing DJI PROSSD\u2026",
    "0x1C00160D": "Reformatting DJI PROSSD recommended",
    "0x1C00160E": "Restoring files on DJI PROSSD...",
    "0x1C00160F": "DJI PROSSD speed low. Replacing storage device recommended",
    "0x1C001701": "Timed shot interval too short. Unable to start shooting",
    "0x1C001702": "Timed shot interval too short. Unable to switch cameras",
    "0x1C001703": "Photo format inconsistent. Unable to switch cameras",
    "0x1C001801": "Timecode error. Restart aircraft",
    "0x1C001901": "ProRes RAW codec not authorized,purchase on the official website",
    "0x1C001902": "CinemaDNG encoding format not authorized. Purchase license from official website",
    "0x1C001903": "ProRes RAW codec not authorized,purchase on the official website",
    "0x1C001904": "CinemaDNG encoding format not authorized\uff0cpurchase on the official website",
    "0x1C001A01": "DJI PROSSD write speed low. Restarting aircraft recommended",
    "0x1C001B01": "Usage count of gimbal port reached",
    "0x1C001E04": "System busy. Photo is not allowed",
    "0x1C001E05": "System not busy.Photo available",
    "0x1C001F01": "System busy. Zoom is not available",
    "0x1C001F02": "System not busy. Zoom available",
    "0x1C002001": "System busy. Do not switch cameras",
    "0x1C002002": "System not busy. Do not switch cameras",
    "0x1C002004": "",
    "0x1C002101": "Camera receiving LiDAR data timed out. Restart aircraft and try again",
    "0x1C002102": "Point cloud data frames dropped. The ultimate point cloud model may not be complete. Restart aircraft",
    "0x1C002103": "LiDAR may be blocked or object out of measuring range",
    "0x1C002104": "RNG sampling failed. Try again later or restart aircraft",
    "0x1C002105": "LiDAR temporarily powered off. Camera overheated",
    "0x1C002106": "LiDAR temporarily unavailable. Camera overheated",
    "0x1C002107": "Infrared auxiliary light temporarily unavailable. Camera overheated",
    "0x1C002201": "Previous media files exist in camera SSD. Back up files to avoid data loss",
    "0x1C002302": "",
    "0x1C002303": "",
    "0x1C002304": "",
    "0x1C002305": "",
    "0x1C002306": "",
    "0x1C002307": "",
    "0x1C002308": "",
    "0x1C002309": "",
    "0x1C00230A": "",
    "0x1C00230B": "",
    "0x1C00230C": "",
    "0x1C00230D": "",
    "0x1C00230E": "",
    "0x1C002501": "Camera overheating warning. Defog and LiDAR disabled automatically",
    "0x1C002502": "Defog and LiDAR disabled automatically. Camera overheated",
    "0x1C002502_in_the_sky": "Infrared auxiliary light (thermal version only) and defog disabled automatically. Camera overheated",
    "0x1C002503": "Camera overheated. Defog temporarily unavailable",
    "0x1C002701": "Timed shot interval too short. Unable to record AI recognition data",
    "0x1C002702": "Unable to record AI recognition data for panoramas",
    "0x1C002703": "Unable to record AI recognition data for 8K photos",
    "0x1C003001": "",
    "0x1C004001": "Invalid memory card. Replace card",
    "0x1C004002": "Memory card speed low. Replace with faster card",
    "0x1C004003": "Memory card error. Replace card",
    "0x1C004004": "No memory card",
    "0x1C100001": "Camera %component_index overheated. Wait for temperature to return to normal before use",
    "0x1C100101": "Camera %component_index error. Restart camera",
    "0x1C100102": "Camera %component_index error. Restart camera",
    "0x1C100103": "Camera processor temperature high. Power off aircraft and wait for temperature to return to normal before use",
    "0x1C100103_in_the_sky": "Camera processor temperature high. Return to home or land promptly. Wait for temperature to return to normal before use",
    "0x1C100104": "Camera processor temperature too high. Power off aircraft and wait for temperature to return to normal before use",
    "0x1C100104_in_the_sky": "Camera processor temperature too high. Return to home or land promptly. Wait for temperature to return to normal before use",
    "0x1C100105": "Camera %component_index error. Restart camera",
    "0x1C100201": "H20 camera image transmission sensor processor error",
    "0x1C100202": "H20 camera image transmission sensor processor error",
    "0x1C100203": "Camera chip overheated. Power off aircraft and wait for temperature to return to normal before use",
    "0x1C100203_in_the_sky": "Camera processor overheated. Return to home or land promptly. Wait for temperature to return to normal before use",
    "0x1C100204": "H20 camera image transmission sensor processor error",
    "0x1C100205": "FPV lens calibration error. Recalibrate lens and try again",
    "0x1C100301": "H20 camera lens error. Restart camera",
    "0x1C100302": "H20 camera lens error. Restart camera",
    "0x1C100303": "H20 camera lens error. Restart camera",
    "0x1C100304": "H20 camera lens error. Restart camera",
    "0x1C100401": "Invalid memory card. Replace card",
    "0x1C100401_index_1": "Invalid eMMC. Restart camera. If the issue persists, contact DJI Support for repairs",
    "0x1C100402": "Memory card speed low. Replace with faster card",
    "0x1C100402_index_1": "eMMC speed error. Restart camera. If the issue persists, contact DJI Support for repairs",
    "0x1C100403": "Memory card error. Replace card",
    "0x1C100403_index_1": "eMMC error. Restart camera. If the issue persists, contact DJI Support for repairs",
    "0x1C100404": "No memory card",
    "0x1C100404_index_1": "eMMC identification error. Restart camera. If the issue persists, contact DJI Support for repairs",
    "0x1C100405": "Confirm memory card read and write permissions",
    "0x1C100406": "Memory card not formatted. Format card before use",
    "0x1C100407": "Formatting memory card...",
    "0x1C100408": "Memory card file system not supported. Format card before use",
    "0x1C100409": "Refreshing memory card...",
    "0x1C10040A": "Memory card full. Clear space",
    "0x1C10040B": "Max file index exceeded. Format SD card",
    "0x1C10040C": "Initializing memory card...",
    "0x1C10040D": "Memory card error. Format card before use",
    "0x1C10040E": "Fixing memory card...",
    "0x1C10040F": "Memory card read and write speed low. Wait until process completes",
    "0x1C200001": "Camera %component_index overheated. Wait for temperature to return to normal before use",
    "0x1C200101": "Camera %component_index error. Restart camera",
    "0x1C200102": "Camera %component_index error. Restart camera",
    "0x1C200103": "Camera processor temperature too high. Power off aircraft and wait for temperature to return to normal before use",
    "0x1C200103_in_the_sky": "Camera processor temperature high. Return to home or land promptly. Wait for temperature to return to normal before use",
    "0x1C200104": "Camera processor temperature too high. Power off aircraft and wait for temperature to return to normal before use",
    "0x1C200104_in_the_sky": "Camera processor temperature too high. Return to home or land promptly. Wait for temperature to return to normal before use",
    "0x1C200105": "Camera %component_index error. Restart camera",
    "0x1C200201": "Camera %component_index error. Restart camera",
    "0x1C200202": "Camera %component_index error. Restart camera",
    "0x1C200203": "Camera chip overheated. Power off aircraft and wait for temperature to return to normal before use",
    "0x1C200203_in_the_sky": "Camera processor overheated. Return to home or land promptly. Wait for temperature to return to normal before use",
    "0x1C200204": "H20 camera image transmission sensor processor error",
    "0x1C200301": "H20 camera lens error. Restart camera",
    "0x1C200302": "H20 camera lens error. Restart camera",
    "0x1C200303": "H20 camera lens error. Restart camera",
    "0x1C200304": "H20 camera lens error. Restart camera",
    "0x1C200401": "Invalid memory card. Replace card",
    "0x1C200401_index_1": "Invalid eMMC. Restart camera. If the issue persists, contact DJI Support for repairs",
    "0x1C200402": "Memory card speed low. Replace with faster card",
    "0x1C200402_index_1": "Restart camera. If the issue persists, contact DJI Support for repairs",
    "0x1C200403": "Memory card error. Replace card",
    "0x1C200403_index_1": "eMMC error. Restart camera. If the issue persists, contact DJI Support for repairs",
    "0x1C200404": "No memory card",
    "0x1C200404_index_1": "eMMC identification error. Restart camera. If the issue persists, contact DJI Support for repairs",
    "0x1C200405": "Confirm memory card read and write permissions",
    "0x1C200406": "Memory card not formatted. Format card before use",
    "0x1C200407": "Formatting memory card...",
    "0x1C200408": "Memory card file system not supported. Format card before use",
    "0x1C200409": "Refreshing memory card...",
    "0x1C20040A": "Memory card full. Clear space",
    "0x1C20040B": "Max file index exceeded. Format SD card",
    "0x1C20040C": "Initializing memory card...",
    "0x1C20040D": "Memory card error. Format card before use",
    "0x1C20040E": "Fixing memory card...",
    "0x1C20040F": "Memory card read and write speed low. Wait until process completes",
    "0x1C200410": "Verification required before using memory card. Enter password to verify",
    "0x1C300001": "Camera %component_index overheated. Wait for temperature to return to normal before use",
    "0x1C300101": "Camera %component_index error. Restart camera",
    "0x1C300102": "Camera %component_index error. Restart camera",
    "0x1C300103": "Camera processor temperature high. Power off aircraft and wait for temperature to return to normal before use",
    "0x1C300103_in_the_sky": "Camera processor temperature high. Return to home or land promptly. Wait for temperature to return to normal before use",
    "0x1C300104": "Camera processor temperature too high. Power off aircraft and wait for temperature to return to normal before use",
    "0x1C300104_in_the_sky": "Camera processor temperature too high. Return to home or land promptly. Wait for temperature to return to normal before use",
    "0x1C300105": "Camera %component_index error. Restart camera",
    "0x1C300301": "H20 camera lens error. Restart camera",
    "0x1C300302": "H20 camera lens error. Restart camera",
    "0x1C300303": "H20 camera lens error. Restart camera",
    "0x1C300304": "H20 camera lens error. Restart camera",
    "0x1C300401": "Invalid memory card. Replace card",
    "0x1C300401_index_1": "Invalid eMMC. Restart camera. If the issue persists, contact DJI Support for repairs",
    "0x1C300402": "Memory card speed low. Replace with faster card",
    "0x1C300402_index_1": "eMMC speed error. Restart camera. If the issue persists, contact DJI Support for repairs",
    "0x1C300403": "Memory card error. Replace card",
    "0x1C300403_index_1": "eMMC error. Restart camera. If the issue persists, contact DJI Support for repairs",
    "0x1C300404": "No memory card",
    "0x1C300404_index_1": "eMMC identification error. Restart camera. If the issue persists, contact DJI Support for repairs",
    "0x1C300405": "Confirm memory card read and write permissions",
    "0x1C300406": "Memory card not formatted. Format card before use",
    "0x1C300407": "Formatting memory card...",
    "0x1C300408": "Memory card file system not supported. Format card before use",
    "0x1C300409": "Refreshing memory card...",
    "0x1C30040A": "Memory card full. Clear space",
    "0x1C30040B": "Max file index exceeded. Format SD card",
    "0x1C30040C": "Initializing memory card...",
    "0x1C30040D": "Memory card error. Format card before use",
    "0x1C30040E": "Fixing memory card...",
    "0x1C30040F": "Memory card read and write speed low. Wait until process completes",
    "0x1C300601": "Temperature of current environment too low. Enable temperature measurement when temperature is within normal range",
    "0x1C300602": "Temperature of current evironment too high. Only enable temperature measurement when temperature is within normal range",
    "0x1C300603": "Zenmuse H20T infrared thermal camera switching modes...",
    "0x1C300604": "Zenmuse H20T infrared thermal camera calibration data missing",
    "0x1C300605": "Zenmuse H20T infrared thermal camera initialization error. Restart camera",
    "0x1C300606": "Temperature measurement failed. Adjust camera parameters and try again",
    "0x1C300607": "Exceeded measuring range limit. Switch to Low Gain mode",
    "0x1C300608": "Exceeded measuring range limit. It is recommended to attach an infrared density filter",
    "0x1C300609": "Exceeded temperature measuring range limit",
    "0x1C300701": "Sun detected. Infrared shutter closed",
    "0x1C300702": "Sun detected. Rotate gimbal to avoid direct sunlight",
    "0x1D001001": "Gimbal unresponsive after power on",
    "0x1D001101": "Gimbal unable to complete auto check",
    "0x1D010001": "Gimbal stuck",
    "0x1D010002": "Gimbal auto-check failed",
    "0x1D010003": "Gimbal motor overloaded",
    "0x1D010C01": "FPV gimbal stuck",
    "0x1D010C02": "FPV gimbal auto-check failed",
    "0x1D010C03": "FPV gimbal motor overloaded",
    "0x1D020001": "Gimbal calibration error",
    "0x1D020002": "Gimbal IMU error. Restart aircraft and try again",
    "0x1D020003": "Gimbal calibration parameter error. Try gimbal Auto Calibration",
    "0x1D020C01": "FPV gimbal calibration error",
    "0x1D030001": "Gimbal unable to retrieve aircraft data",
    "0x1D030C01": "FPV gimbal unable to obtain aircraft data",
    "0x1D040001": "Excessive gimbal vibration",
    "0x1D040002": "Gimbal sensor error",
    "0x1D040003": "Gimbal ESC malfunctioned",
    "0x1D040004": "Gimbal ESC malfunctioned",
    "0x1D040005": "Gimbal ESC malfunctioned",
    "0x1D040C01": "Abnormal FPV gimbal vibration",
    "0x1D040C02": "FPV gimbal sensor error",
    "0x1D040C03": "FPV gimbal ESC malfunction",
    "0x1D040C04": "FPV gimbal ESC malfunction",
    "0x1D040C05": "FPV gimbal ESC malfunction",
    "0x1D050001": "Gimbal %component_index roll axis endpoint reached",
    "0x1D050002": "Gimbal %component_index pitch axis endpoint reached",
    "0x1D050003": "Gimbal %component_index pan axis endpoint reached",
    "0x1D050004": "Gimbal frozen due to low temperature. Return to dock and try unfreezing gimbal",
    "0x1D050301": "Gimbal operation retry attempts limit exceeded",
    "0x1D050302": "Camera exposure error",
    "0x1D05030F": "Gimbal rotation count approaching max limit",
    "0x1D050A01": "Gimbal voltage too low",
    "0x1D050A02": "Gimbal time synchronization error",
    "0x1D050C01": "FPV gimbal limit reached",
    "0x1D050C02": "FPV gimbal tilt limit reached",
    "0x1D050C03": "FPV gimbal pan limit reached",
    "0x1D0C0002": "Gimbal IMU Error",
    "0x1D0C0003": "Gimbal Initialization Error",
    "0x1D0C0004": "Gimbal Initialization Error",
    "0x1D0C0005": "Gimbal voltage error. Replace with DJI battery",
    "0x1D0C000B": "Gimbal Motor Temperature Too High",
    "0x1D0C000E": "Lens not firmly attached. Reattach lens and toggle lever to the locked position",
    "0x1D0C000F": "Gimbal not balanced. Make sure lens protector/ND filter, hood, and balancing weight are properly installed",
    "0x1D0C0C02": "FPV gimbal IMU error",
    "0x1D0C0C03": "FPV gimbal initialization error",
    "0x1D0C0C04": "FPV gimbal initialization error",
    "0x1D0C0C05": "FPV gimbal voltage error. Replace with DJI battery",
    "0x1D0C0C0B": "FPV gimbal motor overheated",
    "0x1D0E0001": "Gimbal Initialization Error",
    "0x1D0E0C01": "FPV gimbal initialization error",
    "0x1D100002": "Gimbal unresponsive after power on",
    "0x1D100006": "Gimbal unresponsive after power on",
    "0x1D110002": "Gimbal unable to complete auto check",
    "0x1D110005": "Gimbal unable to complete auto check",
    "0x1D120001": "Error detected during gimbal auto check",
    "0x1D120002": "Error detected during gimbal auto check",
    "0x1D120004": "Error detected during gimbal auto check",
    "0x1D120006": "Error detected during gimbal auto check",
    "0x1D130003": "Excessive gimbal vibration",
    "0x1D130005": "Excessive gimbal vibration",
    "0x1D13000A": "Excessive gimbal vibration",
    "0x1D140001": "Gimbal motor overloaded",
    "0x1D150002": "Gimbal drifting",
    "0x1D150003": "Gimbal drifting",
    "0x1D150004": "Gimbal drifting",
    "0x1D150005": "Gimbal drifting",
    "0x1D160004": "Camera tilted",
    "0x1D170001": "Gimbal error",
    "0x1D180001": "Gimbal calibration data error",
    "0x1D190002": "Gimbal update failed",
    "0x1E00000": "",
    "0x1E000001": "Payload %component_index startup error",
    "0x1E000002": "Payload %component_index communication error",
    "0x1E000003": "Payload %component_index overheated",
    "0x1E000004": "Payload %component_index hardware error",
    "0x1E000005": "PSDK %component_index in test mode. Ensure flight safety and contact payload supplier for assistance",
    "0x1E000006": "Payload resonates with aircraft. Power supply disconnected. Wait for power supply to recover",
    "0x1E000101": "Aircraft returning to home. Spotlight disabled automatically",
    "0x1E000102": "Aircraft has not taken off. Spotlight max brightness level limited to 40%",
    "0x1E000103": "Spotlight power restricted. Max brightness level reduced",
    "0x1E000104": "Spotlight temperature too high. Brightness will be continuously reduced",
    "0x1E000105": "Aircraft battery low. Spotlight disabled automatically",
    "0x1E000106": "Aircraft landing near ground. Spotlight disabled automatically",
    "0x1E000107": "Spotlight disabled. Spotlight not activated. Activate spotlight before use",
    "0x1E000108": "Brightness is limited. Spotlight temperature sensor error. Reinstall spotlight",
    "0x1E010001": "Volume decreased. Speaker overheated. Wait for speaker to cool down before use",
    "0x1E010002": "Speaker hardware error. Restart aircraft",
    "0x1E010003": "Speaker overloaded. Restart aircraft",
    "0x1E010004": "Speaker disabled automatically. Aircraft battery low",
    "0x1E010009": "Speaker unavailable. Speaker not activated. Activate speaker before use",
    "0x1E01000A": "Max volume may decrease. Speaker temperature sensor error",
    "0x1E020001": "Spotlight gimbal stuck",
    "0x1E020002": "Spotlight gimbal auto check failed",
    "0x1E020003": "Spotlight gimbal motor overloaded",
    "0x1E030001": "Spotlight gimbal calibration error",
    "0x1E030003": "Spotlight gimbal calibration parameter error",
    "0x1E040001": "Spotlight gimbal stuck",
    "0x1E040002": "Spotlight gimbal auto check failed",
    "0x1E040003": "Spotlight gimbal motor overloaded",
    "0x1E050001": "Spotlight gimbal calibration error",
    "0x1E050002": "Spotlight gimbal sensor error",
    "0x1E050003": "Spotlight gimbal calibration parameter error",
    "0x1E050004": "Motor on right side of spotlight error. Try restarting spotlight",
    "0x1E050005": "Spotlight gimbal motor malfunction",
    "0x1E060001": "Spotlight unable to obtain aircraft information",
    "0x1E070002": "Spotlight gimbal sensor error",
    "0x1E070003": "Motor on left side of spotlight error. Try restarting spotlight",
    "0x1E070004": "Motor on right side of spotlight error. Try restarting spotlight",
    "0x1E070005": "Spotlight gimbal motor malfunction",
    "0x1E0D0001": "Spotlight not activated",
    "0x1E0D0002": "No IMU data for Spotlight",
    "0x1E0D0003": "Spotlight gimbal motor not initialized",
    "0x1E0F0001": "Spotlight not activated",
    "0x1E0F0002": "No IMU data for Spotlight",
    "0x1E0F0003": "Spotlight gimbal motor not initialized",
    "0x1E110001": "Spotlight gimbal attitude initialization failed",
    "0x1F010000": "4G service: unable to obtain license. Contact DJI Support",
    "0x1F010001": "4G service: license expired. Import valid license",
    "0x1F010002": "4G service: license verification failed. Contact DJI Support",
    "0x1F010003": "4G service: device SN unauthorized. Authorize device SN",
    "0x1F010004": "4G service: device SN unauthorized. Purchase upgrade package",
    "0x1F010005": "4G service: the number of connected devices exceeds authorized number. Purchase upgrade package",
    "0x1F010006": "4G service: device firmware version too early. Upgrade firmware",
    "0x1F010007": "4G service: server version too early. Upgrade server",
    "0x1F010008": "4G service: requested parameter error. Contact DJI Support",
    "0x1F010009": "4G service: server internal error. Contact DJI Support",
    "0x1F01000A": "4G service: unable to obtain license. Contact DJI Support",
    "0x1F01000B": "4G service: license expired. Import valid license",
    "0x1F01000C": "4G service: license verification failed. Contact DJI Support",
    "0x1F01000D": "System time error. Make sure device and server time are correct and try again",
    "0x1F01000E": "Current area does not match area unlocked by license. Check unlocked area",
    "0x1F010063": "4G service: system unknown error. Contact DJI Support",
    "0x1F0B0001": "Aircraft unable to use LTE Transmission. Network connection unstable or SIM card unable to connect to network",
    "0x1F0B0002": "No network on DJI Cellular Dongle of remote controller",
    "0x1F0B0003": "LTE Server and LTE Transmission unavailable",
    "0x1F0B0004": "LTE Server and LTE Transmission unavailable",
    "0x1F0B0005": "LTE Transmission unavailable. Check and ensure remote controller and aircraft are linked properly",
    "0x1F0B0006": "LTE Transmission unavailable. Restart remote controller",
    "0x1F0B0007": "LTE Transmission unavailable. Check aircraft 4G Dongle network connectivity",
    "0x1F0B0008": "LTE Transmission unavailable. Restart aircraft and remote controller",
    "0x1F0B0009": "LTE Transmission unavailable. Restart remote controller",
    "0x1F0B0016": "LTE Transmission unavailable. Check remote controller network connectivity",
    "0x1F0B0017": "LTE Transmission unavailable. Check remote controller network connectivity",
    "0x1F0B0018": "LTE Transmission unavailable. Restart aircraft and remote controller",
    "0x1F0B001A": "LTE Transmission unavailable. Check aircraft 4G Dongle network connectivity",
    "0x1F0B001B": "LTE Transmission unavailable. Restart aircraft and remote controller",
    "0x1F0B001C": "LTE Transmission error. Aircraft authentication files missing. Contact your local dealer or DJI Support",
    "0x1F0B001c": "LTE Transmission error. Aircraft authentication files missing. Contact your local dealer or DJI Support",
    "0x1F0B001d": "LTE Transmission error. Remote controller authentication files missing. Contact your local dealer or DJI Support",
    "0x1F0B0020": "Update DJI Cellular Dongle of aircraft required",
    "0x1F0B0021": "Update DJI Cellular Dongle of remote controller required",
    "0x1F0B0022": "Airplane mode enabled or Wi-Fi and mobile data disabled on mobile device. Unable to connect",
    "0x1F0B0023": "LTE signal weak. Fly with caution",
    "0x1F0B0024": "LTE signal weak. Fly with caution",
    "0x1F0B0025": "LTE signal weak. Fly with caution",
    "0x1F0B0026": "Insufficient data allowance on SIM card. Fly with caution",
    "0x1F0B0027": "Aircraft LTE certification update required. Contact your local dealer or DJI Support",
    "0x1F0B0028": "Remote controller LTE certification update required. Contact your local dealer or DJI Support",
    "0x1F0B0029": "License expired. Unable to establish communication",
    "0x1F0B002A": "Incompatible firmware versions. Return to home screen to update firmware",
    "0x1F0B002B": "Incompatible firmware versions. Return to home screen to update firmware",
    "0x1F0B002C": "Incompatible firmware versions. Go to home screen to update firmware",
    "0x1F0B002D": "App update required",
    "0x1F0B002E": "Weak network connection on remote controller. Fly with caution",
    "0x1F0B0030": "Failed to connect to LTE server. Try again later",
    "0x1F0B0031": "Weak network signal on mobile device. Device may be unable to establish communication or connection may be unstable",
    "0x1F0B0032": "Service expired. Unable to use Enhanced Transmission. Firmware update required",
    "0x1F0B0035": "Dongle firmware update required",
    "0x1F0B0036": "Enhanced Transmission unavailable in current region",
    "0x1F0B0037": "No internet access on DJI Cellular Dongle of aircraft. Move or change network",
    "0x1F0B0038": "No network on DJI Cellular Dongle of remote controller",
    "0x1F0B0039": "Unable to establish network connection. Move to a different place or switch to a different SIM card from another service provider",
    "0x1F0B003A": "No internet access on DJI Cellular Dongle of aircraft. Change network provider",
    "0x1F0B003B": "No network on DJI Cellular Dongle of remote controller",
    "0x1F0B003C": "Unable to establish network connection. Move to a different place or switch to a different SIM card from another service provider",
    "0x1F0B003D": "No network connection",
    "0x1F0B003E": "No network on SIM card of DJI Cellular Dongle of remote controller. Check or replace SIM card",
    "0x1F0B0040": "No network on remote controller",
    "0x1F0B0040_in_the_sky": "No internet on remote controller. Check DJI Cellular Dongle or Wi-Fi connection status",
    "0x1F0B0045": "Enhanced link latency high. Fly with caution",
    "0x1F0B0045_in_the_sky": "Enhanced link latency high. Fly with caution",
    "0x1F0B0046": "SIM card not inserted in 4G Dongle of aircraft and eSIM card not activated",
    "0x1F0B0047": "SIM card inserted in 4G Dongle of aircraft. eSIM card selected but not activated",
    "0x1F0B0048": "SIM card not inserted in 4G Dongle of remote controller and eSIM card not activated",
    "0x1F0B0049": "SIM card inserted in 4G Dongle of remote controller. eSIM card selected but not activated",
    "0x1F0B004A": "Aircraft unable to use LTE Transmission. Network unstable or no internet on SIM %lte_index",
    "0x1F0B004B": "No internet on DJI Cellular Dongle %lte_index of aircraft. Move to location with stronger signal or try again later",
    "0x1F0B004C": "No internet on DJI Cellular Dongle %lte_index of aircraft. Change network provider",
    "0x1F0B004D": "No network connection",
    "0x1F0B004E": "SIM card not inserted in DJI Cellular Dongle %lte_index and eSIM not activated",
    "0x1F0B004F": "SIM inserted in DJI Cellular Dongle %lte_index. eSIM selected and not activated",
    "0x1a020180": "Infrared sensors overheated. Return to home or land promptly. Move away from high-temperature environment",
    "0x1a420bc0": "Downward ambient light too low. Obstacle avoidance unavailable. Fly with caution",
    "0x1a420bc1": "Forward ambient light too low. Obstacle avoidance unavailable. Fly with caution",
    "0x1a420bc2": "Backward ambient light too low. Backward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420bc3": "Rightward ambient light too low. Rightward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420bc4": "Leftward ambient light too low. Leftward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420bc5": "Upward ambient light too low. Upward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420bc6": "Horizontal ambient light too low. Horizontal obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c00": "Downward ambient light too bright. Downward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c01": "Forward ambient light too bright. Forward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c02": "Backward ambient light too bright. Backward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c03": "Rightward ambient light too bright. Rightward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c04": "Leftward ambient light too bright. Leftward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c05": "Upward ambient light too bright. Upward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c06": "Horizontal ambient light too bright. Horizontal obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c40": "Downward sensor(s) blocked. Downward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c41": "Forward sensor(s) blocked. Forward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c42": "Backward sensor(s) blocked. Backward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c43": "Rightward sensor(s) blocked. Rightward obstacle avoidance unavailable. Only infrared sensors available.  Fly with caution",
    "0x1a420c44": "Leftward sensor(s) blocked. Leftward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c45": "Upward sensor(s) blocked. Upward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c80": "Downward sensor(s) blurry. Downward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c81": "Forward sensor(s) blurry. Forward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c82": "Backward sensor(s) blurry. Backward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c83": "Right sensor(s) blurry. Rightward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c84": "Left sensor(s) blurry. Leftward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420c85": "Upward sensor(s) blurry. Upward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
    "0x1a420cc0": "Aircraft attitude angle too large. Obstacle avoidance unavailable. Fly with caution",
    "0x1a420d00": "Aircraft attitude angle too large. Landing protection unavailable. Land manually",
    "0x1a420d40": "Aircraft approaching obstacle sensing blind spot and may be unable to detect obstacles. Fly with caution",
    "0x1a5103c0": "Downward vision sensor calibration error",
    "0x1a5103c1": "Forward vision sensor calibration error",
    "0x1a5103c2": "Backward vision sensor calibration error",
    "0x1a5103c3": "Upward vision sensor calibration error",
    "0x1a5103c4": "Left vision sensor calibration error",
    "0x1a5103c5": "Right vision sensor calibration\u00a0error",
    "0x1afd0040": "Sensor system error. Unable to take off. Flight prohibited",
    "0x1afd0040_in_the_sky": "Sensor system error. Return to home or land promptly",
    "0x1afe0040": "Vision system overloaded. Fly to open area",
    "0x1b030019": "Aircraft not flying along route. Safe RTH exited",
    "0x1b030034": "Strong interference or spoofing of positioning signal. Return to home promptly",
    "0x1b080001": "Remote ID broadcast error. Failed to obtain remote controller location",
    "0x1b080002": "Remote ID module error. Contact DJI Support",
    "0x1c000603": "Risk of overexposure in photo",
    "0x1c000604": "Risk of overexposure in photo",
    "0x1c100405": "Confirm memory card read and write permissions",
    "0x1c100405_index_1": "Confirm eMMC read and write properties",
    "0x1c100406": "Memory card not formatted. Format card before use",
    "0x1c100406_index_1": "eMMC not formatted. Format before use",
    "0x1c100407": "Formatting memory card...",
    "0x1c100407_index_1": "eMMC formatting. Please wait",
    "0x1c100408": "Memory card file system not supported. Format card before use",
    "0x1c100409": "Refreshing memory card...",
    "0x1c100409_index_1": "eMMC refreshing. Please wait",
    "0x1c10040B": "Max file index exceeded. Format SD card",
    "0x1c10040a": "Memory card full. Clear space",
    "0x1c10040a_index_1": "eMMC full. Clear space",
    "0x1c10040b": "Max file index exceeded. Format SD card",
    "0x1c10040b_index_1": "eMMC memory overflow. Format eMMC and restart camera",
    "0x1c10040c": "Initializing memory card...",
    "0x1c10040c_index_1": "eMMC initializing. Please wait",
    "0x1c10040d": "Memory card error. Format card before use",
    "0x1c10040d_index_1": "eMMC error. Format before use",
    "0x1c10040e": "Fixing memory card...",
    "0x1c10040e_index_1": "eMMC repair in progress. Please wait",
    "0x1c10040f": "Memory card read and write speed low. Wait until process completes",
    "0x1c10040f_index_1": "eMMC read and write speed low. Please wait",
    "0x1c200405_index_1": "Confirm eMMC read and write properties",
    "0x1c200406_index_1": "eMMC not formatted. Format before use",
    "0x1c200407_index_1": "eMMC formatting. Please wait",
    "0x1c200409_index_1": "eMMC refreshing. Please wait",
    "0x1c20040a_index_1": "eMMC full. Clear space",
    "0x1c20040b": "Max file index exceeded. Format SD card",
    "0x1c20040b_index_1": "eMMC memory overflow. Format eMMC and restart camera",
    "0x1c20040c_index_1": "eMMC initializing. Please wait",
    "0x1c20040d_index_1": "eMMC error. Format before use",
    "0x1c20040e_index_1": "eMMC repair in progress. Please wait",
    "0x1c20040f_index_1": "eMMC read and write speed low. Please wait",
    "0x1c200410": "Verification required before using memory card. Enter password to verify",
    "0x1c300405_index_1": "Confirm eMMC read and write properties",
    "0x1c300406_index_1": "eMMC not formatted. Format before use",
    "0x1c300407_index_1": "eMMC formatting. Please wait",
    "0x1c300409_index_1": "eMMC refreshing. Please wait",
    "0x1c30040a_index_1": "eMMC full. Clear space",
    "0x1c30040b": "Max file index exceeded. Format SD card",
    "0x1c30040b_index_1": "eMMC memory overflow. Format eMMC and restart camera",
    "0x1c30040c_index_1": "eMMC initializing. Please wait",
    "0x1c30040d_index_1": "eMMC error. Format before use",
    "0x1c30040e_index_1": "eMMC repair in progress. Please wait",
    "0x1c30040f_index_1": "eMMC read and write speed low. Please wait",
    "0x1f0b0017": "LTE Transmission unavailable. Check remote controller network connectivity",
    "0x20010100": "Remote controller %2$s obtained gimbal %1$s control",
    "0x20010200": "Obtained control of current gimbal",
    "0x20010301": "Free-mode",
    "0x20010302": "Follow",
    "0x20010304": "Failed to change gimbal mode, please try again.",
    "0x20010400": "Tip: Only the first camera can tap-zoom in dual gimbal control mode.",
    "0x20010501": "Gimbal Recenter",
    "0x20010502": "Recenter Gimbal Pan",
    "0x20010503": "Gimbal Pitch Up",
    "0x20010504": "Gimbal Pitch Down",
    "0x20010505": "Gimbal Up",
    "0x20010506": "Gimbal down",
    "0x20010507": "Gimbal Pitch Recenter",
    "0x20010508": "Gimbal roll centered",
    "0x20010600": "Vision stabilization on.",
    "0x20010601": "Vision stabilization off.",
    "0x20010700": "Lost control of %1$s. Multi-Gimbal Connection disabled",
    "0x20010701": "Lost control of %1$s. %2$s dropped from Multi-Gimbal Connection",
    "0x20010800": "Transmission interrupted. Gimbal control lost",
    "0x20010900": "Remote controller %1$s transmission interrupted. Gained control of all gimbals",
    "0x20020000": "Obtained aircraft flight control. Current control stick mode: %1$s",
    "0x20020001": "Aircraft flight control unlocked",
    "0x20020002": "Aircraft flight control locked",
    "0x20020003": "Aircraft flight control obtained by remote controller %1$s",
    "0x20020004": "Unable to obtain current gimbal control",
    "0x20020005": "Aircraft flight control locked by remote controller %1$s. Unable to obtain control",
    "0x20020006": "Unable to obtain aircraft flight control",
    "0x20020100": "Tip: Aircraft reached maximum distance, please pay attention to flight safety.\\n",
    "0x20020200": "High Wind Velocity. Fly with caution.",
    "0x20020201": "High Wind Velocity. Fly with caution.",
    "0x20020300": "ATTI mode",
    "0x20020301": "Cannot switch flight mode. Turn on \\\"Multiple Flight Modes\\\" to enable Atti and Sport Modes",
    "0x20020302": "Switched to S (Sport)-mode.",
    "0x20020303": "Switched to P (Positioning)-mode.",
    "0x20020304": "Switched to T (Tripod)-mode.",
    "0x20020305": "Switched to A (Attitude)-mode.",
    "0x20020306": "To take off in non-P mode, toggle Flight Mode Switch to another mode and then toggle it back.",
    "0x20020307": "When winch mode is enabled, aircraft acceleration is limited and braking time is extended",
    "0x20020308": "Auto release payload successful",
    "0x20020309": "Auto release payload failed",
    "0x20020400": "The remaining battery is only enough for RTH. Return home now.",
    "0x20020500": "Home Point recorded. Return-to-Home Altitude:%1$.1f %2$s",
    "0x20020600": "Low power. Aircraft will return home.",
    "0x20020601": "Critically low power. Aircraft is landing.",
    "0x20020602": "Low power. Returning home.",
    "0x20020603": "Critically low power. Aircraft is landing.",
    "0x20020604": "Critically low voltage. Aircraft is landing. Press the RTH button on the remote controller to stop.",
    "0x20020605": "Low voltage. Returning home now. Press the RTH button on the remote controller to stop.",
    "0x20020606": "Aircraft is landing due to low voltage, which cannot be stopped. You can decelerate the descending speed and avoid obstacles using sticks.",
    "0x20020607": "Aircraft is returning to the Home Point. Minimum RTH Altitude is %1$dm. You can reset the RTH Altitude in Remote Controller Settings after cancelling RTH if necessary.",
    "0x20020608": "Aircraft is returning to the Home Point. RTH Altitude is %1$dm. You can reset the RTH Altitude in Remote Controller Settings after cancelling RTH if necessary.",
    "0x20020609": "Aircraft signal lost. RTH started",
    "0x2002060A": "You are in a No-Fly Zone. Auto landing initiated.",
    "0x2002060B": "Aircraft is close to the Home Point. Initiating Return to Home will now trigger Auto Landing.",
    "0x2002060C": "Aircraft is too far from the Home Point. Initiating Return to Home will now trigger Auto Landing.",
    "0x2002060D": "Landing",
    "0x2002060E": "Force Landing request from APP.",
    "0x20020610": "Obstacle detected. Aircraft is landing",
    "0x20020611": "IMU error. Aircraft is returning home.",
    "0x20020612": "Aircraft is returning to the Home Point.",
    "0x2002061F": "Unofficial battery detected. Aircraft is landing.",
    "0x20020700": "Flight mode configuration: A/P/S. Current flight mode: %1$s.",
    "0x20020700_rc511": "Flight mode configuration: A/N/S. Current flight mode: %1$s.",
    "0x20020800": "Remote controller %1$s requesting aircraft flight control",
    "0x20020900": "Mission interrupted. Fly aircraft manually",
    "0x20020A00": "ATTI mode",
    "0x20020C00": "FlyTo location synced to current controller",
    "0x20020C01": "Severe flight controller error. Control aircraft manually and land promptly",
    "0x20020D00": "Rising landing gear. Obstacle avoidance unavailable",
    "0x20020D01": "Lowering landing gear. Obstacle avoidance unavailable",
    "0x20020E01": "Home Point update stopped. Remote controller disconnected. Pay attention to current Home Point location",
    "0x20020E02": "Remote controller connected again. Updating Home Point...",
    "0x20020b00": "Taking off",
    "0x20020b01": "Takeoff canceled",
    "0x20021000": "Control sticks not centered. Unable to take off. Ensure control sticks are centered",
    "0x20021001": "RTH canceled",
    "0x20021002": "Landing canceled",
    "0x20021100": "Current aircraft does not meet C1 certification requirements. Ensure compliant flight",
    "0x20022001": "QuickSpin started",
    "0x20022002": "No GNSS signal. Flight area unknown. Flight altitude limited to %1$s",
    "0x20022003": "No GNSS signal. Flight area unknown, and ambient light too low. Flight altitude limited to %1$s",
    "0x20030000": "Manned aircraft detected nearby. Fly with caution",
    "0x20040000": "Flight speed too fast. Interval shooting may fail",
    "0x20040100": "Manual exposure is enabled. Metering is disabled.",
    "0x20040200": "Object too close to laser rangefinder",
    "0x20040201": "Object too far for laser rangefinder",
    "0x20040300": "Capturing one-tap pano with visible light camera",
    "0x20040400": "Zenmuse XT S not compatible with other infrared cameras",
    "0x20040500": "Camera %component_index overheated. Shooting photos/videos may fail",
    "0x20040501": "Camera %component_index overheated. Wait for temperature to return to normal before use",
    "0x20040600": "SD card speed is slow, cannot record 4K video.",
    "0x20040700": "Live stream video frame rate less than 9Hz. Fly with caution.",
    "0x20040800": "Aircraft RTH or landing. Unable to enter Pano mode",
    "0x20040801": "Panorama taken successfully. View in Playback",
    "0x20040802": "Taking panorama failed",
    "0x20040803": "Panorama stopped",
    "0x20040804": "Aircraft not in flight. Unable to take panorama",
    "0x20040805": "Getting control failed. Panorama stopped",
    "0x20040806": "Unknown camera error. Unable to start panorama",
    "0x20040807": "Camera response timed out. Panorama stopped",
    "0x20040808": "Insufficient storage. Panorama stopped",
    "0x20040809": "Aircraft moving. Unable to take panorama",
    "0x2004080A": "Gimbal moving. Unable to take panorama",
    "0x2004080B": "Control stick moved. Panorama stopped",
    "0x2004080C": "Max altitude limit reached. Panorama stopped",
    "0x2004080D": "Max distance reached. Panorama stopped",
    "0x2004080E": "Gimbal stuck. Panorama stopped",
    "0x2004080F": "Taking photo failed. Panorama stopped",
    "0x20040810": "Stitching panorama failed",
    "0x20040811": "Loading calibration parameters failed. Panorama stopped",
    "0x20040812": "Adjusting camera parameters failed. Panorama stopped",
    "0x20040813": "Stitching panorama...",
    "0x20040900": "Playback for Primary remote controller in progress. Disconnected from Liveview for Secondary remote controller",
    "0x20040A00": "Camera busy, cannot enter playback.",
    "0x20040A01": "No memory card",
    "0x20040B00": "Install LiDAR on Gimbal I for optimal use",
    "0x20040C00": "Using Controller B. Unable to support LiDAR. Switch to Controller A",
    "0x20040D00": "Calibration failed. Check and try again",
    "0x20040D01": "Calibration failed. Contact DJI Support",
    "0x20040E00": "%1$s camera lens not calibrated. Focusing will be affected. Go to Settings > Calibrate Lens to calibrate.",
    "0x20040F00": "Collecting point cloud data. Real-time data transfer unstable",
    "0x20041000": "Payload IMU warmed up",
    "0x20041100": "Point cloud model recording in progress. Unable to record video",
    "0x20041200": "Calibration Flight complete. Proceed ahead",
    "0x20041300": "Calibration Flight stopped manually. Check and try again",
    "0x20041400": "Communication error between aircraft and payload",
    "0x20041500": "IR Zoom Max",
    "0x20041600": "Switched successfully. A wider temperature measurement range available",
    "0x20041601": "Switched successfully. A more precise temperature measurement available",
    "0x20041602": "Switched successfully. High-Res mode provides clearer infrared image. Temperature measurement not supported",
    "0x20041700": "Light sensor blocked. Multispectral data collection affected",
    "0x20041801": "Incompatible camera parameters. Restart app and go to home screen to update",
    "0x20050100": "Nearby GEO Zone has temporary restrictions preparing to take effect in 1 hour",
    "0x20050200": "Nearby GEO Zone has temporary restrictions preparing to take effect (%1$d)",
    "0x20050300": "Aircraft will automatically descend in %1$s",
    "0x20050400": "Aircraft leaving unlocked GEO zone. Fly with caution",
    "0x20050401": "Aircraft at the boundary of a GEO Zone. RTH may be stopped. Fly away promptly",
    "0x20050402": "Aircraft at boundary of an Altitude Zone (%1$s ). Fly away or descend as soon as possible",
    "0x20050403": "Aircraft entered Altitude Zone (%1$s). Fly with caution",
    "0x20050404": "Aircraft at the boundary of a Restricted Zone. Fly away promptly",
    "0x20050405": "GEO: You are in a Warning Zone (%1$s). Fly with caution.",
    "0x20050406": "Your aircraft is flying in an Altitude Zone (%1$s). Please fly with caution.",
    "0x20050407": "Aircraft in GEO Zone. Max flight altitude: %1$s",
    "0x20050408": "Aircraft flying in an Altitude Zone (%s). Fly with caution",
    "0x20050500": "Reaching maximum altitude...",
    "0x20050600": "Multiple Enhanced Warning Zones near aircraft. Fly with caution",
    "0x20050601": "Multiple Enhanced Warning Zones below aircraft. Fly with caution",
    "0x20050602": "Multiple Enhanced Warning Zones above aircraft. Fly with caution",
    "0x20050603": "Enhanced Warning Zone nearby (%s. Altitude range: %s m. Effective time: %s). Fly with caution",
    "0x20050604": "Enhanced Warning Zone below (%s. Altitude range: %s m. Effective time: %s). Fly with caution",
    "0x20050605": "Enhanced Warning Zone above (%s. Altitude range: %s m. Effective time: %s). Fly with caution",
    "0x20050606": "Aircraft in Enhanced Warning Zone (%s. Altitude range: %s. Effective time: %s). Fly with caution",
    "0x20050607": "Multiple Enhanced Warning Zones nearby. Fly with caution",
    "0x20050608": "GNSS signal weak. Geo-awareness function degraded. Fly with caution",
    "0x20060100": "GNSS coordinates copied %s",
    "0x20060200": "RNG info copied. %s",
    "0x20070100": "Aircraft propulsion system error. Forced landing. Manually control the aircraft and land in an open area",
    "0x20070101": "Aircraft propulsion system error. Unable to take off",
    "0x20080100": "Switched to OcuSync image transmission",
    "0x20080101": "Switched to LTE Dual Link",
    "0x20080200": "In dual control mode or current RC set as controller B. LTE Dual Link unavailable",
    "0x20080300": "LTE network unstable. Fly with caution",
    "0x20080400": "Image transmission signal weak. Adjust antennas and fly with caution",
    "0x20080500": "Remote Controller Signal Weak",
    "0x20080600": "Strong remote controller signal interference. Move away from other remote controllers or the source of interference",
    "0x20080700": "Strong aircraft signal interference. Return to home promptly or move away from the source of interference",
    "0x20090000": "Vision stabilization paused.",
    "0x20090001": "Vision stabilization resumed.",
    "0x20090002": "Vision stabilization paused.Reason: Features too few in current video.",
    "0x20090003": "Vision stabilization resumed.Reason: Features too few in current video.",
    "0x20090004": "Vision stabilization paused.Reason: Features too few in current video.Reason: Features too few in current video.",
    "0x20090100": "Pin Point Success",
    "0x20090101": "Unable to get laser rangefinder data. Recording location failed",
    "0x20090102": "Insufficient satellites available. Recording location failed",
    "0x20090103": "Aircraft location pinned successfully",
    "0x20090200": "Starting Smart Track",
    "0x20090201": "Smart Track Turn Off",
    "0x20090202": "Unable to identify target. Drag-select target on screen",
    "0x200A0000": "Disable Wi-Fi before enabling Relay mode to avoid signal interference",
    "0x20100000": "D-RTK Low Battery",
    "0x20100100": "RTK status error. Entering Maintain Positioning Accuracy mode. Aircraft will exit RTK if reconnection timed out",
    "0x20100200": "RTK base station not found. Check base station and search again",
    "0x2010D000": "D-RTK  Low Battery",
    "0x20110000": "Battery heating",
    "0x20120000": "Failed to access GNSS positioning information of mobile device",
    "0x20120001": "Failed to access GNSS positioning information of DJI device",
    "0x20120200": "Land aircraft before continuing to next step",
    "0x20120300": "Aircraft flying to editing start point",
    "0x20120301": "Arrived at editing start point. Begin editing",
    "0x20120302": "Exit Flight Route Editing",
    "0x20120400": "Phone not bound. Altitude and distance limited. Bind phone before taking off.",
    "0x20120500": "Media files will be uploaded through current remote controller",
    "0x20120501": "Media files will be uploaded through another remote controller",
    "0x20120502": "Aircraft cloud control enabled",
    "0x20120503": "Aircraft bound to other team. Cloud service unavailable",
    "0x20120600": "Removed from project. Unable to view project details",
    "0x20120700": "Project archived. Unable to view project details",
    "0x20120800": "Project team disbanded. Unable to view project details",
    "0x20120900": "Real-time mapping stopped",
    "0x20120A00": "Livestream started",
    "0x20120B00": "Flight route mission paused manually",
    "0x20120B01": "RTK signal weak. Flight route mission paused",
    "0x20120B02": "Max flight altitude reached. Flight route mission paused",
    "0x20120B03": "Max flight distance reached. Flight route mission paused",
    "0x20120B04": "Task paused. Obstacle detected",
    "0x20120B05": "Approaching GEO Zone. Task paused",
    "0x20120B06": "Min flight altitude reached. Task paused",
    "0x20120B07": "Unknown error. Task paused",
    "0x20120B08": "Max flight altitude of airport Altitude Zone reached",
    "0x20120B09": "Emergency brake triggered. Flight task paused",
    "0x20120B0A": "Ambient light too low or fog detected",
    "0x20120B0B": "GNSS signal weak. Task paused",
    "0x20120B0C": "Home Point not updated. Flight task paused",
    "0x20120B0D": "Remote controller disconnected. Smart RTH in progress",
    "0x20120B0E": "Auto takeoff failed. Try uploading flight route again",
    "0x20120B0F": "Approaching boundary of custom flight area. Flight task paused",
    "0x20120B10": "Terrain Follow altitude error (greater than 200 m or less than 30 m). Modify parameter",
    "0x20120B11": "Wind speed too high. Flight task paused",
    "0x20120B12": "Aircraft at the boundary of an Altitude Zone or aircraft altitude too low. Flight task paused",
    "0x20120B13": "PSDK on blocklist. Remove device before takeoff",
    "0x20120B14": "Unable to reach FlyTo destination. Task paused. FlyTo destination inside Restricted Zone or obstacle area",
    "0x20120B15": "Task paused. Failed to plan flight route",
    "0x20120B16": "Compass error. Fly aircraft forward 20 m and then fly backward 20 m to calibrate compass",
    "0x20120BA0": "Aircraft verification in progress...",
    "0x20120C00": "Disable Vision Positioning",
    "0x20120C01": "Enable Vision Positioning",
    "0x20120C02": "Cloud control from DJI DeliveryHub enabled",
    "0x20120C03": "Pausing flight through cloud control",
    "0x20120C04": "Aircraft landing through cloud control",
    "0x20120C05": "Aircraft returning to home through cloud control",
    "0x20120C06": "Operating winch system through cloud control",
    "0x20120C07": "Operating FPV gimbal camera through cloud control",
    "0x20120C08": "Performing flight task through cloud control",
    "0x20120C09": "Cloud control from DJI DeliveryHub disabled",
    "0x20120C0A": "RTH canceled by cloud control",
    "0x20120C0B": "Aircraft locked",
    "0x20120C0C": "Aircraft unlocked",
    "0x20120D01": "Obstacle sensing of all directions disabled. Fly with caution",
    "0x20120D02": "Horizontal obstacle sensing disabled. Fly with caution",
    "0x20120D03": "Upward obstacle sensing disabled. Fly with caution",
    "0x20120D04": "Downward obstacle sensing disabled. Fly with caution",
    "0x20120D05": "Obstacle sensing of all directions enabled",
    "0x20120D06": "Horizontal obstacle sensing enabled",
    "0x20120D07": "Upward obstacle sensing enabled",
    "0x20120D08": "Downward obstacle sensing enabled",
    "0x20120E00": "High ionospheric activity in current area. Positioning accuracy may be affected",
    "0x20120E01": "Aircraft and remote controller firmware versions do not match. Update firmware to latest version",
    "0x20120F00": "Account not logged in. Flight altitude and distance restricted to 30 m and 50 m respectively. Login required"
}